/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as ARouteRouteImport } from './routes/a/route';
import { Route as AdminRouteRouteImport } from './routes/admin/route';
import { Route as AuthRouteRouteImport } from './routes/auth/route';
import { Route as AClienteRouteRouteImport } from './routes/a/cliente/route';
import { Route as ACobrancaBoletoRouteRouteImport } from './routes/a/cobranca-boleto/route';
import { Route as ACobrancaCartaoRouteRouteImport } from './routes/a/cobranca-cartao/route';
import { Route as ACobrancaPixRouteRouteImport } from './routes/a/cobranca-pix/route';
import { Route as AComissaoRouteRouteImport } from './routes/a/comissao/route';
import { Route as ACompraRouteRouteImport } from './routes/a/compra/route';
import { Route as AContasPagarRouteRouteImport } from './routes/a/contas-pagar/route';
import { Route as AContasReceberRouteRouteImport } from './routes/a/contas-receber/route';
import { Route as ACupomFiscalRouteRouteImport } from './routes/a/cupom-fiscal/route';
import { Route as ADebugRouteRouteImport } from './routes/a/debug/route';
import { Route as ADevolucaoRouteRouteImport } from './routes/a/devolucao/route';
import { Route as AEstoqueRouteRouteImport } from './routes/a/estoque/route';
import { Route as AExtratoBoletoRouteRouteImport } from './routes/a/extrato-boleto/route';
import { Route as AExtratoPixRouteRouteImport } from './routes/a/extrato-pix/route';
import { Route as AFornecedorRouteRouteImport } from './routes/a/fornecedor/route';
import { Route as AManifestoCargaRouteRouteImport } from './routes/a/manifesto-carga/route';
import { Route as AMovimentacoesRouteRouteImport } from './routes/a/movimentacoes/route';
import { Route as ANfseRouteRouteImport } from './routes/a/nfse/route';
import { Route as ANotaFiscalRouteRouteImport } from './routes/a/nota-fiscal/route';
import { Route as ANotificacaoRouteRouteImport } from './routes/a/notificacao/route';
import { Route as APagforRouteRouteImport } from './routes/a/pagfor/route';
import { Route as APdvRouteImport } from './routes/a/pdv';
import { Route as AProdutoRouteRouteImport } from './routes/a/produto/route';
import { Route as ARegraFiscalRouteRouteImport } from './routes/a/regra-fiscal/route';
import { Route as ARomaneioRouteRouteImport } from './routes/a/romaneio/route';
import { Route as ASecundarioRouteRouteImport } from './routes/a/secundario/route';
import { Route as AServicoRouteRouteImport } from './routes/a/servico/route';
import { Route as ASpedFiscalRouteRouteImport } from './routes/a/sped-fiscal/route';
import { Route as ATransportadorRouteRouteImport } from './routes/a/transportador/route';
import { Route as AVendaRouteRouteImport } from './routes/a/venda/route';
import { Route as AVendaExternaRouteRouteImport } from './routes/a/venda-externa/route';
import { Route as AdminARouteRouteImport } from './routes/admin/_a/route';
import { Route as AdminAuthRouteImport } from './routes/admin/auth';
import { Route as AuthAcessoNegadoRouteImport } from './routes/auth/acesso-negado';
import { Route as AuthCadastroRouteImport } from './routes/auth/cadastro';
import { Route as AuthCadastroFimRouteImport } from './routes/auth/cadastro-fim';
import { Route as AuthContaBloqueadaRouteImport } from './routes/auth/conta-bloqueada';
import { Route as AuthLoginRouteImport } from './routes/auth/login';
import { Route as AuthLoginAdmRouteImport } from './routes/auth/login-adm';
import { Route as AuthLoginAutomaticoRouteImport } from './routes/auth/login-automatico';
import { Route as AuthRecuperarSenhaRouteImport } from './routes/auth/recuperar-senha';
import { Route as AuthRedefinirSenhaRouteImport } from './routes/auth/redefinir-senha';
import { Route as PErroRouteImport } from './routes/p/erro';
import { Route as AClienteIndexRouteImport } from './routes/a/cliente/index';
import { Route as ACobrancaBoletoIndexRouteImport } from './routes/a/cobranca-boleto/index';
import { Route as ACobrancaBoletoRotinasBancariasRouteImport } from './routes/a/cobranca-boleto/rotinas-bancarias';
import { Route as ACobrancaCartaoIndexRouteImport } from './routes/a/cobranca-cartao/index';
import { Route as ACobrancaCartaoCadastrarRouteImport } from './routes/a/cobranca-cartao/cadastrar';
import { Route as ACobrancaPixIndexRouteImport } from './routes/a/cobranca-pix/index';
import { Route as AComissaoIndexRouteImport } from './routes/a/comissao/index';
import { Route as ACompraCompraRouteImport } from './routes/a/compra/compra';
import { Route as ACompraImportacaoNfeRouteImport } from './routes/a/compra/importacao-nfe';
import { Route as ACompraManifestadorRouteImport } from './routes/a/compra/manifestador';
import { Route as AConfiguracaoEmpresaRouteRouteImport } from './routes/a/configuracao/empresa/route';
import { Route as AConfiguracaoUsuarioRouteImport } from './routes/a/configuracao/usuario';
import { Route as AContasPagarIndexRouteImport } from './routes/a/contas-pagar/index';
import { Route as AContasReceberIndexRouteImport } from './routes/a/contas-receber/index';
import { Route as AContratoIndexRouteImport } from './routes/a/contrato/index';
import { Route as ACupomFiscalIndexRouteImport } from './routes/a/cupom-fiscal/index';
import { Route as ADebugIndexRouteImport } from './routes/a/debug/index';
import { Route as ADevolucaoIndexRouteImport } from './routes/a/devolucao/index';
import { Route as AEstoqueConferenciaRouteImport } from './routes/a/estoque/conferencia';
import { Route as AEstoqueMovimentacaoRouteImport } from './routes/a/estoque/movimentacao';
import { Route as AExtratoBoletoIndexRouteImport } from './routes/a/extrato-boleto/index';
import { Route as AExtratoPixIndexRouteImport } from './routes/a/extrato-pix/index';
import { Route as AFornecedorIndexRouteImport } from './routes/a/fornecedor/index';
import { Route as AImpressaoFiletypeRouteImport } from './routes/a/impressao/$filetype';
import { Route as AInventarioIndexRouteImport } from './routes/a/inventario/index';
import { Route as AManifestoCargaIndexRouteImport } from './routes/a/manifesto-carga/index';
import { Route as AMovimentacoesIndexRouteImport } from './routes/a/movimentacoes/index';
import { Route as ANfseIndexRouteImport } from './routes/a/nfse/index';
import { Route as ANotaFiscalIndexRouteImport } from './routes/a/nota-fiscal/index';
import { Route as ANotaFiscalCadastrarRouteImport } from './routes/a/nota-fiscal/cadastrar';
import { Route as ANotificacaoListagemRouteImport } from './routes/a/notificacao/listagem';
import { Route as APagforImportarRouteImport } from './routes/a/pagfor/importar';
import { Route as APagforListagemRouteImport } from './routes/a/pagfor/listagem';
import { Route as APainelGerencialIndexRouteImport } from './routes/a/painel-gerencial/index';
import { Route as APersonalizacoesComandosRouteImport } from './routes/a/personalizacoes/comandos';
import { Route as APersonalizacoesConsultasRouteImport } from './routes/a/personalizacoes/consultas';
import { Route as AProdutoIndexRouteImport } from './routes/a/produto/index';
import { Route as ARegraFiscalIndexRouteImport } from './routes/a/regra-fiscal/index';
import { Route as ARelatorioCadastroRouteRouteImport } from './routes/a/relatorio/cadastro/route';
import { Route as ARelatorioCompraRouteRouteImport } from './routes/a/relatorio/compra/route';
import { Route as ARelatorioEstoqueRouteRouteImport } from './routes/a/relatorio/estoque/route';
import { Route as ARelatorioFinanceiroRouteRouteImport } from './routes/a/relatorio/financeiro/route';
import { Route as ARelatorioFiscalRouteRouteImport } from './routes/a/relatorio/fiscal/route';
import { Route as ARelatorioVendaRouteRouteImport } from './routes/a/relatorio/venda/route';
import { Route as ARenegociacaoContasPagarRouteRouteImport } from './routes/a/renegociacao/contas-pagar/route';
import { Route as ARenegociacaoContasReceberRouteRouteImport } from './routes/a/renegociacao/contas-receber/route';
import { Route as ARomaneioIndexRouteImport } from './routes/a/romaneio/index';
import { Route as ASecundarioIndexRouteImport } from './routes/a/secundario/index';
import { Route as ASeparacaoIndexRouteImport } from './routes/a/separacao/index';
import { Route as ASeparacaoMonitorRouteImport } from './routes/a/separacao/monitor';
import { Route as AServicoIndexRouteImport } from './routes/a/servico/index';
import { Route as ASpedFiscalIndexRouteImport } from './routes/a/sped-fiscal/index';
import { Route as ASuporteIndexRouteImport } from './routes/a/suporte/index';
import { Route as ASuporteInstrucoesDeUsoRouteImport } from './routes/a/suporte/instrucoes-de-uso';
import { Route as ATransportadorIndexRouteImport } from './routes/a/transportador/index';
import { Route as AVendaExternaIndexRouteImport } from './routes/a/venda-externa/index';
import { Route as AdminAEmpresaRouteImport } from './routes/admin/_a/empresa';
import { Route as AdminAErroRouteImport } from './routes/admin/_a/erro';
import { Route as AdminARepresentanteRouteImport } from './routes/admin/_a/representante';
import { Route as AdminASqlRouteImport } from './routes/admin/_a/sql';
import { Route as AdminASqlEditorRouteImport } from './routes/admin/_a/sql-editor';
import { Route as AdminAuthLoginRouteImport } from './routes/admin/auth/login';
import { Route as PCatalogoSlugRouteRouteImport } from './routes/p/catalogo.$slug/route';
import { Route as PClienteSlugRouteImport } from './routes/p/cliente/$slug';
import { Route as PCompartilhamentoIdRouteImport } from './routes/p/compartilhamento.$id';
import { Route as PContratoIdRouteImport } from './routes/p/contrato.$id';
import { Route as PImpressaoFiletypeRouteImport } from './routes/p/impressao.$filetype';
import { Route as AClienteActionChar123IdpkChar125RouteImport } from './routes/a/cliente/$action.{-$idpk}';
import { Route as ACobrancaBoletoActionChar123IdpkChar125RouteImport } from './routes/a/cobranca-boleto/$action.{-$idpk}';
import { Route as ACompraActionChar123IdpkChar125RouteImport } from './routes/a/compra/$action.{-$idpk}';
import { Route as ACompraClonarIdpkRouteImport } from './routes/a/compra/clonar.$idpk';
import { Route as AConfiguracaoEmpresaIndexRouteImport } from './routes/a/configuracao/empresa/index';
import { Route as AContasPagarActionChar123IdpkChar125RouteImport } from './routes/a/contas-pagar/$action.{-$idpk}';
import { Route as AContasReceberActionChar123IdpkChar125RouteImport } from './routes/a/contas-receber/$action.{-$idpk}';
import { Route as AContratoActionChar123IdpkChar125RouteImport } from './routes/a/contrato/$action.{-$idpk}';
import { Route as ADevolucaoActionChar123IdpkChar125RouteImport } from './routes/a/devolucao/$action.{-$idpk}';
import { Route as AImportacaoTipoChar123IdpkChar125RouteImport } from './routes/a/importacao/$tipo.{-$idpk}';
import { Route as AImportacaoXmlTipoRouteImport } from './routes/a/importacao/xml.$tipo';
import { Route as AInventarioActionChar123IdpkChar125RouteImport } from './routes/a/inventario/$action.{-$idpk}';
import { Route as AManifestoCargaActionChar123IdpkChar125RouteImport } from './routes/a/manifesto-carga/$action.{-$idpk}';
import { Route as AMovimentacoesActionChar123IdpkChar125RouteImport } from './routes/a/movimentacoes/$action.{-$idpk}';
import { Route as AMovimentacoesExtratoIdpkRouteImport } from './routes/a/movimentacoes/extrato.$idpk';
import { Route as ANfseActionChar123IdpkChar125RouteImport } from './routes/a/nfse/$action.{-$idpk}';
import { Route as ANotaFiscalActionChar123IdpkChar125RouteImport } from './routes/a/nota-fiscal/$action.{-$idpk}';
import { Route as APagforActionChar123IdpkChar125RouteImport } from './routes/a/pagfor/$action.{-$idpk}';
import { Route as AProdutoActionChar123IdpkChar125RouteImport } from './routes/a/produto/$action.{-$idpk}';
import { Route as ARegraFiscalActionChar123IdpkChar125RouteImport } from './routes/a/regra-fiscal/$action.{-$idpk}';
import { Route as ARelatorioCadastroIndexRouteImport } from './routes/a/relatorio/cadastro/index';
import { Route as ARelatorioCadastroCatalogoProdutosRouteImport } from './routes/a/relatorio/cadastro/catalogo-produtos';
import { Route as ARelatorioCadastroControleLotesRouteImport } from './routes/a/relatorio/cadastro/controle-lotes';
import { Route as ARelatorioCadastroHistoricoAlteracoesPrecoRouteImport } from './routes/a/relatorio/cadastro/historico-alteracoes-preco';
import { Route as ARelatorioCadastroRelacaoClientesRouteImport } from './routes/a/relatorio/cadastro/relacao-clientes';
import { Route as ARelatorioCadastroRelacaoClientesAniversariantesRouteImport } from './routes/a/relatorio/cadastro/relacao-clientes-aniversariantes';
import { Route as ARelatorioCadastroRelacaoFornecedoresRouteImport } from './routes/a/relatorio/cadastro/relacao-fornecedores';
import { Route as ARelatorioCadastroRelacaoProdutosRouteImport } from './routes/a/relatorio/cadastro/relacao-produtos';
import { Route as ARelatorioCadastroRelacaoTransportadoresRouteImport } from './routes/a/relatorio/cadastro/relacao-transportadores';
import { Route as ARelatorioCompraIndexRouteImport } from './routes/a/relatorio/compra/index';
import { Route as ARelatorioCompraComprasPorFornecedorRouteImport } from './routes/a/relatorio/compra/compras-por-fornecedor';
import { Route as ARelatorioEstoqueIndexRouteImport } from './routes/a/relatorio/estoque/index';
import { Route as ARelatorioEstoqueEstoqueMinimoRouteImport } from './routes/a/relatorio/estoque/estoque-minimo';
import { Route as ARelatorioEstoqueSaldosEmEstoqueRouteImport } from './routes/a/relatorio/estoque/saldos-em-estoque';
import { Route as ARelatorioFinanceiroIndexRouteImport } from './routes/a/relatorio/financeiro/index';
import { Route as ARelatorioFinanceiroBalanceteRouteImport } from './routes/a/relatorio/financeiro/balancete';
import { Route as ARelatorioFinanceiroBoletosRecebidosRouteImport } from './routes/a/relatorio/financeiro/boletos-recebidos';
import { Route as ARelatorioFinanceiroContasPagarRouteImport } from './routes/a/relatorio/financeiro/contas-pagar';
import { Route as ARelatorioFinanceiroContasReceberRouteImport } from './routes/a/relatorio/financeiro/contas-receber';
import { Route as ARelatorioFinanceiroContasRecebidasRouteImport } from './routes/a/relatorio/financeiro/contas-recebidas';
import { Route as ARelatorioFinanceiroDreRouteImport } from './routes/a/relatorio/financeiro/dre';
import { Route as ARelatorioFinanceiroEntradasSaidasRouteImport } from './routes/a/relatorio/financeiro/entradas-saidas';
import { Route as ARelatorioFinanceiroFluxoCaixaRouteImport } from './routes/a/relatorio/financeiro/fluxo-caixa';
import { Route as ARelatorioFinanceiroLancamentosContasReceberRouteImport } from './routes/a/relatorio/financeiro/lancamentos-contas-receber';
import { Route as ARelatorioFinanceiroPagamentosRouteImport } from './routes/a/relatorio/financeiro/pagamentos';
import { Route as ARelatorioFinanceiroRelacaoBoletosRouteImport } from './routes/a/relatorio/financeiro/relacao-boletos';
import { Route as ARelatorioFinanceiroTotaisPorCategoriaRouteImport } from './routes/a/relatorio/financeiro/totais-por-categoria';
import { Route as ARelatorioFiscalIndexRouteImport } from './routes/a/relatorio/fiscal/index';
import { Route as ARelatorioFiscalItensNotasFiscaisRouteImport } from './routes/a/relatorio/fiscal/itens-notas-fiscais';
import { Route as ARelatorioFiscalNotasFiscaisClienteRouteImport } from './routes/a/relatorio/fiscal/notas-fiscais-cliente';
import { Route as ARelatorioFiscalNotasFiscaisProdutoRouteImport } from './routes/a/relatorio/fiscal/notas-fiscais-produto';
import { Route as ARelatorioFiscalNotasFiscaisTipoRouteImport } from './routes/a/relatorio/fiscal/notas-fiscais-tipo';
import { Route as ARelatorioFiscalRelacaoDocumentosRouteImport } from './routes/a/relatorio/fiscal/relacao-documentos';
import { Route as ARelatorioFiscalRelacaoSequenciasInutilizadasRouteImport } from './routes/a/relatorio/fiscal/relacao-sequencias-inutilizadas';
import { Route as ARelatorioFiscalTotalAgrupadoCfopRouteImport } from './routes/a/relatorio/fiscal/total-agrupado-cfop';
import { Route as ARelatorioFiscalTotalAgrupadoFormaPagamentoRouteImport } from './routes/a/relatorio/fiscal/total-agrupado-forma-pagamento';
import { Route as ARelatorioFiscalTotalAgrupadoNcmRouteImport } from './routes/a/relatorio/fiscal/total-agrupado-ncm';
import { Route as ARelatorioVendaIndexRouteImport } from './routes/a/relatorio/venda/index';
import { Route as ARelatorioVendaComissoesRouteImport } from './routes/a/relatorio/venda/comissoes';
import { Route as ARelatorioVendaProdutosMaisVendidosRouteImport } from './routes/a/relatorio/venda/produtos-mais-vendidos';
import { Route as ARelatorioVendaRelacaoVendasRouteImport } from './routes/a/relatorio/venda/relacao-vendas';
import { Route as ARelatorioVendaRelacaoVendasProdutoRouteImport } from './routes/a/relatorio/venda/relacao-vendas-produto';
import { Route as ARelatorioVendaRelacaoVendasResumidoRouteImport } from './routes/a/relatorio/venda/relacao-vendas-resumido';
import { Route as ARelatorioVendaTotalFormaPagamentoRouteImport } from './routes/a/relatorio/venda/total-forma-pagamento';
import { Route as ARelatorioVendaVendasClienteRouteImport } from './routes/a/relatorio/venda/vendas-cliente';
import { Route as ARelatorioVendaVendasVendedorRouteImport } from './routes/a/relatorio/venda/vendas-vendedor';
import { Route as ARenegociacaoContasPagarIndexRouteImport } from './routes/a/renegociacao/contas-pagar/index';
import { Route as ARenegociacaoContasPagarCadastrarRouteImport } from './routes/a/renegociacao/contas-pagar/cadastrar';
import { Route as ARenegociacaoContasReceberIndexRouteImport } from './routes/a/renegociacao/contas-receber/index';
import { Route as ARenegociacaoContasReceberCadastrarRouteImport } from './routes/a/renegociacao/contas-receber/cadastrar';
import { Route as ARomaneioActionChar123IdpkChar125RouteImport } from './routes/a/romaneio/$action.{-$idpk}';
import { Route as ASeparacaoTypeIdpkRouteImport } from './routes/a/separacao/$type.$idpk';
import { Route as AServicoActionChar123IdpkChar125RouteImport } from './routes/a/servico/$action.{-$idpk}';
import { Route as ASpedFiscalActionChar123IdpkChar125RouteImport } from './routes/a/sped-fiscal/$action.{-$idpk}';
import { Route as ATransportadorActionChar123IdpkChar125RouteImport } from './routes/a/transportador/$action.{-$idpk}';
import { Route as AVendaExternaActionChar123IdpkChar125RouteImport } from './routes/a/venda-externa/$action.{-$idpk}';
import { Route as AVendaActionIdpkRouteImport } from './routes/a/venda/$action.$idpk';
import { Route as AVendaTipoIndexRouteImport } from './routes/a/venda/$tipo.index';
import { Route as AVendaCadastrarTipoRouteImport } from './routes/a/venda/cadastrar.$tipo';
import { Route as AdminAConfiguracaoRepresentanteRouteImport } from './routes/admin/_a/configuracao.representante';
import { Route as PCatalogoSlugIndexRouteImport } from './routes/p/catalogo.$slug/index';
import { Route as PCatalogoSlugDefaultRouteRouteImport } from './routes/p/catalogo.$slug/_default/route';
import { Route as PCatalogoSlugAuthRouteRouteImport } from './routes/p/catalogo.$slug/auth/route';
import { Route as PContaDigitalTermosDeUsoBase64RouteImport } from './routes/p/conta-digital/termos-de-uso.$base64';
import { Route as PPagamentoIdIndexRouteImport } from './routes/p/pagamento.$id/index';
import { Route as ARomaneioImpressaoCargaIdpkRouteImport } from './routes/a/romaneio/impressao/carga.$idpk';
import { Route as ARomaneioImpressaoEntregaIdpkRouteImport } from './routes/a/romaneio/impressao/entrega.$idpk';
import { Route as ARomaneioImpressaoPadraoIdpkRouteImport } from './routes/a/romaneio/impressao/padrao.$idpk';
import { Route as AVendaClonarTipoIdpkRouteImport } from './routes/a/venda/clonar.$tipo.$idpk';
import { Route as AdminAEmpresaActionChar123IdpkChar125RouteImport } from './routes/admin/_a/empresa_.$action.{-$idpk}';
import { Route as PCatalogoSlugDefaultFinalizarRouteImport } from './routes/p/catalogo.$slug/_default/finalizar';
import { Route as PCatalogoSlugDefaultProdutosRouteImport } from './routes/p/catalogo.$slug/_default/produtos';
import { Route as PCatalogoSlugDefaultUsuarioRouteRouteImport } from './routes/p/catalogo.$slug/_default/usuario/route';
import { Route as PCatalogoSlugAuthCadastrarRouteImport } from './routes/p/catalogo.$slug/auth/cadastrar';
import { Route as PCatalogoSlugAuthEntrarRouteImport } from './routes/p/catalogo.$slug/auth/entrar';
import { Route as PCatalogoSlugAuthRecuperarSenhaRouteImport } from './routes/p/catalogo.$slug/auth/recuperar-senha';
import { Route as PCatalogoSlugAuthValidarCodigoRouteImport } from './routes/p/catalogo.$slug/auth/validar-codigo';
import { Route as PCatalogoSlugDefaultUsuarioPerfilRouteImport } from './routes/p/catalogo.$slug/_default/usuario/perfil';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const ARouteRoute = ARouteRouteImport.update({
  id: '/a',
  path: '/a',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any);
const AClienteRouteRoute = AClienteRouteRouteImport.update({
  id: '/cliente',
  path: '/cliente',
  getParentRoute: () => ARouteRoute,
} as any);
const ACobrancaBoletoRouteRoute = ACobrancaBoletoRouteRouteImport.update({
  id: '/cobranca-boleto',
  path: '/cobranca-boleto',
  getParentRoute: () => ARouteRoute,
} as any);
const ACobrancaCartaoRouteRoute = ACobrancaCartaoRouteRouteImport.update({
  id: '/cobranca-cartao',
  path: '/cobranca-cartao',
  getParentRoute: () => ARouteRoute,
} as any);
const ACobrancaPixRouteRoute = ACobrancaPixRouteRouteImport.update({
  id: '/cobranca-pix',
  path: '/cobranca-pix',
  getParentRoute: () => ARouteRoute,
} as any);
const AComissaoRouteRoute = AComissaoRouteRouteImport.update({
  id: '/comissao',
  path: '/comissao',
  getParentRoute: () => ARouteRoute,
} as any);
const ACompraRouteRoute = ACompraRouteRouteImport.update({
  id: '/compra',
  path: '/compra',
  getParentRoute: () => ARouteRoute,
} as any);
const AContasPagarRouteRoute = AContasPagarRouteRouteImport.update({
  id: '/contas-pagar',
  path: '/contas-pagar',
  getParentRoute: () => ARouteRoute,
} as any);
const AContasReceberRouteRoute = AContasReceberRouteRouteImport.update({
  id: '/contas-receber',
  path: '/contas-receber',
  getParentRoute: () => ARouteRoute,
} as any);
const ACupomFiscalRouteRoute = ACupomFiscalRouteRouteImport.update({
  id: '/cupom-fiscal',
  path: '/cupom-fiscal',
  getParentRoute: () => ARouteRoute,
} as any);
const ADebugRouteRoute = ADebugRouteRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => ARouteRoute,
} as any);
const ADevolucaoRouteRoute = ADevolucaoRouteRouteImport.update({
  id: '/devolucao',
  path: '/devolucao',
  getParentRoute: () => ARouteRoute,
} as any);
const AEstoqueRouteRoute = AEstoqueRouteRouteImport.update({
  id: '/estoque',
  path: '/estoque',
  getParentRoute: () => ARouteRoute,
} as any);
const AExtratoBoletoRouteRoute = AExtratoBoletoRouteRouteImport.update({
  id: '/extrato-boleto',
  path: '/extrato-boleto',
  getParentRoute: () => ARouteRoute,
} as any);
const AExtratoPixRouteRoute = AExtratoPixRouteRouteImport.update({
  id: '/extrato-pix',
  path: '/extrato-pix',
  getParentRoute: () => ARouteRoute,
} as any);
const AFornecedorRouteRoute = AFornecedorRouteRouteImport.update({
  id: '/fornecedor',
  path: '/fornecedor',
  getParentRoute: () => ARouteRoute,
} as any);
const AManifestoCargaRouteRoute = AManifestoCargaRouteRouteImport.update({
  id: '/manifesto-carga',
  path: '/manifesto-carga',
  getParentRoute: () => ARouteRoute,
} as any);
const AMovimentacoesRouteRoute = AMovimentacoesRouteRouteImport.update({
  id: '/movimentacoes',
  path: '/movimentacoes',
  getParentRoute: () => ARouteRoute,
} as any);
const ANfseRouteRoute = ANfseRouteRouteImport.update({
  id: '/nfse',
  path: '/nfse',
  getParentRoute: () => ARouteRoute,
} as any);
const ANotaFiscalRouteRoute = ANotaFiscalRouteRouteImport.update({
  id: '/nota-fiscal',
  path: '/nota-fiscal',
  getParentRoute: () => ARouteRoute,
} as any);
const ANotificacaoRouteRoute = ANotificacaoRouteRouteImport.update({
  id: '/notificacao',
  path: '/notificacao',
  getParentRoute: () => ARouteRoute,
} as any);
const APagforRouteRoute = APagforRouteRouteImport.update({
  id: '/pagfor',
  path: '/pagfor',
  getParentRoute: () => ARouteRoute,
} as any);
const APdvRoute = APdvRouteImport.update({
  id: '/pdv',
  path: '/pdv',
  getParentRoute: () => ARouteRoute,
} as any);
const AProdutoRouteRoute = AProdutoRouteRouteImport.update({
  id: '/produto',
  path: '/produto',
  getParentRoute: () => ARouteRoute,
} as any);
const ARegraFiscalRouteRoute = ARegraFiscalRouteRouteImport.update({
  id: '/regra-fiscal',
  path: '/regra-fiscal',
  getParentRoute: () => ARouteRoute,
} as any);
const ARomaneioRouteRoute = ARomaneioRouteRouteImport.update({
  id: '/romaneio',
  path: '/romaneio',
  getParentRoute: () => ARouteRoute,
} as any);
const ASecundarioRouteRoute = ASecundarioRouteRouteImport.update({
  id: '/secundario',
  path: '/secundario',
  getParentRoute: () => ARouteRoute,
} as any);
const AServicoRouteRoute = AServicoRouteRouteImport.update({
  id: '/servico',
  path: '/servico',
  getParentRoute: () => ARouteRoute,
} as any);
const ASpedFiscalRouteRoute = ASpedFiscalRouteRouteImport.update({
  id: '/sped-fiscal',
  path: '/sped-fiscal',
  getParentRoute: () => ARouteRoute,
} as any);
const ATransportadorRouteRoute = ATransportadorRouteRouteImport.update({
  id: '/transportador',
  path: '/transportador',
  getParentRoute: () => ARouteRoute,
} as any);
const AVendaRouteRoute = AVendaRouteRouteImport.update({
  id: '/venda',
  path: '/venda',
  getParentRoute: () => ARouteRoute,
} as any);
const AVendaExternaRouteRoute = AVendaExternaRouteRouteImport.update({
  id: '/venda-externa',
  path: '/venda-externa',
  getParentRoute: () => ARouteRoute,
} as any);
const AdminARouteRoute = AdminARouteRouteImport.update({
  id: '/_a',
  getParentRoute: () => AdminRouteRoute,
} as any);
const AdminAuthRoute = AdminAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => AdminRouteRoute,
} as any);
const AuthAcessoNegadoRoute = AuthAcessoNegadoRouteImport.update({
  id: '/acesso-negado',
  path: '/acesso-negado',
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthCadastroRoute = AuthCadastroRouteImport.update({
  id: '/cadastro',
  path: '/cadastro',
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthCadastroFimRoute = AuthCadastroFimRouteImport.update({
  id: '/cadastro-fim',
  path: '/cadastro-fim',
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthContaBloqueadaRoute = AuthContaBloqueadaRouteImport.update({
  id: '/conta-bloqueada',
  path: '/conta-bloqueada',
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthLoginAdmRoute = AuthLoginAdmRouteImport.update({
  id: '/login-adm',
  path: '/login-adm',
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthLoginAutomaticoRoute = AuthLoginAutomaticoRouteImport.update({
  id: '/login-automatico',
  path: '/login-automatico',
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthRecuperarSenhaRoute = AuthRecuperarSenhaRouteImport.update({
  id: '/recuperar-senha',
  path: '/recuperar-senha',
  getParentRoute: () => AuthRouteRoute,
} as any);
const AuthRedefinirSenhaRoute = AuthRedefinirSenhaRouteImport.update({
  id: '/redefinir-senha',
  path: '/redefinir-senha',
  getParentRoute: () => AuthRouteRoute,
} as any);
const PErroRoute = PErroRouteImport.update({
  id: '/p/erro',
  path: '/p/erro',
  getParentRoute: () => rootRouteImport,
} as any);
const AClienteIndexRoute = AClienteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AClienteRouteRoute,
} as any);
const ACobrancaBoletoIndexRoute = ACobrancaBoletoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ACobrancaBoletoRouteRoute,
} as any);
const ACobrancaBoletoRotinasBancariasRoute =
  ACobrancaBoletoRotinasBancariasRouteImport.update({
    id: '/rotinas-bancarias',
    path: '/rotinas-bancarias',
    getParentRoute: () => ACobrancaBoletoRouteRoute,
  } as any);
const ACobrancaCartaoIndexRoute = ACobrancaCartaoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ACobrancaCartaoRouteRoute,
} as any);
const ACobrancaCartaoCadastrarRoute =
  ACobrancaCartaoCadastrarRouteImport.update({
    id: '/cadastrar',
    path: '/cadastrar',
    getParentRoute: () => ACobrancaCartaoRouteRoute,
  } as any);
const ACobrancaPixIndexRoute = ACobrancaPixIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ACobrancaPixRouteRoute,
} as any);
const AComissaoIndexRoute = AComissaoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AComissaoRouteRoute,
} as any);
const ACompraCompraRoute = ACompraCompraRouteImport.update({
  id: '/compra',
  path: '/compra',
  getParentRoute: () => ACompraRouteRoute,
} as any);
const ACompraImportacaoNfeRoute = ACompraImportacaoNfeRouteImport.update({
  id: '/importacao-nfe',
  path: '/importacao-nfe',
  getParentRoute: () => ACompraRouteRoute,
} as any);
const ACompraManifestadorRoute = ACompraManifestadorRouteImport.update({
  id: '/manifestador',
  path: '/manifestador',
  getParentRoute: () => ACompraRouteRoute,
} as any);
const AConfiguracaoEmpresaRouteRoute =
  AConfiguracaoEmpresaRouteRouteImport.update({
    id: '/configuracao/empresa',
    path: '/configuracao/empresa',
    getParentRoute: () => ARouteRoute,
  } as any);
const AConfiguracaoUsuarioRoute = AConfiguracaoUsuarioRouteImport.update({
  id: '/configuracao/usuario',
  path: '/configuracao/usuario',
  getParentRoute: () => ARouteRoute,
} as any);
const AContasPagarIndexRoute = AContasPagarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AContasPagarRouteRoute,
} as any);
const AContasReceberIndexRoute = AContasReceberIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AContasReceberRouteRoute,
} as any);
const AContratoIndexRoute = AContratoIndexRouteImport.update({
  id: '/contrato/',
  path: '/contrato/',
  getParentRoute: () => ARouteRoute,
} as any);
const ACupomFiscalIndexRoute = ACupomFiscalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ACupomFiscalRouteRoute,
} as any);
const ADebugIndexRoute = ADebugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ADebugRouteRoute,
} as any);
const ADevolucaoIndexRoute = ADevolucaoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ADevolucaoRouteRoute,
} as any);
const AEstoqueConferenciaRoute = AEstoqueConferenciaRouteImport.update({
  id: '/conferencia',
  path: '/conferencia',
  getParentRoute: () => AEstoqueRouteRoute,
} as any);
const AEstoqueMovimentacaoRoute = AEstoqueMovimentacaoRouteImport.update({
  id: '/movimentacao',
  path: '/movimentacao',
  getParentRoute: () => AEstoqueRouteRoute,
} as any);
const AExtratoBoletoIndexRoute = AExtratoBoletoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AExtratoBoletoRouteRoute,
} as any);
const AExtratoPixIndexRoute = AExtratoPixIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AExtratoPixRouteRoute,
} as any);
const AFornecedorIndexRoute = AFornecedorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AFornecedorRouteRoute,
} as any);
const AImpressaoFiletypeRoute = AImpressaoFiletypeRouteImport.update({
  id: '/impressao/$filetype',
  path: '/impressao/$filetype',
  getParentRoute: () => ARouteRoute,
} as any);
const AInventarioIndexRoute = AInventarioIndexRouteImport.update({
  id: '/inventario/',
  path: '/inventario/',
  getParentRoute: () => ARouteRoute,
} as any);
const AManifestoCargaIndexRoute = AManifestoCargaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AManifestoCargaRouteRoute,
} as any);
const AMovimentacoesIndexRoute = AMovimentacoesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AMovimentacoesRouteRoute,
} as any);
const ANfseIndexRoute = ANfseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ANfseRouteRoute,
} as any);
const ANotaFiscalIndexRoute = ANotaFiscalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ANotaFiscalRouteRoute,
} as any);
const ANotaFiscalCadastrarRoute = ANotaFiscalCadastrarRouteImport.update({
  id: '/cadastrar',
  path: '/cadastrar',
  getParentRoute: () => ANotaFiscalRouteRoute,
} as any);
const ANotificacaoListagemRoute = ANotificacaoListagemRouteImport.update({
  id: '/listagem',
  path: '/listagem',
  getParentRoute: () => ANotificacaoRouteRoute,
} as any);
const APagforImportarRoute = APagforImportarRouteImport.update({
  id: '/importar',
  path: '/importar',
  getParentRoute: () => APagforRouteRoute,
} as any);
const APagforListagemRoute = APagforListagemRouteImport.update({
  id: '/listagem',
  path: '/listagem',
  getParentRoute: () => APagforRouteRoute,
} as any);
const APainelGerencialIndexRoute = APainelGerencialIndexRouteImport.update({
  id: '/painel-gerencial/',
  path: '/painel-gerencial/',
  getParentRoute: () => ARouteRoute,
} as any);
const APersonalizacoesComandosRoute =
  APersonalizacoesComandosRouteImport.update({
    id: '/personalizacoes/comandos',
    path: '/personalizacoes/comandos',
    getParentRoute: () => ARouteRoute,
  } as any);
const APersonalizacoesConsultasRoute =
  APersonalizacoesConsultasRouteImport.update({
    id: '/personalizacoes/consultas',
    path: '/personalizacoes/consultas',
    getParentRoute: () => ARouteRoute,
  } as any);
const AProdutoIndexRoute = AProdutoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AProdutoRouteRoute,
} as any);
const ARegraFiscalIndexRoute = ARegraFiscalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ARegraFiscalRouteRoute,
} as any);
const ARelatorioCadastroRouteRoute = ARelatorioCadastroRouteRouteImport.update({
  id: '/relatorio/cadastro',
  path: '/relatorio/cadastro',
  getParentRoute: () => ARouteRoute,
} as any);
const ARelatorioCompraRouteRoute = ARelatorioCompraRouteRouteImport.update({
  id: '/relatorio/compra',
  path: '/relatorio/compra',
  getParentRoute: () => ARouteRoute,
} as any);
const ARelatorioEstoqueRouteRoute = ARelatorioEstoqueRouteRouteImport.update({
  id: '/relatorio/estoque',
  path: '/relatorio/estoque',
  getParentRoute: () => ARouteRoute,
} as any);
const ARelatorioFinanceiroRouteRoute =
  ARelatorioFinanceiroRouteRouteImport.update({
    id: '/relatorio/financeiro',
    path: '/relatorio/financeiro',
    getParentRoute: () => ARouteRoute,
  } as any);
const ARelatorioFiscalRouteRoute = ARelatorioFiscalRouteRouteImport.update({
  id: '/relatorio/fiscal',
  path: '/relatorio/fiscal',
  getParentRoute: () => ARouteRoute,
} as any);
const ARelatorioVendaRouteRoute = ARelatorioVendaRouteRouteImport.update({
  id: '/relatorio/venda',
  path: '/relatorio/venda',
  getParentRoute: () => ARouteRoute,
} as any);
const ARenegociacaoContasPagarRouteRoute =
  ARenegociacaoContasPagarRouteRouteImport.update({
    id: '/renegociacao/contas-pagar',
    path: '/renegociacao/contas-pagar',
    getParentRoute: () => ARouteRoute,
  } as any);
const ARenegociacaoContasReceberRouteRoute =
  ARenegociacaoContasReceberRouteRouteImport.update({
    id: '/renegociacao/contas-receber',
    path: '/renegociacao/contas-receber',
    getParentRoute: () => ARouteRoute,
  } as any);
const ARomaneioIndexRoute = ARomaneioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ARomaneioRouteRoute,
} as any);
const ASecundarioIndexRoute = ASecundarioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ASecundarioRouteRoute,
} as any);
const ASeparacaoIndexRoute = ASeparacaoIndexRouteImport.update({
  id: '/separacao/',
  path: '/separacao/',
  getParentRoute: () => ARouteRoute,
} as any);
const ASeparacaoMonitorRoute = ASeparacaoMonitorRouteImport.update({
  id: '/separacao/monitor',
  path: '/separacao/monitor',
  getParentRoute: () => ARouteRoute,
} as any);
const AServicoIndexRoute = AServicoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AServicoRouteRoute,
} as any);
const ASpedFiscalIndexRoute = ASpedFiscalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ASpedFiscalRouteRoute,
} as any);
const ASuporteIndexRoute = ASuporteIndexRouteImport.update({
  id: '/suporte/',
  path: '/suporte/',
  getParentRoute: () => ARouteRoute,
} as any);
const ASuporteInstrucoesDeUsoRoute = ASuporteInstrucoesDeUsoRouteImport.update({
  id: '/suporte/instrucoes-de-uso',
  path: '/suporte/instrucoes-de-uso',
  getParentRoute: () => ARouteRoute,
} as any);
const ATransportadorIndexRoute = ATransportadorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ATransportadorRouteRoute,
} as any);
const AVendaExternaIndexRoute = AVendaExternaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AVendaExternaRouteRoute,
} as any);
const AdminAEmpresaRoute = AdminAEmpresaRouteImport.update({
  id: '/empresa',
  path: '/empresa',
  getParentRoute: () => AdminARouteRoute,
} as any);
const AdminAErroRoute = AdminAErroRouteImport.update({
  id: '/erro',
  path: '/erro',
  getParentRoute: () => AdminARouteRoute,
} as any);
const AdminARepresentanteRoute = AdminARepresentanteRouteImport.update({
  id: '/representante',
  path: '/representante',
  getParentRoute: () => AdminARouteRoute,
} as any);
const AdminASqlRoute = AdminASqlRouteImport.update({
  id: '/sql',
  path: '/sql',
  getParentRoute: () => AdminARouteRoute,
} as any);
const AdminASqlEditorRoute = AdminASqlEditorRouteImport.update({
  id: '/sql-editor',
  path: '/sql-editor',
  getParentRoute: () => AdminARouteRoute,
} as any);
const AdminAuthLoginRoute = AdminAuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminAuthRoute,
} as any);
const PCatalogoSlugRouteRoute = PCatalogoSlugRouteRouteImport.update({
  id: '/p/catalogo/$slug',
  path: '/p/catalogo/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const PClienteSlugRoute = PClienteSlugRouteImport.update({
  id: '/p/cliente/$slug',
  path: '/p/cliente/$slug',
  getParentRoute: () => rootRouteImport,
} as any);
const PCompartilhamentoIdRoute = PCompartilhamentoIdRouteImport.update({
  id: '/p/compartilhamento/$id',
  path: '/p/compartilhamento/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const PContratoIdRoute = PContratoIdRouteImport.update({
  id: '/p/contrato/$id',
  path: '/p/contrato/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const PImpressaoFiletypeRoute = PImpressaoFiletypeRouteImport.update({
  id: '/p/impressao/$filetype',
  path: '/p/impressao/$filetype',
  getParentRoute: () => rootRouteImport,
} as any);
const AClienteActionChar123IdpkChar125Route =
  AClienteActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => AClienteRouteRoute,
  } as any);
const ACobrancaBoletoActionChar123IdpkChar125Route =
  ACobrancaBoletoActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => ACobrancaBoletoRouteRoute,
  } as any);
const ACompraActionChar123IdpkChar125Route =
  ACompraActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => ACompraRouteRoute,
  } as any);
const ACompraClonarIdpkRoute = ACompraClonarIdpkRouteImport.update({
  id: '/clonar/$idpk',
  path: '/clonar/$idpk',
  getParentRoute: () => ACompraRouteRoute,
} as any);
const AConfiguracaoEmpresaIndexRoute =
  AConfiguracaoEmpresaIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AConfiguracaoEmpresaRouteRoute,
  } as any);
const AContasPagarActionChar123IdpkChar125Route =
  AContasPagarActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => AContasPagarRouteRoute,
  } as any);
const AContasReceberActionChar123IdpkChar125Route =
  AContasReceberActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => AContasReceberRouteRoute,
  } as any);
const AContratoActionChar123IdpkChar125Route =
  AContratoActionChar123IdpkChar125RouteImport.update({
    id: '/contrato/$action/{-$idpk}',
    path: '/contrato/$action/{-$idpk}',
    getParentRoute: () => ARouteRoute,
  } as any);
const ADevolucaoActionChar123IdpkChar125Route =
  ADevolucaoActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => ADevolucaoRouteRoute,
  } as any);
const AImportacaoTipoChar123IdpkChar125Route =
  AImportacaoTipoChar123IdpkChar125RouteImport.update({
    id: '/importacao/$tipo/{-$idpk}',
    path: '/importacao/$tipo/{-$idpk}',
    getParentRoute: () => ARouteRoute,
  } as any);
const AImportacaoXmlTipoRoute = AImportacaoXmlTipoRouteImport.update({
  id: '/importacao/xml/$tipo',
  path: '/importacao/xml/$tipo',
  getParentRoute: () => ARouteRoute,
} as any);
const AInventarioActionChar123IdpkChar125Route =
  AInventarioActionChar123IdpkChar125RouteImport.update({
    id: '/inventario/$action/{-$idpk}',
    path: '/inventario/$action/{-$idpk}',
    getParentRoute: () => ARouteRoute,
  } as any);
const AManifestoCargaActionChar123IdpkChar125Route =
  AManifestoCargaActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => AManifestoCargaRouteRoute,
  } as any);
const AMovimentacoesActionChar123IdpkChar125Route =
  AMovimentacoesActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => AMovimentacoesRouteRoute,
  } as any);
const AMovimentacoesExtratoIdpkRoute =
  AMovimentacoesExtratoIdpkRouteImport.update({
    id: '/extrato/$idpk',
    path: '/extrato/$idpk',
    getParentRoute: () => AMovimentacoesRouteRoute,
  } as any);
const ANfseActionChar123IdpkChar125Route =
  ANfseActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => ANfseRouteRoute,
  } as any);
const ANotaFiscalActionChar123IdpkChar125Route =
  ANotaFiscalActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => ANotaFiscalRouteRoute,
  } as any);
const APagforActionChar123IdpkChar125Route =
  APagforActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => APagforRouteRoute,
  } as any);
const AProdutoActionChar123IdpkChar125Route =
  AProdutoActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => AProdutoRouteRoute,
  } as any);
const ARegraFiscalActionChar123IdpkChar125Route =
  ARegraFiscalActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => ARegraFiscalRouteRoute,
  } as any);
const ARelatorioCadastroIndexRoute = ARelatorioCadastroIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ARelatorioCadastroRouteRoute,
} as any);
const ARelatorioCadastroCatalogoProdutosRoute =
  ARelatorioCadastroCatalogoProdutosRouteImport.update({
    id: '/catalogo-produtos',
    path: '/catalogo-produtos',
    getParentRoute: () => ARelatorioCadastroRouteRoute,
  } as any);
const ARelatorioCadastroControleLotesRoute =
  ARelatorioCadastroControleLotesRouteImport.update({
    id: '/controle-lotes',
    path: '/controle-lotes',
    getParentRoute: () => ARelatorioCadastroRouteRoute,
  } as any);
const ARelatorioCadastroHistoricoAlteracoesPrecoRoute =
  ARelatorioCadastroHistoricoAlteracoesPrecoRouteImport.update({
    id: '/historico-alteracoes-preco',
    path: '/historico-alteracoes-preco',
    getParentRoute: () => ARelatorioCadastroRouteRoute,
  } as any);
const ARelatorioCadastroRelacaoClientesRoute =
  ARelatorioCadastroRelacaoClientesRouteImport.update({
    id: '/relacao-clientes',
    path: '/relacao-clientes',
    getParentRoute: () => ARelatorioCadastroRouteRoute,
  } as any);
const ARelatorioCadastroRelacaoClientesAniversariantesRoute =
  ARelatorioCadastroRelacaoClientesAniversariantesRouteImport.update({
    id: '/relacao-clientes-aniversariantes',
    path: '/relacao-clientes-aniversariantes',
    getParentRoute: () => ARelatorioCadastroRouteRoute,
  } as any);
const ARelatorioCadastroRelacaoFornecedoresRoute =
  ARelatorioCadastroRelacaoFornecedoresRouteImport.update({
    id: '/relacao-fornecedores',
    path: '/relacao-fornecedores',
    getParentRoute: () => ARelatorioCadastroRouteRoute,
  } as any);
const ARelatorioCadastroRelacaoProdutosRoute =
  ARelatorioCadastroRelacaoProdutosRouteImport.update({
    id: '/relacao-produtos',
    path: '/relacao-produtos',
    getParentRoute: () => ARelatorioCadastroRouteRoute,
  } as any);
const ARelatorioCadastroRelacaoTransportadoresRoute =
  ARelatorioCadastroRelacaoTransportadoresRouteImport.update({
    id: '/relacao-transportadores',
    path: '/relacao-transportadores',
    getParentRoute: () => ARelatorioCadastroRouteRoute,
  } as any);
const ARelatorioCompraIndexRoute = ARelatorioCompraIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ARelatorioCompraRouteRoute,
} as any);
const ARelatorioCompraComprasPorFornecedorRoute =
  ARelatorioCompraComprasPorFornecedorRouteImport.update({
    id: '/compras-por-fornecedor',
    path: '/compras-por-fornecedor',
    getParentRoute: () => ARelatorioCompraRouteRoute,
  } as any);
const ARelatorioEstoqueIndexRoute = ARelatorioEstoqueIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ARelatorioEstoqueRouteRoute,
} as any);
const ARelatorioEstoqueEstoqueMinimoRoute =
  ARelatorioEstoqueEstoqueMinimoRouteImport.update({
    id: '/estoque-minimo',
    path: '/estoque-minimo',
    getParentRoute: () => ARelatorioEstoqueRouteRoute,
  } as any);
const ARelatorioEstoqueSaldosEmEstoqueRoute =
  ARelatorioEstoqueSaldosEmEstoqueRouteImport.update({
    id: '/saldos-em-estoque',
    path: '/saldos-em-estoque',
    getParentRoute: () => ARelatorioEstoqueRouteRoute,
  } as any);
const ARelatorioFinanceiroIndexRoute =
  ARelatorioFinanceiroIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroBalanceteRoute =
  ARelatorioFinanceiroBalanceteRouteImport.update({
    id: '/balancete',
    path: '/balancete',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroBoletosRecebidosRoute =
  ARelatorioFinanceiroBoletosRecebidosRouteImport.update({
    id: '/boletos-recebidos',
    path: '/boletos-recebidos',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroContasPagarRoute =
  ARelatorioFinanceiroContasPagarRouteImport.update({
    id: '/contas-pagar',
    path: '/contas-pagar',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroContasReceberRoute =
  ARelatorioFinanceiroContasReceberRouteImport.update({
    id: '/contas-receber',
    path: '/contas-receber',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroContasRecebidasRoute =
  ARelatorioFinanceiroContasRecebidasRouteImport.update({
    id: '/contas-recebidas',
    path: '/contas-recebidas',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroDreRoute = ARelatorioFinanceiroDreRouteImport.update({
  id: '/dre',
  path: '/dre',
  getParentRoute: () => ARelatorioFinanceiroRouteRoute,
} as any);
const ARelatorioFinanceiroEntradasSaidasRoute =
  ARelatorioFinanceiroEntradasSaidasRouteImport.update({
    id: '/entradas-saidas',
    path: '/entradas-saidas',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroFluxoCaixaRoute =
  ARelatorioFinanceiroFluxoCaixaRouteImport.update({
    id: '/fluxo-caixa',
    path: '/fluxo-caixa',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroLancamentosContasReceberRoute =
  ARelatorioFinanceiroLancamentosContasReceberRouteImport.update({
    id: '/lancamentos-contas-receber',
    path: '/lancamentos-contas-receber',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroPagamentosRoute =
  ARelatorioFinanceiroPagamentosRouteImport.update({
    id: '/pagamentos',
    path: '/pagamentos',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroRelacaoBoletosRoute =
  ARelatorioFinanceiroRelacaoBoletosRouteImport.update({
    id: '/relacao-boletos',
    path: '/relacao-boletos',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFinanceiroTotaisPorCategoriaRoute =
  ARelatorioFinanceiroTotaisPorCategoriaRouteImport.update({
    id: '/totais-por-categoria',
    path: '/totais-por-categoria',
    getParentRoute: () => ARelatorioFinanceiroRouteRoute,
  } as any);
const ARelatorioFiscalIndexRoute = ARelatorioFiscalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ARelatorioFiscalRouteRoute,
} as any);
const ARelatorioFiscalItensNotasFiscaisRoute =
  ARelatorioFiscalItensNotasFiscaisRouteImport.update({
    id: '/itens-notas-fiscais',
    path: '/itens-notas-fiscais',
    getParentRoute: () => ARelatorioFiscalRouteRoute,
  } as any);
const ARelatorioFiscalNotasFiscaisClienteRoute =
  ARelatorioFiscalNotasFiscaisClienteRouteImport.update({
    id: '/notas-fiscais-cliente',
    path: '/notas-fiscais-cliente',
    getParentRoute: () => ARelatorioFiscalRouteRoute,
  } as any);
const ARelatorioFiscalNotasFiscaisProdutoRoute =
  ARelatorioFiscalNotasFiscaisProdutoRouteImport.update({
    id: '/notas-fiscais-produto',
    path: '/notas-fiscais-produto',
    getParentRoute: () => ARelatorioFiscalRouteRoute,
  } as any);
const ARelatorioFiscalNotasFiscaisTipoRoute =
  ARelatorioFiscalNotasFiscaisTipoRouteImport.update({
    id: '/notas-fiscais-tipo',
    path: '/notas-fiscais-tipo',
    getParentRoute: () => ARelatorioFiscalRouteRoute,
  } as any);
const ARelatorioFiscalRelacaoDocumentosRoute =
  ARelatorioFiscalRelacaoDocumentosRouteImport.update({
    id: '/relacao-documentos',
    path: '/relacao-documentos',
    getParentRoute: () => ARelatorioFiscalRouteRoute,
  } as any);
const ARelatorioFiscalRelacaoSequenciasInutilizadasRoute =
  ARelatorioFiscalRelacaoSequenciasInutilizadasRouteImport.update({
    id: '/relacao-sequencias-inutilizadas',
    path: '/relacao-sequencias-inutilizadas',
    getParentRoute: () => ARelatorioFiscalRouteRoute,
  } as any);
const ARelatorioFiscalTotalAgrupadoCfopRoute =
  ARelatorioFiscalTotalAgrupadoCfopRouteImport.update({
    id: '/total-agrupado-cfop',
    path: '/total-agrupado-cfop',
    getParentRoute: () => ARelatorioFiscalRouteRoute,
  } as any);
const ARelatorioFiscalTotalAgrupadoFormaPagamentoRoute =
  ARelatorioFiscalTotalAgrupadoFormaPagamentoRouteImport.update({
    id: '/total-agrupado-forma-pagamento',
    path: '/total-agrupado-forma-pagamento',
    getParentRoute: () => ARelatorioFiscalRouteRoute,
  } as any);
const ARelatorioFiscalTotalAgrupadoNcmRoute =
  ARelatorioFiscalTotalAgrupadoNcmRouteImport.update({
    id: '/total-agrupado-ncm',
    path: '/total-agrupado-ncm',
    getParentRoute: () => ARelatorioFiscalRouteRoute,
  } as any);
const ARelatorioVendaIndexRoute = ARelatorioVendaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ARelatorioVendaRouteRoute,
} as any);
const ARelatorioVendaComissoesRoute =
  ARelatorioVendaComissoesRouteImport.update({
    id: '/comissoes',
    path: '/comissoes',
    getParentRoute: () => ARelatorioVendaRouteRoute,
  } as any);
const ARelatorioVendaProdutosMaisVendidosRoute =
  ARelatorioVendaProdutosMaisVendidosRouteImport.update({
    id: '/produtos-mais-vendidos',
    path: '/produtos-mais-vendidos',
    getParentRoute: () => ARelatorioVendaRouteRoute,
  } as any);
const ARelatorioVendaRelacaoVendasRoute =
  ARelatorioVendaRelacaoVendasRouteImport.update({
    id: '/relacao-vendas',
    path: '/relacao-vendas',
    getParentRoute: () => ARelatorioVendaRouteRoute,
  } as any);
const ARelatorioVendaRelacaoVendasProdutoRoute =
  ARelatorioVendaRelacaoVendasProdutoRouteImport.update({
    id: '/relacao-vendas-produto',
    path: '/relacao-vendas-produto',
    getParentRoute: () => ARelatorioVendaRouteRoute,
  } as any);
const ARelatorioVendaRelacaoVendasResumidoRoute =
  ARelatorioVendaRelacaoVendasResumidoRouteImport.update({
    id: '/relacao-vendas-resumido',
    path: '/relacao-vendas-resumido',
    getParentRoute: () => ARelatorioVendaRouteRoute,
  } as any);
const ARelatorioVendaTotalFormaPagamentoRoute =
  ARelatorioVendaTotalFormaPagamentoRouteImport.update({
    id: '/total-forma-pagamento',
    path: '/total-forma-pagamento',
    getParentRoute: () => ARelatorioVendaRouteRoute,
  } as any);
const ARelatorioVendaVendasClienteRoute =
  ARelatorioVendaVendasClienteRouteImport.update({
    id: '/vendas-cliente',
    path: '/vendas-cliente',
    getParentRoute: () => ARelatorioVendaRouteRoute,
  } as any);
const ARelatorioVendaVendasVendedorRoute =
  ARelatorioVendaVendasVendedorRouteImport.update({
    id: '/vendas-vendedor',
    path: '/vendas-vendedor',
    getParentRoute: () => ARelatorioVendaRouteRoute,
  } as any);
const ARenegociacaoContasPagarIndexRoute =
  ARenegociacaoContasPagarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ARenegociacaoContasPagarRouteRoute,
  } as any);
const ARenegociacaoContasPagarCadastrarRoute =
  ARenegociacaoContasPagarCadastrarRouteImport.update({
    id: '/cadastrar',
    path: '/cadastrar',
    getParentRoute: () => ARenegociacaoContasPagarRouteRoute,
  } as any);
const ARenegociacaoContasReceberIndexRoute =
  ARenegociacaoContasReceberIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ARenegociacaoContasReceberRouteRoute,
  } as any);
const ARenegociacaoContasReceberCadastrarRoute =
  ARenegociacaoContasReceberCadastrarRouteImport.update({
    id: '/cadastrar',
    path: '/cadastrar',
    getParentRoute: () => ARenegociacaoContasReceberRouteRoute,
  } as any);
const ARomaneioActionChar123IdpkChar125Route =
  ARomaneioActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => ARomaneioRouteRoute,
  } as any);
const ASeparacaoTypeIdpkRoute = ASeparacaoTypeIdpkRouteImport.update({
  id: '/separacao/$type/$idpk',
  path: '/separacao/$type/$idpk',
  getParentRoute: () => ARouteRoute,
} as any);
const AServicoActionChar123IdpkChar125Route =
  AServicoActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => AServicoRouteRoute,
  } as any);
const ASpedFiscalActionChar123IdpkChar125Route =
  ASpedFiscalActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => ASpedFiscalRouteRoute,
  } as any);
const ATransportadorActionChar123IdpkChar125Route =
  ATransportadorActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => ATransportadorRouteRoute,
  } as any);
const AVendaExternaActionChar123IdpkChar125Route =
  AVendaExternaActionChar123IdpkChar125RouteImport.update({
    id: '/$action/{-$idpk}',
    path: '/$action/{-$idpk}',
    getParentRoute: () => AVendaExternaRouteRoute,
  } as any);
const AVendaActionIdpkRoute = AVendaActionIdpkRouteImport.update({
  id: '/$action/$idpk',
  path: '/$action/$idpk',
  getParentRoute: () => AVendaRouteRoute,
} as any);
const AVendaTipoIndexRoute = AVendaTipoIndexRouteImport.update({
  id: '/$tipo/',
  path: '/$tipo/',
  getParentRoute: () => AVendaRouteRoute,
} as any);
const AVendaCadastrarTipoRoute = AVendaCadastrarTipoRouteImport.update({
  id: '/cadastrar/$tipo',
  path: '/cadastrar/$tipo',
  getParentRoute: () => AVendaRouteRoute,
} as any);
const AdminAConfiguracaoRepresentanteRoute =
  AdminAConfiguracaoRepresentanteRouteImport.update({
    id: '/configuracao/representante',
    path: '/configuracao/representante',
    getParentRoute: () => AdminARouteRoute,
  } as any);
const PCatalogoSlugIndexRoute = PCatalogoSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PCatalogoSlugRouteRoute,
} as any);
const PCatalogoSlugDefaultRouteRoute =
  PCatalogoSlugDefaultRouteRouteImport.update({
    id: '/_default',
    getParentRoute: () => PCatalogoSlugRouteRoute,
  } as any);
const PCatalogoSlugAuthRouteRoute = PCatalogoSlugAuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => PCatalogoSlugRouteRoute,
} as any);
const PContaDigitalTermosDeUsoBase64Route =
  PContaDigitalTermosDeUsoBase64RouteImport.update({
    id: '/p/conta-digital/termos-de-uso/$base64',
    path: '/p/conta-digital/termos-de-uso/$base64',
    getParentRoute: () => rootRouteImport,
  } as any);
const PPagamentoIdIndexRoute = PPagamentoIdIndexRouteImport.update({
  id: '/p/pagamento/$id/',
  path: '/p/pagamento/$id/',
  getParentRoute: () => rootRouteImport,
} as any);
const ARomaneioImpressaoCargaIdpkRoute =
  ARomaneioImpressaoCargaIdpkRouteImport.update({
    id: '/impressao/carga/$idpk',
    path: '/impressao/carga/$idpk',
    getParentRoute: () => ARomaneioRouteRoute,
  } as any);
const ARomaneioImpressaoEntregaIdpkRoute =
  ARomaneioImpressaoEntregaIdpkRouteImport.update({
    id: '/impressao/entrega/$idpk',
    path: '/impressao/entrega/$idpk',
    getParentRoute: () => ARomaneioRouteRoute,
  } as any);
const ARomaneioImpressaoPadraoIdpkRoute =
  ARomaneioImpressaoPadraoIdpkRouteImport.update({
    id: '/impressao/padrao/$idpk',
    path: '/impressao/padrao/$idpk',
    getParentRoute: () => ARomaneioRouteRoute,
  } as any);
const AVendaClonarTipoIdpkRoute = AVendaClonarTipoIdpkRouteImport.update({
  id: '/clonar/$tipo/$idpk',
  path: '/clonar/$tipo/$idpk',
  getParentRoute: () => AVendaRouteRoute,
} as any);
const AdminAEmpresaActionChar123IdpkChar125Route =
  AdminAEmpresaActionChar123IdpkChar125RouteImport.update({
    id: '/empresa_/$action/{-$idpk}',
    path: '/empresa/$action/{-$idpk}',
    getParentRoute: () => AdminARouteRoute,
  } as any);
const PCatalogoSlugDefaultFinalizarRoute =
  PCatalogoSlugDefaultFinalizarRouteImport.update({
    id: '/finalizar',
    path: '/finalizar',
    getParentRoute: () => PCatalogoSlugDefaultRouteRoute,
  } as any);
const PCatalogoSlugDefaultProdutosRoute =
  PCatalogoSlugDefaultProdutosRouteImport.update({
    id: '/produtos',
    path: '/produtos',
    getParentRoute: () => PCatalogoSlugDefaultRouteRoute,
  } as any);
const PCatalogoSlugDefaultUsuarioRouteRoute =
  PCatalogoSlugDefaultUsuarioRouteRouteImport.update({
    id: '/usuario',
    path: '/usuario',
    getParentRoute: () => PCatalogoSlugDefaultRouteRoute,
  } as any);
const PCatalogoSlugAuthCadastrarRoute =
  PCatalogoSlugAuthCadastrarRouteImport.update({
    id: '/cadastrar',
    path: '/cadastrar',
    getParentRoute: () => PCatalogoSlugAuthRouteRoute,
  } as any);
const PCatalogoSlugAuthEntrarRoute = PCatalogoSlugAuthEntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => PCatalogoSlugAuthRouteRoute,
} as any);
const PCatalogoSlugAuthRecuperarSenhaRoute =
  PCatalogoSlugAuthRecuperarSenhaRouteImport.update({
    id: '/recuperar-senha',
    path: '/recuperar-senha',
    getParentRoute: () => PCatalogoSlugAuthRouteRoute,
  } as any);
const PCatalogoSlugAuthValidarCodigoRoute =
  PCatalogoSlugAuthValidarCodigoRouteImport.update({
    id: '/validar-codigo',
    path: '/validar-codigo',
    getParentRoute: () => PCatalogoSlugAuthRouteRoute,
  } as any);
const PCatalogoSlugDefaultUsuarioPerfilRoute =
  PCatalogoSlugDefaultUsuarioPerfilRouteImport.update({
    id: '/perfil',
    path: '/perfil',
    getParentRoute: () => PCatalogoSlugDefaultUsuarioRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/a': typeof ARouteRouteWithChildren;
  '/admin': typeof AdminRouteRouteWithChildren;
  '/auth': typeof AuthRouteRouteWithChildren;
  '/a/cliente': typeof AClienteRouteRouteWithChildren;
  '/a/cobranca-boleto': typeof ACobrancaBoletoRouteRouteWithChildren;
  '/a/cobranca-cartao': typeof ACobrancaCartaoRouteRouteWithChildren;
  '/a/cobranca-pix': typeof ACobrancaPixRouteRouteWithChildren;
  '/a/comissao': typeof AComissaoRouteRouteWithChildren;
  '/a/compra': typeof ACompraRouteRouteWithChildren;
  '/a/contas-pagar': typeof AContasPagarRouteRouteWithChildren;
  '/a/contas-receber': typeof AContasReceberRouteRouteWithChildren;
  '/a/cupom-fiscal': typeof ACupomFiscalRouteRouteWithChildren;
  '/a/debug': typeof ADebugRouteRouteWithChildren;
  '/a/devolucao': typeof ADevolucaoRouteRouteWithChildren;
  '/a/estoque': typeof AEstoqueRouteRouteWithChildren;
  '/a/extrato-boleto': typeof AExtratoBoletoRouteRouteWithChildren;
  '/a/extrato-pix': typeof AExtratoPixRouteRouteWithChildren;
  '/a/fornecedor': typeof AFornecedorRouteRouteWithChildren;
  '/a/manifesto-carga': typeof AManifestoCargaRouteRouteWithChildren;
  '/a/movimentacoes': typeof AMovimentacoesRouteRouteWithChildren;
  '/a/nfse': typeof ANfseRouteRouteWithChildren;
  '/a/nota-fiscal': typeof ANotaFiscalRouteRouteWithChildren;
  '/a/notificacao': typeof ANotificacaoRouteRouteWithChildren;
  '/a/pagfor': typeof APagforRouteRouteWithChildren;
  '/a/produto': typeof AProdutoRouteRouteWithChildren;
  '/a/regra-fiscal': typeof ARegraFiscalRouteRouteWithChildren;
  '/a/romaneio': typeof ARomaneioRouteRouteWithChildren;
  '/a/secundario': typeof ASecundarioRouteRouteWithChildren;
  '/a/servico': typeof AServicoRouteRouteWithChildren;
  '/a/sped-fiscal': typeof ASpedFiscalRouteRouteWithChildren;
  '/a/transportador': typeof ATransportadorRouteRouteWithChildren;
  '/a/venda': typeof AVendaRouteRouteWithChildren;
  '/a/venda-externa': typeof AVendaExternaRouteRouteWithChildren;
  '/a/pdv': typeof APdvRoute;
  '/admin/auth': typeof AdminAuthRouteWithChildren;
  '/auth/acesso-negado': typeof AuthAcessoNegadoRoute;
  '/auth/cadastro': typeof AuthCadastroRoute;
  '/auth/cadastro-fim': typeof AuthCadastroFimRoute;
  '/auth/conta-bloqueada': typeof AuthContaBloqueadaRoute;
  '/auth/login': typeof AuthLoginRoute;
  '/auth/login-adm': typeof AuthLoginAdmRoute;
  '/auth/login-automatico': typeof AuthLoginAutomaticoRoute;
  '/auth/recuperar-senha': typeof AuthRecuperarSenhaRoute;
  '/auth/redefinir-senha': typeof AuthRedefinirSenhaRoute;
  '/p/erro': typeof PErroRoute;
  '/a/configuracao/empresa': typeof AConfiguracaoEmpresaRouteRouteWithChildren;
  '/a/relatorio/cadastro': typeof ARelatorioCadastroRouteRouteWithChildren;
  '/a/relatorio/compra': typeof ARelatorioCompraRouteRouteWithChildren;
  '/a/relatorio/estoque': typeof ARelatorioEstoqueRouteRouteWithChildren;
  '/a/relatorio/financeiro': typeof ARelatorioFinanceiroRouteRouteWithChildren;
  '/a/relatorio/fiscal': typeof ARelatorioFiscalRouteRouteWithChildren;
  '/a/relatorio/venda': typeof ARelatorioVendaRouteRouteWithChildren;
  '/a/renegociacao/contas-pagar': typeof ARenegociacaoContasPagarRouteRouteWithChildren;
  '/a/renegociacao/contas-receber': typeof ARenegociacaoContasReceberRouteRouteWithChildren;
  '/p/catalogo/$slug': typeof PCatalogoSlugRouteRouteWithChildren;
  '/a/cobranca-boleto/rotinas-bancarias': typeof ACobrancaBoletoRotinasBancariasRoute;
  '/a/cobranca-cartao/cadastrar': typeof ACobrancaCartaoCadastrarRoute;
  '/a/compra/compra': typeof ACompraCompraRoute;
  '/a/compra/importacao-nfe': typeof ACompraImportacaoNfeRoute;
  '/a/compra/manifestador': typeof ACompraManifestadorRoute;
  '/a/configuracao/usuario': typeof AConfiguracaoUsuarioRoute;
  '/a/estoque/conferencia': typeof AEstoqueConferenciaRoute;
  '/a/estoque/movimentacao': typeof AEstoqueMovimentacaoRoute;
  '/a/impressao/$filetype': typeof AImpressaoFiletypeRoute;
  '/a/nota-fiscal/cadastrar': typeof ANotaFiscalCadastrarRoute;
  '/a/notificacao/listagem': typeof ANotificacaoListagemRoute;
  '/a/pagfor/importar': typeof APagforImportarRoute;
  '/a/pagfor/listagem': typeof APagforListagemRoute;
  '/a/personalizacoes/comandos': typeof APersonalizacoesComandosRoute;
  '/a/personalizacoes/consultas': typeof APersonalizacoesConsultasRoute;
  '/a/separacao/monitor': typeof ASeparacaoMonitorRoute;
  '/a/suporte/instrucoes-de-uso': typeof ASuporteInstrucoesDeUsoRoute;
  '/admin/empresa': typeof AdminAEmpresaRoute;
  '/admin/erro': typeof AdminAErroRoute;
  '/admin/representante': typeof AdminARepresentanteRoute;
  '/admin/sql': typeof AdminASqlRoute;
  '/admin/sql-editor': typeof AdminASqlEditorRoute;
  '/admin/auth/login': typeof AdminAuthLoginRoute;
  '/p/cliente/$slug': typeof PClienteSlugRoute;
  '/p/compartilhamento/$id': typeof PCompartilhamentoIdRoute;
  '/p/contrato/$id': typeof PContratoIdRoute;
  '/p/impressao/$filetype': typeof PImpressaoFiletypeRoute;
  '/a/cliente/': typeof AClienteIndexRoute;
  '/a/cobranca-boleto/': typeof ACobrancaBoletoIndexRoute;
  '/a/cobranca-cartao/': typeof ACobrancaCartaoIndexRoute;
  '/a/cobranca-pix/': typeof ACobrancaPixIndexRoute;
  '/a/comissao/': typeof AComissaoIndexRoute;
  '/a/contas-pagar/': typeof AContasPagarIndexRoute;
  '/a/contas-receber/': typeof AContasReceberIndexRoute;
  '/a/contrato/': typeof AContratoIndexRoute;
  '/a/cupom-fiscal/': typeof ACupomFiscalIndexRoute;
  '/a/debug/': typeof ADebugIndexRoute;
  '/a/devolucao/': typeof ADevolucaoIndexRoute;
  '/a/extrato-boleto/': typeof AExtratoBoletoIndexRoute;
  '/a/extrato-pix/': typeof AExtratoPixIndexRoute;
  '/a/fornecedor/': typeof AFornecedorIndexRoute;
  '/a/inventario/': typeof AInventarioIndexRoute;
  '/a/manifesto-carga/': typeof AManifestoCargaIndexRoute;
  '/a/movimentacoes/': typeof AMovimentacoesIndexRoute;
  '/a/nfse/': typeof ANfseIndexRoute;
  '/a/nota-fiscal/': typeof ANotaFiscalIndexRoute;
  '/a/painel-gerencial/': typeof APainelGerencialIndexRoute;
  '/a/produto/': typeof AProdutoIndexRoute;
  '/a/regra-fiscal/': typeof ARegraFiscalIndexRoute;
  '/a/romaneio/': typeof ARomaneioIndexRoute;
  '/a/secundario/': typeof ASecundarioIndexRoute;
  '/a/separacao/': typeof ASeparacaoIndexRoute;
  '/a/servico/': typeof AServicoIndexRoute;
  '/a/sped-fiscal/': typeof ASpedFiscalIndexRoute;
  '/a/suporte/': typeof ASuporteIndexRoute;
  '/a/transportador/': typeof ATransportadorIndexRoute;
  '/a/venda-externa/': typeof AVendaExternaIndexRoute;
  '/p/catalogo/$slug/auth': typeof PCatalogoSlugAuthRouteRouteWithChildren;
  '/a/cliente/$action/{-$idpk}': typeof AClienteActionChar123IdpkChar125Route;
  '/a/cobranca-boleto/$action/{-$idpk}': typeof ACobrancaBoletoActionChar123IdpkChar125Route;
  '/a/compra/$action/{-$idpk}': typeof ACompraActionChar123IdpkChar125Route;
  '/a/compra/clonar/$idpk': typeof ACompraClonarIdpkRoute;
  '/a/contas-pagar/$action/{-$idpk}': typeof AContasPagarActionChar123IdpkChar125Route;
  '/a/contas-receber/$action/{-$idpk}': typeof AContasReceberActionChar123IdpkChar125Route;
  '/a/contrato/$action/{-$idpk}': typeof AContratoActionChar123IdpkChar125Route;
  '/a/devolucao/$action/{-$idpk}': typeof ADevolucaoActionChar123IdpkChar125Route;
  '/a/importacao/$tipo/{-$idpk}': typeof AImportacaoTipoChar123IdpkChar125Route;
  '/a/importacao/xml/$tipo': typeof AImportacaoXmlTipoRoute;
  '/a/inventario/$action/{-$idpk}': typeof AInventarioActionChar123IdpkChar125Route;
  '/a/manifesto-carga/$action/{-$idpk}': typeof AManifestoCargaActionChar123IdpkChar125Route;
  '/a/movimentacoes/$action/{-$idpk}': typeof AMovimentacoesActionChar123IdpkChar125Route;
  '/a/movimentacoes/extrato/$idpk': typeof AMovimentacoesExtratoIdpkRoute;
  '/a/nfse/$action/{-$idpk}': typeof ANfseActionChar123IdpkChar125Route;
  '/a/nota-fiscal/$action/{-$idpk}': typeof ANotaFiscalActionChar123IdpkChar125Route;
  '/a/pagfor/$action/{-$idpk}': typeof APagforActionChar123IdpkChar125Route;
  '/a/produto/$action/{-$idpk}': typeof AProdutoActionChar123IdpkChar125Route;
  '/a/regra-fiscal/$action/{-$idpk}': typeof ARegraFiscalActionChar123IdpkChar125Route;
  '/a/relatorio/cadastro/catalogo-produtos': typeof ARelatorioCadastroCatalogoProdutosRoute;
  '/a/relatorio/cadastro/controle-lotes': typeof ARelatorioCadastroControleLotesRoute;
  '/a/relatorio/cadastro/historico-alteracoes-preco': typeof ARelatorioCadastroHistoricoAlteracoesPrecoRoute;
  '/a/relatorio/cadastro/relacao-clientes': typeof ARelatorioCadastroRelacaoClientesRoute;
  '/a/relatorio/cadastro/relacao-clientes-aniversariantes': typeof ARelatorioCadastroRelacaoClientesAniversariantesRoute;
  '/a/relatorio/cadastro/relacao-fornecedores': typeof ARelatorioCadastroRelacaoFornecedoresRoute;
  '/a/relatorio/cadastro/relacao-produtos': typeof ARelatorioCadastroRelacaoProdutosRoute;
  '/a/relatorio/cadastro/relacao-transportadores': typeof ARelatorioCadastroRelacaoTransportadoresRoute;
  '/a/relatorio/compra/compras-por-fornecedor': typeof ARelatorioCompraComprasPorFornecedorRoute;
  '/a/relatorio/estoque/estoque-minimo': typeof ARelatorioEstoqueEstoqueMinimoRoute;
  '/a/relatorio/estoque/saldos-em-estoque': typeof ARelatorioEstoqueSaldosEmEstoqueRoute;
  '/a/relatorio/financeiro/balancete': typeof ARelatorioFinanceiroBalanceteRoute;
  '/a/relatorio/financeiro/boletos-recebidos': typeof ARelatorioFinanceiroBoletosRecebidosRoute;
  '/a/relatorio/financeiro/contas-pagar': typeof ARelatorioFinanceiroContasPagarRoute;
  '/a/relatorio/financeiro/contas-receber': typeof ARelatorioFinanceiroContasReceberRoute;
  '/a/relatorio/financeiro/contas-recebidas': typeof ARelatorioFinanceiroContasRecebidasRoute;
  '/a/relatorio/financeiro/dre': typeof ARelatorioFinanceiroDreRoute;
  '/a/relatorio/financeiro/entradas-saidas': typeof ARelatorioFinanceiroEntradasSaidasRoute;
  '/a/relatorio/financeiro/fluxo-caixa': typeof ARelatorioFinanceiroFluxoCaixaRoute;
  '/a/relatorio/financeiro/lancamentos-contas-receber': typeof ARelatorioFinanceiroLancamentosContasReceberRoute;
  '/a/relatorio/financeiro/pagamentos': typeof ARelatorioFinanceiroPagamentosRoute;
  '/a/relatorio/financeiro/relacao-boletos': typeof ARelatorioFinanceiroRelacaoBoletosRoute;
  '/a/relatorio/financeiro/totais-por-categoria': typeof ARelatorioFinanceiroTotaisPorCategoriaRoute;
  '/a/relatorio/fiscal/itens-notas-fiscais': typeof ARelatorioFiscalItensNotasFiscaisRoute;
  '/a/relatorio/fiscal/notas-fiscais-cliente': typeof ARelatorioFiscalNotasFiscaisClienteRoute;
  '/a/relatorio/fiscal/notas-fiscais-produto': typeof ARelatorioFiscalNotasFiscaisProdutoRoute;
  '/a/relatorio/fiscal/notas-fiscais-tipo': typeof ARelatorioFiscalNotasFiscaisTipoRoute;
  '/a/relatorio/fiscal/relacao-documentos': typeof ARelatorioFiscalRelacaoDocumentosRoute;
  '/a/relatorio/fiscal/relacao-sequencias-inutilizadas': typeof ARelatorioFiscalRelacaoSequenciasInutilizadasRoute;
  '/a/relatorio/fiscal/total-agrupado-cfop': typeof ARelatorioFiscalTotalAgrupadoCfopRoute;
  '/a/relatorio/fiscal/total-agrupado-forma-pagamento': typeof ARelatorioFiscalTotalAgrupadoFormaPagamentoRoute;
  '/a/relatorio/fiscal/total-agrupado-ncm': typeof ARelatorioFiscalTotalAgrupadoNcmRoute;
  '/a/relatorio/venda/comissoes': typeof ARelatorioVendaComissoesRoute;
  '/a/relatorio/venda/produtos-mais-vendidos': typeof ARelatorioVendaProdutosMaisVendidosRoute;
  '/a/relatorio/venda/relacao-vendas': typeof ARelatorioVendaRelacaoVendasRoute;
  '/a/relatorio/venda/relacao-vendas-produto': typeof ARelatorioVendaRelacaoVendasProdutoRoute;
  '/a/relatorio/venda/relacao-vendas-resumido': typeof ARelatorioVendaRelacaoVendasResumidoRoute;
  '/a/relatorio/venda/total-forma-pagamento': typeof ARelatorioVendaTotalFormaPagamentoRoute;
  '/a/relatorio/venda/vendas-cliente': typeof ARelatorioVendaVendasClienteRoute;
  '/a/relatorio/venda/vendas-vendedor': typeof ARelatorioVendaVendasVendedorRoute;
  '/a/renegociacao/contas-pagar/cadastrar': typeof ARenegociacaoContasPagarCadastrarRoute;
  '/a/renegociacao/contas-receber/cadastrar': typeof ARenegociacaoContasReceberCadastrarRoute;
  '/a/romaneio/$action/{-$idpk}': typeof ARomaneioActionChar123IdpkChar125Route;
  '/a/separacao/$type/$idpk': typeof ASeparacaoTypeIdpkRoute;
  '/a/servico/$action/{-$idpk}': typeof AServicoActionChar123IdpkChar125Route;
  '/a/sped-fiscal/$action/{-$idpk}': typeof ASpedFiscalActionChar123IdpkChar125Route;
  '/a/transportador/$action/{-$idpk}': typeof ATransportadorActionChar123IdpkChar125Route;
  '/a/venda-externa/$action/{-$idpk}': typeof AVendaExternaActionChar123IdpkChar125Route;
  '/a/venda/$action/$idpk': typeof AVendaActionIdpkRoute;
  '/a/venda/cadastrar/$tipo': typeof AVendaCadastrarTipoRoute;
  '/admin/configuracao/representante': typeof AdminAConfiguracaoRepresentanteRoute;
  '/p/conta-digital/termos-de-uso/$base64': typeof PContaDigitalTermosDeUsoBase64Route;
  '/a/configuracao/empresa/': typeof AConfiguracaoEmpresaIndexRoute;
  '/a/relatorio/cadastro/': typeof ARelatorioCadastroIndexRoute;
  '/a/relatorio/compra/': typeof ARelatorioCompraIndexRoute;
  '/a/relatorio/estoque/': typeof ARelatorioEstoqueIndexRoute;
  '/a/relatorio/financeiro/': typeof ARelatorioFinanceiroIndexRoute;
  '/a/relatorio/fiscal/': typeof ARelatorioFiscalIndexRoute;
  '/a/relatorio/venda/': typeof ARelatorioVendaIndexRoute;
  '/a/renegociacao/contas-pagar/': typeof ARenegociacaoContasPagarIndexRoute;
  '/a/renegociacao/contas-receber/': typeof ARenegociacaoContasReceberIndexRoute;
  '/a/venda/$tipo/': typeof AVendaTipoIndexRoute;
  '/p/catalogo/$slug/': typeof PCatalogoSlugIndexRoute;
  '/p/pagamento/$id/': typeof PPagamentoIdIndexRoute;
  '/p/catalogo/$slug/usuario': typeof PCatalogoSlugDefaultUsuarioRouteRouteWithChildren;
  '/a/romaneio/impressao/carga/$idpk': typeof ARomaneioImpressaoCargaIdpkRoute;
  '/a/romaneio/impressao/entrega/$idpk': typeof ARomaneioImpressaoEntregaIdpkRoute;
  '/a/romaneio/impressao/padrao/$idpk': typeof ARomaneioImpressaoPadraoIdpkRoute;
  '/a/venda/clonar/$tipo/$idpk': typeof AVendaClonarTipoIdpkRoute;
  '/admin/empresa/$action/{-$idpk}': typeof AdminAEmpresaActionChar123IdpkChar125Route;
  '/p/catalogo/$slug/finalizar': typeof PCatalogoSlugDefaultFinalizarRoute;
  '/p/catalogo/$slug/produtos': typeof PCatalogoSlugDefaultProdutosRoute;
  '/p/catalogo/$slug/auth/cadastrar': typeof PCatalogoSlugAuthCadastrarRoute;
  '/p/catalogo/$slug/auth/entrar': typeof PCatalogoSlugAuthEntrarRoute;
  '/p/catalogo/$slug/auth/recuperar-senha': typeof PCatalogoSlugAuthRecuperarSenhaRoute;
  '/p/catalogo/$slug/auth/validar-codigo': typeof PCatalogoSlugAuthValidarCodigoRoute;
  '/p/catalogo/$slug/usuario/perfil': typeof PCatalogoSlugDefaultUsuarioPerfilRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/a': typeof ARouteRouteWithChildren;
  '/admin': typeof AdminRouteRouteWithChildren;
  '/auth': typeof AuthRouteRouteWithChildren;
  '/a/compra': typeof ACompraRouteRouteWithChildren;
  '/a/estoque': typeof AEstoqueRouteRouteWithChildren;
  '/a/notificacao': typeof ANotificacaoRouteRouteWithChildren;
  '/a/pagfor': typeof APagforRouteRouteWithChildren;
  '/a/venda': typeof AVendaRouteRouteWithChildren;
  '/a/pdv': typeof APdvRoute;
  '/admin/auth': typeof AdminAuthRouteWithChildren;
  '/auth/acesso-negado': typeof AuthAcessoNegadoRoute;
  '/auth/cadastro': typeof AuthCadastroRoute;
  '/auth/cadastro-fim': typeof AuthCadastroFimRoute;
  '/auth/conta-bloqueada': typeof AuthContaBloqueadaRoute;
  '/auth/login': typeof AuthLoginRoute;
  '/auth/login-adm': typeof AuthLoginAdmRoute;
  '/auth/login-automatico': typeof AuthLoginAutomaticoRoute;
  '/auth/recuperar-senha': typeof AuthRecuperarSenhaRoute;
  '/auth/redefinir-senha': typeof AuthRedefinirSenhaRoute;
  '/p/erro': typeof PErroRoute;
  '/a/cobranca-boleto/rotinas-bancarias': typeof ACobrancaBoletoRotinasBancariasRoute;
  '/a/cobranca-cartao/cadastrar': typeof ACobrancaCartaoCadastrarRoute;
  '/a/compra/compra': typeof ACompraCompraRoute;
  '/a/compra/importacao-nfe': typeof ACompraImportacaoNfeRoute;
  '/a/compra/manifestador': typeof ACompraManifestadorRoute;
  '/a/configuracao/usuario': typeof AConfiguracaoUsuarioRoute;
  '/a/estoque/conferencia': typeof AEstoqueConferenciaRoute;
  '/a/estoque/movimentacao': typeof AEstoqueMovimentacaoRoute;
  '/a/impressao/$filetype': typeof AImpressaoFiletypeRoute;
  '/a/nota-fiscal/cadastrar': typeof ANotaFiscalCadastrarRoute;
  '/a/notificacao/listagem': typeof ANotificacaoListagemRoute;
  '/a/pagfor/importar': typeof APagforImportarRoute;
  '/a/pagfor/listagem': typeof APagforListagemRoute;
  '/a/personalizacoes/comandos': typeof APersonalizacoesComandosRoute;
  '/a/personalizacoes/consultas': typeof APersonalizacoesConsultasRoute;
  '/a/separacao/monitor': typeof ASeparacaoMonitorRoute;
  '/a/suporte/instrucoes-de-uso': typeof ASuporteInstrucoesDeUsoRoute;
  '/admin/empresa': typeof AdminAEmpresaRoute;
  '/admin/erro': typeof AdminAErroRoute;
  '/admin/representante': typeof AdminARepresentanteRoute;
  '/admin/sql': typeof AdminASqlRoute;
  '/admin/sql-editor': typeof AdminASqlEditorRoute;
  '/admin/auth/login': typeof AdminAuthLoginRoute;
  '/p/cliente/$slug': typeof PClienteSlugRoute;
  '/p/compartilhamento/$id': typeof PCompartilhamentoIdRoute;
  '/p/contrato/$id': typeof PContratoIdRoute;
  '/p/impressao/$filetype': typeof PImpressaoFiletypeRoute;
  '/a/cliente': typeof AClienteIndexRoute;
  '/a/cobranca-boleto': typeof ACobrancaBoletoIndexRoute;
  '/a/cobranca-cartao': typeof ACobrancaCartaoIndexRoute;
  '/a/cobranca-pix': typeof ACobrancaPixIndexRoute;
  '/a/comissao': typeof AComissaoIndexRoute;
  '/a/contas-pagar': typeof AContasPagarIndexRoute;
  '/a/contas-receber': typeof AContasReceberIndexRoute;
  '/a/contrato': typeof AContratoIndexRoute;
  '/a/cupom-fiscal': typeof ACupomFiscalIndexRoute;
  '/a/debug': typeof ADebugIndexRoute;
  '/a/devolucao': typeof ADevolucaoIndexRoute;
  '/a/extrato-boleto': typeof AExtratoBoletoIndexRoute;
  '/a/extrato-pix': typeof AExtratoPixIndexRoute;
  '/a/fornecedor': typeof AFornecedorIndexRoute;
  '/a/inventario': typeof AInventarioIndexRoute;
  '/a/manifesto-carga': typeof AManifestoCargaIndexRoute;
  '/a/movimentacoes': typeof AMovimentacoesIndexRoute;
  '/a/nfse': typeof ANfseIndexRoute;
  '/a/nota-fiscal': typeof ANotaFiscalIndexRoute;
  '/a/painel-gerencial': typeof APainelGerencialIndexRoute;
  '/a/produto': typeof AProdutoIndexRoute;
  '/a/regra-fiscal': typeof ARegraFiscalIndexRoute;
  '/a/romaneio': typeof ARomaneioIndexRoute;
  '/a/secundario': typeof ASecundarioIndexRoute;
  '/a/separacao': typeof ASeparacaoIndexRoute;
  '/a/servico': typeof AServicoIndexRoute;
  '/a/sped-fiscal': typeof ASpedFiscalIndexRoute;
  '/a/suporte': typeof ASuporteIndexRoute;
  '/a/transportador': typeof ATransportadorIndexRoute;
  '/a/venda-externa': typeof AVendaExternaIndexRoute;
  '/p/catalogo/$slug': typeof PCatalogoSlugIndexRoute;
  '/p/catalogo/$slug/auth': typeof PCatalogoSlugAuthRouteRouteWithChildren;
  '/a/cliente/$action/{-$idpk}': typeof AClienteActionChar123IdpkChar125Route;
  '/a/cobranca-boleto/$action/{-$idpk}': typeof ACobrancaBoletoActionChar123IdpkChar125Route;
  '/a/compra/$action/{-$idpk}': typeof ACompraActionChar123IdpkChar125Route;
  '/a/compra/clonar/$idpk': typeof ACompraClonarIdpkRoute;
  '/a/contas-pagar/$action/{-$idpk}': typeof AContasPagarActionChar123IdpkChar125Route;
  '/a/contas-receber/$action/{-$idpk}': typeof AContasReceberActionChar123IdpkChar125Route;
  '/a/contrato/$action/{-$idpk}': typeof AContratoActionChar123IdpkChar125Route;
  '/a/devolucao/$action/{-$idpk}': typeof ADevolucaoActionChar123IdpkChar125Route;
  '/a/importacao/$tipo/{-$idpk}': typeof AImportacaoTipoChar123IdpkChar125Route;
  '/a/importacao/xml/$tipo': typeof AImportacaoXmlTipoRoute;
  '/a/inventario/$action/{-$idpk}': typeof AInventarioActionChar123IdpkChar125Route;
  '/a/manifesto-carga/$action/{-$idpk}': typeof AManifestoCargaActionChar123IdpkChar125Route;
  '/a/movimentacoes/$action/{-$idpk}': typeof AMovimentacoesActionChar123IdpkChar125Route;
  '/a/movimentacoes/extrato/$idpk': typeof AMovimentacoesExtratoIdpkRoute;
  '/a/nfse/$action/{-$idpk}': typeof ANfseActionChar123IdpkChar125Route;
  '/a/nota-fiscal/$action/{-$idpk}': typeof ANotaFiscalActionChar123IdpkChar125Route;
  '/a/pagfor/$action/{-$idpk}': typeof APagforActionChar123IdpkChar125Route;
  '/a/produto/$action/{-$idpk}': typeof AProdutoActionChar123IdpkChar125Route;
  '/a/regra-fiscal/$action/{-$idpk}': typeof ARegraFiscalActionChar123IdpkChar125Route;
  '/a/relatorio/cadastro/catalogo-produtos': typeof ARelatorioCadastroCatalogoProdutosRoute;
  '/a/relatorio/cadastro/controle-lotes': typeof ARelatorioCadastroControleLotesRoute;
  '/a/relatorio/cadastro/historico-alteracoes-preco': typeof ARelatorioCadastroHistoricoAlteracoesPrecoRoute;
  '/a/relatorio/cadastro/relacao-clientes': typeof ARelatorioCadastroRelacaoClientesRoute;
  '/a/relatorio/cadastro/relacao-clientes-aniversariantes': typeof ARelatorioCadastroRelacaoClientesAniversariantesRoute;
  '/a/relatorio/cadastro/relacao-fornecedores': typeof ARelatorioCadastroRelacaoFornecedoresRoute;
  '/a/relatorio/cadastro/relacao-produtos': typeof ARelatorioCadastroRelacaoProdutosRoute;
  '/a/relatorio/cadastro/relacao-transportadores': typeof ARelatorioCadastroRelacaoTransportadoresRoute;
  '/a/relatorio/compra/compras-por-fornecedor': typeof ARelatorioCompraComprasPorFornecedorRoute;
  '/a/relatorio/estoque/estoque-minimo': typeof ARelatorioEstoqueEstoqueMinimoRoute;
  '/a/relatorio/estoque/saldos-em-estoque': typeof ARelatorioEstoqueSaldosEmEstoqueRoute;
  '/a/relatorio/financeiro/balancete': typeof ARelatorioFinanceiroBalanceteRoute;
  '/a/relatorio/financeiro/boletos-recebidos': typeof ARelatorioFinanceiroBoletosRecebidosRoute;
  '/a/relatorio/financeiro/contas-pagar': typeof ARelatorioFinanceiroContasPagarRoute;
  '/a/relatorio/financeiro/contas-receber': typeof ARelatorioFinanceiroContasReceberRoute;
  '/a/relatorio/financeiro/contas-recebidas': typeof ARelatorioFinanceiroContasRecebidasRoute;
  '/a/relatorio/financeiro/dre': typeof ARelatorioFinanceiroDreRoute;
  '/a/relatorio/financeiro/entradas-saidas': typeof ARelatorioFinanceiroEntradasSaidasRoute;
  '/a/relatorio/financeiro/fluxo-caixa': typeof ARelatorioFinanceiroFluxoCaixaRoute;
  '/a/relatorio/financeiro/lancamentos-contas-receber': typeof ARelatorioFinanceiroLancamentosContasReceberRoute;
  '/a/relatorio/financeiro/pagamentos': typeof ARelatorioFinanceiroPagamentosRoute;
  '/a/relatorio/financeiro/relacao-boletos': typeof ARelatorioFinanceiroRelacaoBoletosRoute;
  '/a/relatorio/financeiro/totais-por-categoria': typeof ARelatorioFinanceiroTotaisPorCategoriaRoute;
  '/a/relatorio/fiscal/itens-notas-fiscais': typeof ARelatorioFiscalItensNotasFiscaisRoute;
  '/a/relatorio/fiscal/notas-fiscais-cliente': typeof ARelatorioFiscalNotasFiscaisClienteRoute;
  '/a/relatorio/fiscal/notas-fiscais-produto': typeof ARelatorioFiscalNotasFiscaisProdutoRoute;
  '/a/relatorio/fiscal/notas-fiscais-tipo': typeof ARelatorioFiscalNotasFiscaisTipoRoute;
  '/a/relatorio/fiscal/relacao-documentos': typeof ARelatorioFiscalRelacaoDocumentosRoute;
  '/a/relatorio/fiscal/relacao-sequencias-inutilizadas': typeof ARelatorioFiscalRelacaoSequenciasInutilizadasRoute;
  '/a/relatorio/fiscal/total-agrupado-cfop': typeof ARelatorioFiscalTotalAgrupadoCfopRoute;
  '/a/relatorio/fiscal/total-agrupado-forma-pagamento': typeof ARelatorioFiscalTotalAgrupadoFormaPagamentoRoute;
  '/a/relatorio/fiscal/total-agrupado-ncm': typeof ARelatorioFiscalTotalAgrupadoNcmRoute;
  '/a/relatorio/venda/comissoes': typeof ARelatorioVendaComissoesRoute;
  '/a/relatorio/venda/produtos-mais-vendidos': typeof ARelatorioVendaProdutosMaisVendidosRoute;
  '/a/relatorio/venda/relacao-vendas': typeof ARelatorioVendaRelacaoVendasRoute;
  '/a/relatorio/venda/relacao-vendas-produto': typeof ARelatorioVendaRelacaoVendasProdutoRoute;
  '/a/relatorio/venda/relacao-vendas-resumido': typeof ARelatorioVendaRelacaoVendasResumidoRoute;
  '/a/relatorio/venda/total-forma-pagamento': typeof ARelatorioVendaTotalFormaPagamentoRoute;
  '/a/relatorio/venda/vendas-cliente': typeof ARelatorioVendaVendasClienteRoute;
  '/a/relatorio/venda/vendas-vendedor': typeof ARelatorioVendaVendasVendedorRoute;
  '/a/renegociacao/contas-pagar/cadastrar': typeof ARenegociacaoContasPagarCadastrarRoute;
  '/a/renegociacao/contas-receber/cadastrar': typeof ARenegociacaoContasReceberCadastrarRoute;
  '/a/romaneio/$action/{-$idpk}': typeof ARomaneioActionChar123IdpkChar125Route;
  '/a/separacao/$type/$idpk': typeof ASeparacaoTypeIdpkRoute;
  '/a/servico/$action/{-$idpk}': typeof AServicoActionChar123IdpkChar125Route;
  '/a/sped-fiscal/$action/{-$idpk}': typeof ASpedFiscalActionChar123IdpkChar125Route;
  '/a/transportador/$action/{-$idpk}': typeof ATransportadorActionChar123IdpkChar125Route;
  '/a/venda-externa/$action/{-$idpk}': typeof AVendaExternaActionChar123IdpkChar125Route;
  '/a/venda/$action/$idpk': typeof AVendaActionIdpkRoute;
  '/a/venda/cadastrar/$tipo': typeof AVendaCadastrarTipoRoute;
  '/admin/configuracao/representante': typeof AdminAConfiguracaoRepresentanteRoute;
  '/p/conta-digital/termos-de-uso/$base64': typeof PContaDigitalTermosDeUsoBase64Route;
  '/a/configuracao/empresa': typeof AConfiguracaoEmpresaIndexRoute;
  '/a/relatorio/cadastro': typeof ARelatorioCadastroIndexRoute;
  '/a/relatorio/compra': typeof ARelatorioCompraIndexRoute;
  '/a/relatorio/estoque': typeof ARelatorioEstoqueIndexRoute;
  '/a/relatorio/financeiro': typeof ARelatorioFinanceiroIndexRoute;
  '/a/relatorio/fiscal': typeof ARelatorioFiscalIndexRoute;
  '/a/relatorio/venda': typeof ARelatorioVendaIndexRoute;
  '/a/renegociacao/contas-pagar': typeof ARenegociacaoContasPagarIndexRoute;
  '/a/renegociacao/contas-receber': typeof ARenegociacaoContasReceberIndexRoute;
  '/a/venda/$tipo': typeof AVendaTipoIndexRoute;
  '/p/pagamento/$id': typeof PPagamentoIdIndexRoute;
  '/p/catalogo/$slug/usuario': typeof PCatalogoSlugDefaultUsuarioRouteRouteWithChildren;
  '/a/romaneio/impressao/carga/$idpk': typeof ARomaneioImpressaoCargaIdpkRoute;
  '/a/romaneio/impressao/entrega/$idpk': typeof ARomaneioImpressaoEntregaIdpkRoute;
  '/a/romaneio/impressao/padrao/$idpk': typeof ARomaneioImpressaoPadraoIdpkRoute;
  '/a/venda/clonar/$tipo/$idpk': typeof AVendaClonarTipoIdpkRoute;
  '/admin/empresa/$action/{-$idpk}': typeof AdminAEmpresaActionChar123IdpkChar125Route;
  '/p/catalogo/$slug/finalizar': typeof PCatalogoSlugDefaultFinalizarRoute;
  '/p/catalogo/$slug/produtos': typeof PCatalogoSlugDefaultProdutosRoute;
  '/p/catalogo/$slug/auth/cadastrar': typeof PCatalogoSlugAuthCadastrarRoute;
  '/p/catalogo/$slug/auth/entrar': typeof PCatalogoSlugAuthEntrarRoute;
  '/p/catalogo/$slug/auth/recuperar-senha': typeof PCatalogoSlugAuthRecuperarSenhaRoute;
  '/p/catalogo/$slug/auth/validar-codigo': typeof PCatalogoSlugAuthValidarCodigoRoute;
  '/p/catalogo/$slug/usuario/perfil': typeof PCatalogoSlugDefaultUsuarioPerfilRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/a': typeof ARouteRouteWithChildren;
  '/admin': typeof AdminRouteRouteWithChildren;
  '/auth': typeof AuthRouteRouteWithChildren;
  '/a/cliente': typeof AClienteRouteRouteWithChildren;
  '/a/cobranca-boleto': typeof ACobrancaBoletoRouteRouteWithChildren;
  '/a/cobranca-cartao': typeof ACobrancaCartaoRouteRouteWithChildren;
  '/a/cobranca-pix': typeof ACobrancaPixRouteRouteWithChildren;
  '/a/comissao': typeof AComissaoRouteRouteWithChildren;
  '/a/compra': typeof ACompraRouteRouteWithChildren;
  '/a/contas-pagar': typeof AContasPagarRouteRouteWithChildren;
  '/a/contas-receber': typeof AContasReceberRouteRouteWithChildren;
  '/a/cupom-fiscal': typeof ACupomFiscalRouteRouteWithChildren;
  '/a/debug': typeof ADebugRouteRouteWithChildren;
  '/a/devolucao': typeof ADevolucaoRouteRouteWithChildren;
  '/a/estoque': typeof AEstoqueRouteRouteWithChildren;
  '/a/extrato-boleto': typeof AExtratoBoletoRouteRouteWithChildren;
  '/a/extrato-pix': typeof AExtratoPixRouteRouteWithChildren;
  '/a/fornecedor': typeof AFornecedorRouteRouteWithChildren;
  '/a/manifesto-carga': typeof AManifestoCargaRouteRouteWithChildren;
  '/a/movimentacoes': typeof AMovimentacoesRouteRouteWithChildren;
  '/a/nfse': typeof ANfseRouteRouteWithChildren;
  '/a/nota-fiscal': typeof ANotaFiscalRouteRouteWithChildren;
  '/a/notificacao': typeof ANotificacaoRouteRouteWithChildren;
  '/a/pagfor': typeof APagforRouteRouteWithChildren;
  '/a/produto': typeof AProdutoRouteRouteWithChildren;
  '/a/regra-fiscal': typeof ARegraFiscalRouteRouteWithChildren;
  '/a/romaneio': typeof ARomaneioRouteRouteWithChildren;
  '/a/secundario': typeof ASecundarioRouteRouteWithChildren;
  '/a/servico': typeof AServicoRouteRouteWithChildren;
  '/a/sped-fiscal': typeof ASpedFiscalRouteRouteWithChildren;
  '/a/transportador': typeof ATransportadorRouteRouteWithChildren;
  '/a/venda': typeof AVendaRouteRouteWithChildren;
  '/a/venda-externa': typeof AVendaExternaRouteRouteWithChildren;
  '/admin/_a': typeof AdminARouteRouteWithChildren;
  '/a/pdv': typeof APdvRoute;
  '/admin/auth': typeof AdminAuthRouteWithChildren;
  '/auth/acesso-negado': typeof AuthAcessoNegadoRoute;
  '/auth/cadastro': typeof AuthCadastroRoute;
  '/auth/cadastro-fim': typeof AuthCadastroFimRoute;
  '/auth/conta-bloqueada': typeof AuthContaBloqueadaRoute;
  '/auth/login': typeof AuthLoginRoute;
  '/auth/login-adm': typeof AuthLoginAdmRoute;
  '/auth/login-automatico': typeof AuthLoginAutomaticoRoute;
  '/auth/recuperar-senha': typeof AuthRecuperarSenhaRoute;
  '/auth/redefinir-senha': typeof AuthRedefinirSenhaRoute;
  '/p/erro': typeof PErroRoute;
  '/a/configuracao/empresa': typeof AConfiguracaoEmpresaRouteRouteWithChildren;
  '/a/relatorio/cadastro': typeof ARelatorioCadastroRouteRouteWithChildren;
  '/a/relatorio/compra': typeof ARelatorioCompraRouteRouteWithChildren;
  '/a/relatorio/estoque': typeof ARelatorioEstoqueRouteRouteWithChildren;
  '/a/relatorio/financeiro': typeof ARelatorioFinanceiroRouteRouteWithChildren;
  '/a/relatorio/fiscal': typeof ARelatorioFiscalRouteRouteWithChildren;
  '/a/relatorio/venda': typeof ARelatorioVendaRouteRouteWithChildren;
  '/a/renegociacao/contas-pagar': typeof ARenegociacaoContasPagarRouteRouteWithChildren;
  '/a/renegociacao/contas-receber': typeof ARenegociacaoContasReceberRouteRouteWithChildren;
  '/p/catalogo/$slug': typeof PCatalogoSlugRouteRouteWithChildren;
  '/a/cobranca-boleto/rotinas-bancarias': typeof ACobrancaBoletoRotinasBancariasRoute;
  '/a/cobranca-cartao/cadastrar': typeof ACobrancaCartaoCadastrarRoute;
  '/a/compra/compra': typeof ACompraCompraRoute;
  '/a/compra/importacao-nfe': typeof ACompraImportacaoNfeRoute;
  '/a/compra/manifestador': typeof ACompraManifestadorRoute;
  '/a/configuracao/usuario': typeof AConfiguracaoUsuarioRoute;
  '/a/estoque/conferencia': typeof AEstoqueConferenciaRoute;
  '/a/estoque/movimentacao': typeof AEstoqueMovimentacaoRoute;
  '/a/impressao/$filetype': typeof AImpressaoFiletypeRoute;
  '/a/nota-fiscal/cadastrar': typeof ANotaFiscalCadastrarRoute;
  '/a/notificacao/listagem': typeof ANotificacaoListagemRoute;
  '/a/pagfor/importar': typeof APagforImportarRoute;
  '/a/pagfor/listagem': typeof APagforListagemRoute;
  '/a/personalizacoes/comandos': typeof APersonalizacoesComandosRoute;
  '/a/personalizacoes/consultas': typeof APersonalizacoesConsultasRoute;
  '/a/separacao/monitor': typeof ASeparacaoMonitorRoute;
  '/a/suporte/instrucoes-de-uso': typeof ASuporteInstrucoesDeUsoRoute;
  '/admin/_a/empresa': typeof AdminAEmpresaRoute;
  '/admin/_a/erro': typeof AdminAErroRoute;
  '/admin/_a/representante': typeof AdminARepresentanteRoute;
  '/admin/_a/sql': typeof AdminASqlRoute;
  '/admin/_a/sql-editor': typeof AdminASqlEditorRoute;
  '/admin/auth/login': typeof AdminAuthLoginRoute;
  '/p/cliente/$slug': typeof PClienteSlugRoute;
  '/p/compartilhamento/$id': typeof PCompartilhamentoIdRoute;
  '/p/contrato/$id': typeof PContratoIdRoute;
  '/p/impressao/$filetype': typeof PImpressaoFiletypeRoute;
  '/a/cliente/': typeof AClienteIndexRoute;
  '/a/cobranca-boleto/': typeof ACobrancaBoletoIndexRoute;
  '/a/cobranca-cartao/': typeof ACobrancaCartaoIndexRoute;
  '/a/cobranca-pix/': typeof ACobrancaPixIndexRoute;
  '/a/comissao/': typeof AComissaoIndexRoute;
  '/a/contas-pagar/': typeof AContasPagarIndexRoute;
  '/a/contas-receber/': typeof AContasReceberIndexRoute;
  '/a/contrato/': typeof AContratoIndexRoute;
  '/a/cupom-fiscal/': typeof ACupomFiscalIndexRoute;
  '/a/debug/': typeof ADebugIndexRoute;
  '/a/devolucao/': typeof ADevolucaoIndexRoute;
  '/a/extrato-boleto/': typeof AExtratoBoletoIndexRoute;
  '/a/extrato-pix/': typeof AExtratoPixIndexRoute;
  '/a/fornecedor/': typeof AFornecedorIndexRoute;
  '/a/inventario/': typeof AInventarioIndexRoute;
  '/a/manifesto-carga/': typeof AManifestoCargaIndexRoute;
  '/a/movimentacoes/': typeof AMovimentacoesIndexRoute;
  '/a/nfse/': typeof ANfseIndexRoute;
  '/a/nota-fiscal/': typeof ANotaFiscalIndexRoute;
  '/a/painel-gerencial/': typeof APainelGerencialIndexRoute;
  '/a/produto/': typeof AProdutoIndexRoute;
  '/a/regra-fiscal/': typeof ARegraFiscalIndexRoute;
  '/a/romaneio/': typeof ARomaneioIndexRoute;
  '/a/secundario/': typeof ASecundarioIndexRoute;
  '/a/separacao/': typeof ASeparacaoIndexRoute;
  '/a/servico/': typeof AServicoIndexRoute;
  '/a/sped-fiscal/': typeof ASpedFiscalIndexRoute;
  '/a/suporte/': typeof ASuporteIndexRoute;
  '/a/transportador/': typeof ATransportadorIndexRoute;
  '/a/venda-externa/': typeof AVendaExternaIndexRoute;
  '/p/catalogo/$slug/_default': typeof PCatalogoSlugDefaultRouteRouteWithChildren;
  '/p/catalogo/$slug/auth': typeof PCatalogoSlugAuthRouteRouteWithChildren;
  '/a/cliente/$action/{-$idpk}': typeof AClienteActionChar123IdpkChar125Route;
  '/a/cobranca-boleto/$action/{-$idpk}': typeof ACobrancaBoletoActionChar123IdpkChar125Route;
  '/a/compra/$action/{-$idpk}': typeof ACompraActionChar123IdpkChar125Route;
  '/a/compra/clonar/$idpk': typeof ACompraClonarIdpkRoute;
  '/a/contas-pagar/$action/{-$idpk}': typeof AContasPagarActionChar123IdpkChar125Route;
  '/a/contas-receber/$action/{-$idpk}': typeof AContasReceberActionChar123IdpkChar125Route;
  '/a/contrato/$action/{-$idpk}': typeof AContratoActionChar123IdpkChar125Route;
  '/a/devolucao/$action/{-$idpk}': typeof ADevolucaoActionChar123IdpkChar125Route;
  '/a/importacao/$tipo/{-$idpk}': typeof AImportacaoTipoChar123IdpkChar125Route;
  '/a/importacao/xml/$tipo': typeof AImportacaoXmlTipoRoute;
  '/a/inventario/$action/{-$idpk}': typeof AInventarioActionChar123IdpkChar125Route;
  '/a/manifesto-carga/$action/{-$idpk}': typeof AManifestoCargaActionChar123IdpkChar125Route;
  '/a/movimentacoes/$action/{-$idpk}': typeof AMovimentacoesActionChar123IdpkChar125Route;
  '/a/movimentacoes/extrato/$idpk': typeof AMovimentacoesExtratoIdpkRoute;
  '/a/nfse/$action/{-$idpk}': typeof ANfseActionChar123IdpkChar125Route;
  '/a/nota-fiscal/$action/{-$idpk}': typeof ANotaFiscalActionChar123IdpkChar125Route;
  '/a/pagfor/$action/{-$idpk}': typeof APagforActionChar123IdpkChar125Route;
  '/a/produto/$action/{-$idpk}': typeof AProdutoActionChar123IdpkChar125Route;
  '/a/regra-fiscal/$action/{-$idpk}': typeof ARegraFiscalActionChar123IdpkChar125Route;
  '/a/relatorio/cadastro/catalogo-produtos': typeof ARelatorioCadastroCatalogoProdutosRoute;
  '/a/relatorio/cadastro/controle-lotes': typeof ARelatorioCadastroControleLotesRoute;
  '/a/relatorio/cadastro/historico-alteracoes-preco': typeof ARelatorioCadastroHistoricoAlteracoesPrecoRoute;
  '/a/relatorio/cadastro/relacao-clientes': typeof ARelatorioCadastroRelacaoClientesRoute;
  '/a/relatorio/cadastro/relacao-clientes-aniversariantes': typeof ARelatorioCadastroRelacaoClientesAniversariantesRoute;
  '/a/relatorio/cadastro/relacao-fornecedores': typeof ARelatorioCadastroRelacaoFornecedoresRoute;
  '/a/relatorio/cadastro/relacao-produtos': typeof ARelatorioCadastroRelacaoProdutosRoute;
  '/a/relatorio/cadastro/relacao-transportadores': typeof ARelatorioCadastroRelacaoTransportadoresRoute;
  '/a/relatorio/compra/compras-por-fornecedor': typeof ARelatorioCompraComprasPorFornecedorRoute;
  '/a/relatorio/estoque/estoque-minimo': typeof ARelatorioEstoqueEstoqueMinimoRoute;
  '/a/relatorio/estoque/saldos-em-estoque': typeof ARelatorioEstoqueSaldosEmEstoqueRoute;
  '/a/relatorio/financeiro/balancete': typeof ARelatorioFinanceiroBalanceteRoute;
  '/a/relatorio/financeiro/boletos-recebidos': typeof ARelatorioFinanceiroBoletosRecebidosRoute;
  '/a/relatorio/financeiro/contas-pagar': typeof ARelatorioFinanceiroContasPagarRoute;
  '/a/relatorio/financeiro/contas-receber': typeof ARelatorioFinanceiroContasReceberRoute;
  '/a/relatorio/financeiro/contas-recebidas': typeof ARelatorioFinanceiroContasRecebidasRoute;
  '/a/relatorio/financeiro/dre': typeof ARelatorioFinanceiroDreRoute;
  '/a/relatorio/financeiro/entradas-saidas': typeof ARelatorioFinanceiroEntradasSaidasRoute;
  '/a/relatorio/financeiro/fluxo-caixa': typeof ARelatorioFinanceiroFluxoCaixaRoute;
  '/a/relatorio/financeiro/lancamentos-contas-receber': typeof ARelatorioFinanceiroLancamentosContasReceberRoute;
  '/a/relatorio/financeiro/pagamentos': typeof ARelatorioFinanceiroPagamentosRoute;
  '/a/relatorio/financeiro/relacao-boletos': typeof ARelatorioFinanceiroRelacaoBoletosRoute;
  '/a/relatorio/financeiro/totais-por-categoria': typeof ARelatorioFinanceiroTotaisPorCategoriaRoute;
  '/a/relatorio/fiscal/itens-notas-fiscais': typeof ARelatorioFiscalItensNotasFiscaisRoute;
  '/a/relatorio/fiscal/notas-fiscais-cliente': typeof ARelatorioFiscalNotasFiscaisClienteRoute;
  '/a/relatorio/fiscal/notas-fiscais-produto': typeof ARelatorioFiscalNotasFiscaisProdutoRoute;
  '/a/relatorio/fiscal/notas-fiscais-tipo': typeof ARelatorioFiscalNotasFiscaisTipoRoute;
  '/a/relatorio/fiscal/relacao-documentos': typeof ARelatorioFiscalRelacaoDocumentosRoute;
  '/a/relatorio/fiscal/relacao-sequencias-inutilizadas': typeof ARelatorioFiscalRelacaoSequenciasInutilizadasRoute;
  '/a/relatorio/fiscal/total-agrupado-cfop': typeof ARelatorioFiscalTotalAgrupadoCfopRoute;
  '/a/relatorio/fiscal/total-agrupado-forma-pagamento': typeof ARelatorioFiscalTotalAgrupadoFormaPagamentoRoute;
  '/a/relatorio/fiscal/total-agrupado-ncm': typeof ARelatorioFiscalTotalAgrupadoNcmRoute;
  '/a/relatorio/venda/comissoes': typeof ARelatorioVendaComissoesRoute;
  '/a/relatorio/venda/produtos-mais-vendidos': typeof ARelatorioVendaProdutosMaisVendidosRoute;
  '/a/relatorio/venda/relacao-vendas': typeof ARelatorioVendaRelacaoVendasRoute;
  '/a/relatorio/venda/relacao-vendas-produto': typeof ARelatorioVendaRelacaoVendasProdutoRoute;
  '/a/relatorio/venda/relacao-vendas-resumido': typeof ARelatorioVendaRelacaoVendasResumidoRoute;
  '/a/relatorio/venda/total-forma-pagamento': typeof ARelatorioVendaTotalFormaPagamentoRoute;
  '/a/relatorio/venda/vendas-cliente': typeof ARelatorioVendaVendasClienteRoute;
  '/a/relatorio/venda/vendas-vendedor': typeof ARelatorioVendaVendasVendedorRoute;
  '/a/renegociacao/contas-pagar/cadastrar': typeof ARenegociacaoContasPagarCadastrarRoute;
  '/a/renegociacao/contas-receber/cadastrar': typeof ARenegociacaoContasReceberCadastrarRoute;
  '/a/romaneio/$action/{-$idpk}': typeof ARomaneioActionChar123IdpkChar125Route;
  '/a/separacao/$type/$idpk': typeof ASeparacaoTypeIdpkRoute;
  '/a/servico/$action/{-$idpk}': typeof AServicoActionChar123IdpkChar125Route;
  '/a/sped-fiscal/$action/{-$idpk}': typeof ASpedFiscalActionChar123IdpkChar125Route;
  '/a/transportador/$action/{-$idpk}': typeof ATransportadorActionChar123IdpkChar125Route;
  '/a/venda-externa/$action/{-$idpk}': typeof AVendaExternaActionChar123IdpkChar125Route;
  '/a/venda/$action/$idpk': typeof AVendaActionIdpkRoute;
  '/a/venda/cadastrar/$tipo': typeof AVendaCadastrarTipoRoute;
  '/admin/_a/configuracao/representante': typeof AdminAConfiguracaoRepresentanteRoute;
  '/p/conta-digital/termos-de-uso/$base64': typeof PContaDigitalTermosDeUsoBase64Route;
  '/a/configuracao/empresa/': typeof AConfiguracaoEmpresaIndexRoute;
  '/a/relatorio/cadastro/': typeof ARelatorioCadastroIndexRoute;
  '/a/relatorio/compra/': typeof ARelatorioCompraIndexRoute;
  '/a/relatorio/estoque/': typeof ARelatorioEstoqueIndexRoute;
  '/a/relatorio/financeiro/': typeof ARelatorioFinanceiroIndexRoute;
  '/a/relatorio/fiscal/': typeof ARelatorioFiscalIndexRoute;
  '/a/relatorio/venda/': typeof ARelatorioVendaIndexRoute;
  '/a/renegociacao/contas-pagar/': typeof ARenegociacaoContasPagarIndexRoute;
  '/a/renegociacao/contas-receber/': typeof ARenegociacaoContasReceberIndexRoute;
  '/a/venda/$tipo/': typeof AVendaTipoIndexRoute;
  '/p/catalogo/$slug/': typeof PCatalogoSlugIndexRoute;
  '/p/pagamento/$id/': typeof PPagamentoIdIndexRoute;
  '/p/catalogo/$slug/_default/usuario': typeof PCatalogoSlugDefaultUsuarioRouteRouteWithChildren;
  '/a/romaneio/impressao/carga/$idpk': typeof ARomaneioImpressaoCargaIdpkRoute;
  '/a/romaneio/impressao/entrega/$idpk': typeof ARomaneioImpressaoEntregaIdpkRoute;
  '/a/romaneio/impressao/padrao/$idpk': typeof ARomaneioImpressaoPadraoIdpkRoute;
  '/a/venda/clonar/$tipo/$idpk': typeof AVendaClonarTipoIdpkRoute;
  '/admin/_a/empresa_/$action/{-$idpk}': typeof AdminAEmpresaActionChar123IdpkChar125Route;
  '/p/catalogo/$slug/_default/finalizar': typeof PCatalogoSlugDefaultFinalizarRoute;
  '/p/catalogo/$slug/_default/produtos': typeof PCatalogoSlugDefaultProdutosRoute;
  '/p/catalogo/$slug/auth/cadastrar': typeof PCatalogoSlugAuthCadastrarRoute;
  '/p/catalogo/$slug/auth/entrar': typeof PCatalogoSlugAuthEntrarRoute;
  '/p/catalogo/$slug/auth/recuperar-senha': typeof PCatalogoSlugAuthRecuperarSenhaRoute;
  '/p/catalogo/$slug/auth/validar-codigo': typeof PCatalogoSlugAuthValidarCodigoRoute;
  '/p/catalogo/$slug/_default/usuario/perfil': typeof PCatalogoSlugDefaultUsuarioPerfilRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/a'
    | '/admin'
    | '/auth'
    | '/a/cliente'
    | '/a/cobranca-boleto'
    | '/a/cobranca-cartao'
    | '/a/cobranca-pix'
    | '/a/comissao'
    | '/a/compra'
    | '/a/contas-pagar'
    | '/a/contas-receber'
    | '/a/cupom-fiscal'
    | '/a/debug'
    | '/a/devolucao'
    | '/a/estoque'
    | '/a/extrato-boleto'
    | '/a/extrato-pix'
    | '/a/fornecedor'
    | '/a/manifesto-carga'
    | '/a/movimentacoes'
    | '/a/nfse'
    | '/a/nota-fiscal'
    | '/a/notificacao'
    | '/a/pagfor'
    | '/a/produto'
    | '/a/regra-fiscal'
    | '/a/romaneio'
    | '/a/secundario'
    | '/a/servico'
    | '/a/sped-fiscal'
    | '/a/transportador'
    | '/a/venda'
    | '/a/venda-externa'
    | '/a/pdv'
    | '/admin/auth'
    | '/auth/acesso-negado'
    | '/auth/cadastro'
    | '/auth/cadastro-fim'
    | '/auth/conta-bloqueada'
    | '/auth/login'
    | '/auth/login-adm'
    | '/auth/login-automatico'
    | '/auth/recuperar-senha'
    | '/auth/redefinir-senha'
    | '/p/erro'
    | '/a/configuracao/empresa'
    | '/a/relatorio/cadastro'
    | '/a/relatorio/compra'
    | '/a/relatorio/estoque'
    | '/a/relatorio/financeiro'
    | '/a/relatorio/fiscal'
    | '/a/relatorio/venda'
    | '/a/renegociacao/contas-pagar'
    | '/a/renegociacao/contas-receber'
    | '/p/catalogo/$slug'
    | '/a/cobranca-boleto/rotinas-bancarias'
    | '/a/cobranca-cartao/cadastrar'
    | '/a/compra/compra'
    | '/a/compra/importacao-nfe'
    | '/a/compra/manifestador'
    | '/a/configuracao/usuario'
    | '/a/estoque/conferencia'
    | '/a/estoque/movimentacao'
    | '/a/impressao/$filetype'
    | '/a/nota-fiscal/cadastrar'
    | '/a/notificacao/listagem'
    | '/a/pagfor/importar'
    | '/a/pagfor/listagem'
    | '/a/personalizacoes/comandos'
    | '/a/personalizacoes/consultas'
    | '/a/separacao/monitor'
    | '/a/suporte/instrucoes-de-uso'
    | '/admin/empresa'
    | '/admin/erro'
    | '/admin/representante'
    | '/admin/sql'
    | '/admin/sql-editor'
    | '/admin/auth/login'
    | '/p/cliente/$slug'
    | '/p/compartilhamento/$id'
    | '/p/contrato/$id'
    | '/p/impressao/$filetype'
    | '/a/cliente/'
    | '/a/cobranca-boleto/'
    | '/a/cobranca-cartao/'
    | '/a/cobranca-pix/'
    | '/a/comissao/'
    | '/a/contas-pagar/'
    | '/a/contas-receber/'
    | '/a/contrato/'
    | '/a/cupom-fiscal/'
    | '/a/debug/'
    | '/a/devolucao/'
    | '/a/extrato-boleto/'
    | '/a/extrato-pix/'
    | '/a/fornecedor/'
    | '/a/inventario/'
    | '/a/manifesto-carga/'
    | '/a/movimentacoes/'
    | '/a/nfse/'
    | '/a/nota-fiscal/'
    | '/a/painel-gerencial/'
    | '/a/produto/'
    | '/a/regra-fiscal/'
    | '/a/romaneio/'
    | '/a/secundario/'
    | '/a/separacao/'
    | '/a/servico/'
    | '/a/sped-fiscal/'
    | '/a/suporte/'
    | '/a/transportador/'
    | '/a/venda-externa/'
    | '/p/catalogo/$slug/auth'
    | '/a/cliente/$action/{-$idpk}'
    | '/a/cobranca-boleto/$action/{-$idpk}'
    | '/a/compra/$action/{-$idpk}'
    | '/a/compra/clonar/$idpk'
    | '/a/contas-pagar/$action/{-$idpk}'
    | '/a/contas-receber/$action/{-$idpk}'
    | '/a/contrato/$action/{-$idpk}'
    | '/a/devolucao/$action/{-$idpk}'
    | '/a/importacao/$tipo/{-$idpk}'
    | '/a/importacao/xml/$tipo'
    | '/a/inventario/$action/{-$idpk}'
    | '/a/manifesto-carga/$action/{-$idpk}'
    | '/a/movimentacoes/$action/{-$idpk}'
    | '/a/movimentacoes/extrato/$idpk'
    | '/a/nfse/$action/{-$idpk}'
    | '/a/nota-fiscal/$action/{-$idpk}'
    | '/a/pagfor/$action/{-$idpk}'
    | '/a/produto/$action/{-$idpk}'
    | '/a/regra-fiscal/$action/{-$idpk}'
    | '/a/relatorio/cadastro/catalogo-produtos'
    | '/a/relatorio/cadastro/controle-lotes'
    | '/a/relatorio/cadastro/historico-alteracoes-preco'
    | '/a/relatorio/cadastro/relacao-clientes'
    | '/a/relatorio/cadastro/relacao-clientes-aniversariantes'
    | '/a/relatorio/cadastro/relacao-fornecedores'
    | '/a/relatorio/cadastro/relacao-produtos'
    | '/a/relatorio/cadastro/relacao-transportadores'
    | '/a/relatorio/compra/compras-por-fornecedor'
    | '/a/relatorio/estoque/estoque-minimo'
    | '/a/relatorio/estoque/saldos-em-estoque'
    | '/a/relatorio/financeiro/balancete'
    | '/a/relatorio/financeiro/boletos-recebidos'
    | '/a/relatorio/financeiro/contas-pagar'
    | '/a/relatorio/financeiro/contas-receber'
    | '/a/relatorio/financeiro/contas-recebidas'
    | '/a/relatorio/financeiro/dre'
    | '/a/relatorio/financeiro/entradas-saidas'
    | '/a/relatorio/financeiro/fluxo-caixa'
    | '/a/relatorio/financeiro/lancamentos-contas-receber'
    | '/a/relatorio/financeiro/pagamentos'
    | '/a/relatorio/financeiro/relacao-boletos'
    | '/a/relatorio/financeiro/totais-por-categoria'
    | '/a/relatorio/fiscal/itens-notas-fiscais'
    | '/a/relatorio/fiscal/notas-fiscais-cliente'
    | '/a/relatorio/fiscal/notas-fiscais-produto'
    | '/a/relatorio/fiscal/notas-fiscais-tipo'
    | '/a/relatorio/fiscal/relacao-documentos'
    | '/a/relatorio/fiscal/relacao-sequencias-inutilizadas'
    | '/a/relatorio/fiscal/total-agrupado-cfop'
    | '/a/relatorio/fiscal/total-agrupado-forma-pagamento'
    | '/a/relatorio/fiscal/total-agrupado-ncm'
    | '/a/relatorio/venda/comissoes'
    | '/a/relatorio/venda/produtos-mais-vendidos'
    | '/a/relatorio/venda/relacao-vendas'
    | '/a/relatorio/venda/relacao-vendas-produto'
    | '/a/relatorio/venda/relacao-vendas-resumido'
    | '/a/relatorio/venda/total-forma-pagamento'
    | '/a/relatorio/venda/vendas-cliente'
    | '/a/relatorio/venda/vendas-vendedor'
    | '/a/renegociacao/contas-pagar/cadastrar'
    | '/a/renegociacao/contas-receber/cadastrar'
    | '/a/romaneio/$action/{-$idpk}'
    | '/a/separacao/$type/$idpk'
    | '/a/servico/$action/{-$idpk}'
    | '/a/sped-fiscal/$action/{-$idpk}'
    | '/a/transportador/$action/{-$idpk}'
    | '/a/venda-externa/$action/{-$idpk}'
    | '/a/venda/$action/$idpk'
    | '/a/venda/cadastrar/$tipo'
    | '/admin/configuracao/representante'
    | '/p/conta-digital/termos-de-uso/$base64'
    | '/a/configuracao/empresa/'
    | '/a/relatorio/cadastro/'
    | '/a/relatorio/compra/'
    | '/a/relatorio/estoque/'
    | '/a/relatorio/financeiro/'
    | '/a/relatorio/fiscal/'
    | '/a/relatorio/venda/'
    | '/a/renegociacao/contas-pagar/'
    | '/a/renegociacao/contas-receber/'
    | '/a/venda/$tipo/'
    | '/p/catalogo/$slug/'
    | '/p/pagamento/$id/'
    | '/p/catalogo/$slug/usuario'
    | '/a/romaneio/impressao/carga/$idpk'
    | '/a/romaneio/impressao/entrega/$idpk'
    | '/a/romaneio/impressao/padrao/$idpk'
    | '/a/venda/clonar/$tipo/$idpk'
    | '/admin/empresa/$action/{-$idpk}'
    | '/p/catalogo/$slug/finalizar'
    | '/p/catalogo/$slug/produtos'
    | '/p/catalogo/$slug/auth/cadastrar'
    | '/p/catalogo/$slug/auth/entrar'
    | '/p/catalogo/$slug/auth/recuperar-senha'
    | '/p/catalogo/$slug/auth/validar-codigo'
    | '/p/catalogo/$slug/usuario/perfil';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/a'
    | '/admin'
    | '/auth'
    | '/a/compra'
    | '/a/estoque'
    | '/a/notificacao'
    | '/a/pagfor'
    | '/a/venda'
    | '/a/pdv'
    | '/admin/auth'
    | '/auth/acesso-negado'
    | '/auth/cadastro'
    | '/auth/cadastro-fim'
    | '/auth/conta-bloqueada'
    | '/auth/login'
    | '/auth/login-adm'
    | '/auth/login-automatico'
    | '/auth/recuperar-senha'
    | '/auth/redefinir-senha'
    | '/p/erro'
    | '/a/cobranca-boleto/rotinas-bancarias'
    | '/a/cobranca-cartao/cadastrar'
    | '/a/compra/compra'
    | '/a/compra/importacao-nfe'
    | '/a/compra/manifestador'
    | '/a/configuracao/usuario'
    | '/a/estoque/conferencia'
    | '/a/estoque/movimentacao'
    | '/a/impressao/$filetype'
    | '/a/nota-fiscal/cadastrar'
    | '/a/notificacao/listagem'
    | '/a/pagfor/importar'
    | '/a/pagfor/listagem'
    | '/a/personalizacoes/comandos'
    | '/a/personalizacoes/consultas'
    | '/a/separacao/monitor'
    | '/a/suporte/instrucoes-de-uso'
    | '/admin/empresa'
    | '/admin/erro'
    | '/admin/representante'
    | '/admin/sql'
    | '/admin/sql-editor'
    | '/admin/auth/login'
    | '/p/cliente/$slug'
    | '/p/compartilhamento/$id'
    | '/p/contrato/$id'
    | '/p/impressao/$filetype'
    | '/a/cliente'
    | '/a/cobranca-boleto'
    | '/a/cobranca-cartao'
    | '/a/cobranca-pix'
    | '/a/comissao'
    | '/a/contas-pagar'
    | '/a/contas-receber'
    | '/a/contrato'
    | '/a/cupom-fiscal'
    | '/a/debug'
    | '/a/devolucao'
    | '/a/extrato-boleto'
    | '/a/extrato-pix'
    | '/a/fornecedor'
    | '/a/inventario'
    | '/a/manifesto-carga'
    | '/a/movimentacoes'
    | '/a/nfse'
    | '/a/nota-fiscal'
    | '/a/painel-gerencial'
    | '/a/produto'
    | '/a/regra-fiscal'
    | '/a/romaneio'
    | '/a/secundario'
    | '/a/separacao'
    | '/a/servico'
    | '/a/sped-fiscal'
    | '/a/suporte'
    | '/a/transportador'
    | '/a/venda-externa'
    | '/p/catalogo/$slug'
    | '/p/catalogo/$slug/auth'
    | '/a/cliente/$action/{-$idpk}'
    | '/a/cobranca-boleto/$action/{-$idpk}'
    | '/a/compra/$action/{-$idpk}'
    | '/a/compra/clonar/$idpk'
    | '/a/contas-pagar/$action/{-$idpk}'
    | '/a/contas-receber/$action/{-$idpk}'
    | '/a/contrato/$action/{-$idpk}'
    | '/a/devolucao/$action/{-$idpk}'
    | '/a/importacao/$tipo/{-$idpk}'
    | '/a/importacao/xml/$tipo'
    | '/a/inventario/$action/{-$idpk}'
    | '/a/manifesto-carga/$action/{-$idpk}'
    | '/a/movimentacoes/$action/{-$idpk}'
    | '/a/movimentacoes/extrato/$idpk'
    | '/a/nfse/$action/{-$idpk}'
    | '/a/nota-fiscal/$action/{-$idpk}'
    | '/a/pagfor/$action/{-$idpk}'
    | '/a/produto/$action/{-$idpk}'
    | '/a/regra-fiscal/$action/{-$idpk}'
    | '/a/relatorio/cadastro/catalogo-produtos'
    | '/a/relatorio/cadastro/controle-lotes'
    | '/a/relatorio/cadastro/historico-alteracoes-preco'
    | '/a/relatorio/cadastro/relacao-clientes'
    | '/a/relatorio/cadastro/relacao-clientes-aniversariantes'
    | '/a/relatorio/cadastro/relacao-fornecedores'
    | '/a/relatorio/cadastro/relacao-produtos'
    | '/a/relatorio/cadastro/relacao-transportadores'
    | '/a/relatorio/compra/compras-por-fornecedor'
    | '/a/relatorio/estoque/estoque-minimo'
    | '/a/relatorio/estoque/saldos-em-estoque'
    | '/a/relatorio/financeiro/balancete'
    | '/a/relatorio/financeiro/boletos-recebidos'
    | '/a/relatorio/financeiro/contas-pagar'
    | '/a/relatorio/financeiro/contas-receber'
    | '/a/relatorio/financeiro/contas-recebidas'
    | '/a/relatorio/financeiro/dre'
    | '/a/relatorio/financeiro/entradas-saidas'
    | '/a/relatorio/financeiro/fluxo-caixa'
    | '/a/relatorio/financeiro/lancamentos-contas-receber'
    | '/a/relatorio/financeiro/pagamentos'
    | '/a/relatorio/financeiro/relacao-boletos'
    | '/a/relatorio/financeiro/totais-por-categoria'
    | '/a/relatorio/fiscal/itens-notas-fiscais'
    | '/a/relatorio/fiscal/notas-fiscais-cliente'
    | '/a/relatorio/fiscal/notas-fiscais-produto'
    | '/a/relatorio/fiscal/notas-fiscais-tipo'
    | '/a/relatorio/fiscal/relacao-documentos'
    | '/a/relatorio/fiscal/relacao-sequencias-inutilizadas'
    | '/a/relatorio/fiscal/total-agrupado-cfop'
    | '/a/relatorio/fiscal/total-agrupado-forma-pagamento'
    | '/a/relatorio/fiscal/total-agrupado-ncm'
    | '/a/relatorio/venda/comissoes'
    | '/a/relatorio/venda/produtos-mais-vendidos'
    | '/a/relatorio/venda/relacao-vendas'
    | '/a/relatorio/venda/relacao-vendas-produto'
    | '/a/relatorio/venda/relacao-vendas-resumido'
    | '/a/relatorio/venda/total-forma-pagamento'
    | '/a/relatorio/venda/vendas-cliente'
    | '/a/relatorio/venda/vendas-vendedor'
    | '/a/renegociacao/contas-pagar/cadastrar'
    | '/a/renegociacao/contas-receber/cadastrar'
    | '/a/romaneio/$action/{-$idpk}'
    | '/a/separacao/$type/$idpk'
    | '/a/servico/$action/{-$idpk}'
    | '/a/sped-fiscal/$action/{-$idpk}'
    | '/a/transportador/$action/{-$idpk}'
    | '/a/venda-externa/$action/{-$idpk}'
    | '/a/venda/$action/$idpk'
    | '/a/venda/cadastrar/$tipo'
    | '/admin/configuracao/representante'
    | '/p/conta-digital/termos-de-uso/$base64'
    | '/a/configuracao/empresa'
    | '/a/relatorio/cadastro'
    | '/a/relatorio/compra'
    | '/a/relatorio/estoque'
    | '/a/relatorio/financeiro'
    | '/a/relatorio/fiscal'
    | '/a/relatorio/venda'
    | '/a/renegociacao/contas-pagar'
    | '/a/renegociacao/contas-receber'
    | '/a/venda/$tipo'
    | '/p/pagamento/$id'
    | '/p/catalogo/$slug/usuario'
    | '/a/romaneio/impressao/carga/$idpk'
    | '/a/romaneio/impressao/entrega/$idpk'
    | '/a/romaneio/impressao/padrao/$idpk'
    | '/a/venda/clonar/$tipo/$idpk'
    | '/admin/empresa/$action/{-$idpk}'
    | '/p/catalogo/$slug/finalizar'
    | '/p/catalogo/$slug/produtos'
    | '/p/catalogo/$slug/auth/cadastrar'
    | '/p/catalogo/$slug/auth/entrar'
    | '/p/catalogo/$slug/auth/recuperar-senha'
    | '/p/catalogo/$slug/auth/validar-codigo'
    | '/p/catalogo/$slug/usuario/perfil';
  id:
    | '__root__'
    | '/'
    | '/a'
    | '/admin'
    | '/auth'
    | '/a/cliente'
    | '/a/cobranca-boleto'
    | '/a/cobranca-cartao'
    | '/a/cobranca-pix'
    | '/a/comissao'
    | '/a/compra'
    | '/a/contas-pagar'
    | '/a/contas-receber'
    | '/a/cupom-fiscal'
    | '/a/debug'
    | '/a/devolucao'
    | '/a/estoque'
    | '/a/extrato-boleto'
    | '/a/extrato-pix'
    | '/a/fornecedor'
    | '/a/manifesto-carga'
    | '/a/movimentacoes'
    | '/a/nfse'
    | '/a/nota-fiscal'
    | '/a/notificacao'
    | '/a/pagfor'
    | '/a/produto'
    | '/a/regra-fiscal'
    | '/a/romaneio'
    | '/a/secundario'
    | '/a/servico'
    | '/a/sped-fiscal'
    | '/a/transportador'
    | '/a/venda'
    | '/a/venda-externa'
    | '/admin/_a'
    | '/a/pdv'
    | '/admin/auth'
    | '/auth/acesso-negado'
    | '/auth/cadastro'
    | '/auth/cadastro-fim'
    | '/auth/conta-bloqueada'
    | '/auth/login'
    | '/auth/login-adm'
    | '/auth/login-automatico'
    | '/auth/recuperar-senha'
    | '/auth/redefinir-senha'
    | '/p/erro'
    | '/a/configuracao/empresa'
    | '/a/relatorio/cadastro'
    | '/a/relatorio/compra'
    | '/a/relatorio/estoque'
    | '/a/relatorio/financeiro'
    | '/a/relatorio/fiscal'
    | '/a/relatorio/venda'
    | '/a/renegociacao/contas-pagar'
    | '/a/renegociacao/contas-receber'
    | '/p/catalogo/$slug'
    | '/a/cobranca-boleto/rotinas-bancarias'
    | '/a/cobranca-cartao/cadastrar'
    | '/a/compra/compra'
    | '/a/compra/importacao-nfe'
    | '/a/compra/manifestador'
    | '/a/configuracao/usuario'
    | '/a/estoque/conferencia'
    | '/a/estoque/movimentacao'
    | '/a/impressao/$filetype'
    | '/a/nota-fiscal/cadastrar'
    | '/a/notificacao/listagem'
    | '/a/pagfor/importar'
    | '/a/pagfor/listagem'
    | '/a/personalizacoes/comandos'
    | '/a/personalizacoes/consultas'
    | '/a/separacao/monitor'
    | '/a/suporte/instrucoes-de-uso'
    | '/admin/_a/empresa'
    | '/admin/_a/erro'
    | '/admin/_a/representante'
    | '/admin/_a/sql'
    | '/admin/_a/sql-editor'
    | '/admin/auth/login'
    | '/p/cliente/$slug'
    | '/p/compartilhamento/$id'
    | '/p/contrato/$id'
    | '/p/impressao/$filetype'
    | '/a/cliente/'
    | '/a/cobranca-boleto/'
    | '/a/cobranca-cartao/'
    | '/a/cobranca-pix/'
    | '/a/comissao/'
    | '/a/contas-pagar/'
    | '/a/contas-receber/'
    | '/a/contrato/'
    | '/a/cupom-fiscal/'
    | '/a/debug/'
    | '/a/devolucao/'
    | '/a/extrato-boleto/'
    | '/a/extrato-pix/'
    | '/a/fornecedor/'
    | '/a/inventario/'
    | '/a/manifesto-carga/'
    | '/a/movimentacoes/'
    | '/a/nfse/'
    | '/a/nota-fiscal/'
    | '/a/painel-gerencial/'
    | '/a/produto/'
    | '/a/regra-fiscal/'
    | '/a/romaneio/'
    | '/a/secundario/'
    | '/a/separacao/'
    | '/a/servico/'
    | '/a/sped-fiscal/'
    | '/a/suporte/'
    | '/a/transportador/'
    | '/a/venda-externa/'
    | '/p/catalogo/$slug/_default'
    | '/p/catalogo/$slug/auth'
    | '/a/cliente/$action/{-$idpk}'
    | '/a/cobranca-boleto/$action/{-$idpk}'
    | '/a/compra/$action/{-$idpk}'
    | '/a/compra/clonar/$idpk'
    | '/a/contas-pagar/$action/{-$idpk}'
    | '/a/contas-receber/$action/{-$idpk}'
    | '/a/contrato/$action/{-$idpk}'
    | '/a/devolucao/$action/{-$idpk}'
    | '/a/importacao/$tipo/{-$idpk}'
    | '/a/importacao/xml/$tipo'
    | '/a/inventario/$action/{-$idpk}'
    | '/a/manifesto-carga/$action/{-$idpk}'
    | '/a/movimentacoes/$action/{-$idpk}'
    | '/a/movimentacoes/extrato/$idpk'
    | '/a/nfse/$action/{-$idpk}'
    | '/a/nota-fiscal/$action/{-$idpk}'
    | '/a/pagfor/$action/{-$idpk}'
    | '/a/produto/$action/{-$idpk}'
    | '/a/regra-fiscal/$action/{-$idpk}'
    | '/a/relatorio/cadastro/catalogo-produtos'
    | '/a/relatorio/cadastro/controle-lotes'
    | '/a/relatorio/cadastro/historico-alteracoes-preco'
    | '/a/relatorio/cadastro/relacao-clientes'
    | '/a/relatorio/cadastro/relacao-clientes-aniversariantes'
    | '/a/relatorio/cadastro/relacao-fornecedores'
    | '/a/relatorio/cadastro/relacao-produtos'
    | '/a/relatorio/cadastro/relacao-transportadores'
    | '/a/relatorio/compra/compras-por-fornecedor'
    | '/a/relatorio/estoque/estoque-minimo'
    | '/a/relatorio/estoque/saldos-em-estoque'
    | '/a/relatorio/financeiro/balancete'
    | '/a/relatorio/financeiro/boletos-recebidos'
    | '/a/relatorio/financeiro/contas-pagar'
    | '/a/relatorio/financeiro/contas-receber'
    | '/a/relatorio/financeiro/contas-recebidas'
    | '/a/relatorio/financeiro/dre'
    | '/a/relatorio/financeiro/entradas-saidas'
    | '/a/relatorio/financeiro/fluxo-caixa'
    | '/a/relatorio/financeiro/lancamentos-contas-receber'
    | '/a/relatorio/financeiro/pagamentos'
    | '/a/relatorio/financeiro/relacao-boletos'
    | '/a/relatorio/financeiro/totais-por-categoria'
    | '/a/relatorio/fiscal/itens-notas-fiscais'
    | '/a/relatorio/fiscal/notas-fiscais-cliente'
    | '/a/relatorio/fiscal/notas-fiscais-produto'
    | '/a/relatorio/fiscal/notas-fiscais-tipo'
    | '/a/relatorio/fiscal/relacao-documentos'
    | '/a/relatorio/fiscal/relacao-sequencias-inutilizadas'
    | '/a/relatorio/fiscal/total-agrupado-cfop'
    | '/a/relatorio/fiscal/total-agrupado-forma-pagamento'
    | '/a/relatorio/fiscal/total-agrupado-ncm'
    | '/a/relatorio/venda/comissoes'
    | '/a/relatorio/venda/produtos-mais-vendidos'
    | '/a/relatorio/venda/relacao-vendas'
    | '/a/relatorio/venda/relacao-vendas-produto'
    | '/a/relatorio/venda/relacao-vendas-resumido'
    | '/a/relatorio/venda/total-forma-pagamento'
    | '/a/relatorio/venda/vendas-cliente'
    | '/a/relatorio/venda/vendas-vendedor'
    | '/a/renegociacao/contas-pagar/cadastrar'
    | '/a/renegociacao/contas-receber/cadastrar'
    | '/a/romaneio/$action/{-$idpk}'
    | '/a/separacao/$type/$idpk'
    | '/a/servico/$action/{-$idpk}'
    | '/a/sped-fiscal/$action/{-$idpk}'
    | '/a/transportador/$action/{-$idpk}'
    | '/a/venda-externa/$action/{-$idpk}'
    | '/a/venda/$action/$idpk'
    | '/a/venda/cadastrar/$tipo'
    | '/admin/_a/configuracao/representante'
    | '/p/conta-digital/termos-de-uso/$base64'
    | '/a/configuracao/empresa/'
    | '/a/relatorio/cadastro/'
    | '/a/relatorio/compra/'
    | '/a/relatorio/estoque/'
    | '/a/relatorio/financeiro/'
    | '/a/relatorio/fiscal/'
    | '/a/relatorio/venda/'
    | '/a/renegociacao/contas-pagar/'
    | '/a/renegociacao/contas-receber/'
    | '/a/venda/$tipo/'
    | '/p/catalogo/$slug/'
    | '/p/pagamento/$id/'
    | '/p/catalogo/$slug/_default/usuario'
    | '/a/romaneio/impressao/carga/$idpk'
    | '/a/romaneio/impressao/entrega/$idpk'
    | '/a/romaneio/impressao/padrao/$idpk'
    | '/a/venda/clonar/$tipo/$idpk'
    | '/admin/_a/empresa_/$action/{-$idpk}'
    | '/p/catalogo/$slug/_default/finalizar'
    | '/p/catalogo/$slug/_default/produtos'
    | '/p/catalogo/$slug/auth/cadastrar'
    | '/p/catalogo/$slug/auth/entrar'
    | '/p/catalogo/$slug/auth/recuperar-senha'
    | '/p/catalogo/$slug/auth/validar-codigo'
    | '/p/catalogo/$slug/_default/usuario/perfil';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ARouteRoute: typeof ARouteRouteWithChildren;
  AdminRouteRoute: typeof AdminRouteRouteWithChildren;
  AuthRouteRoute: typeof AuthRouteRouteWithChildren;
  PErroRoute: typeof PErroRoute;
  PCatalogoSlugRouteRoute: typeof PCatalogoSlugRouteRouteWithChildren;
  PClienteSlugRoute: typeof PClienteSlugRoute;
  PCompartilhamentoIdRoute: typeof PCompartilhamentoIdRoute;
  PContratoIdRoute: typeof PContratoIdRoute;
  PImpressaoFiletypeRoute: typeof PImpressaoFiletypeRoute;
  PContaDigitalTermosDeUsoBase64Route: typeof PContaDigitalTermosDeUsoBase64Route;
  PPagamentoIdIndexRoute: typeof PPagamentoIdIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/a': {
      id: '/a';
      path: '/a';
      fullPath: '/a';
      preLoaderRoute: typeof ARouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin': {
      id: '/admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/auth': {
      id: '/auth';
      path: '/auth';
      fullPath: '/auth';
      preLoaderRoute: typeof AuthRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/a/cliente': {
      id: '/a/cliente';
      path: '/cliente';
      fullPath: '/a/cliente';
      preLoaderRoute: typeof AClienteRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/cobranca-boleto': {
      id: '/a/cobranca-boleto';
      path: '/cobranca-boleto';
      fullPath: '/a/cobranca-boleto';
      preLoaderRoute: typeof ACobrancaBoletoRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/cobranca-cartao': {
      id: '/a/cobranca-cartao';
      path: '/cobranca-cartao';
      fullPath: '/a/cobranca-cartao';
      preLoaderRoute: typeof ACobrancaCartaoRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/cobranca-pix': {
      id: '/a/cobranca-pix';
      path: '/cobranca-pix';
      fullPath: '/a/cobranca-pix';
      preLoaderRoute: typeof ACobrancaPixRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/comissao': {
      id: '/a/comissao';
      path: '/comissao';
      fullPath: '/a/comissao';
      preLoaderRoute: typeof AComissaoRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/compra': {
      id: '/a/compra';
      path: '/compra';
      fullPath: '/a/compra';
      preLoaderRoute: typeof ACompraRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/contas-pagar': {
      id: '/a/contas-pagar';
      path: '/contas-pagar';
      fullPath: '/a/contas-pagar';
      preLoaderRoute: typeof AContasPagarRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/contas-receber': {
      id: '/a/contas-receber';
      path: '/contas-receber';
      fullPath: '/a/contas-receber';
      preLoaderRoute: typeof AContasReceberRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/cupom-fiscal': {
      id: '/a/cupom-fiscal';
      path: '/cupom-fiscal';
      fullPath: '/a/cupom-fiscal';
      preLoaderRoute: typeof ACupomFiscalRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/debug': {
      id: '/a/debug';
      path: '/debug';
      fullPath: '/a/debug';
      preLoaderRoute: typeof ADebugRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/devolucao': {
      id: '/a/devolucao';
      path: '/devolucao';
      fullPath: '/a/devolucao';
      preLoaderRoute: typeof ADevolucaoRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/estoque': {
      id: '/a/estoque';
      path: '/estoque';
      fullPath: '/a/estoque';
      preLoaderRoute: typeof AEstoqueRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/extrato-boleto': {
      id: '/a/extrato-boleto';
      path: '/extrato-boleto';
      fullPath: '/a/extrato-boleto';
      preLoaderRoute: typeof AExtratoBoletoRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/extrato-pix': {
      id: '/a/extrato-pix';
      path: '/extrato-pix';
      fullPath: '/a/extrato-pix';
      preLoaderRoute: typeof AExtratoPixRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/fornecedor': {
      id: '/a/fornecedor';
      path: '/fornecedor';
      fullPath: '/a/fornecedor';
      preLoaderRoute: typeof AFornecedorRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/manifesto-carga': {
      id: '/a/manifesto-carga';
      path: '/manifesto-carga';
      fullPath: '/a/manifesto-carga';
      preLoaderRoute: typeof AManifestoCargaRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/movimentacoes': {
      id: '/a/movimentacoes';
      path: '/movimentacoes';
      fullPath: '/a/movimentacoes';
      preLoaderRoute: typeof AMovimentacoesRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/nfse': {
      id: '/a/nfse';
      path: '/nfse';
      fullPath: '/a/nfse';
      preLoaderRoute: typeof ANfseRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/nota-fiscal': {
      id: '/a/nota-fiscal';
      path: '/nota-fiscal';
      fullPath: '/a/nota-fiscal';
      preLoaderRoute: typeof ANotaFiscalRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/notificacao': {
      id: '/a/notificacao';
      path: '/notificacao';
      fullPath: '/a/notificacao';
      preLoaderRoute: typeof ANotificacaoRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/pagfor': {
      id: '/a/pagfor';
      path: '/pagfor';
      fullPath: '/a/pagfor';
      preLoaderRoute: typeof APagforRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/pdv': {
      id: '/a/pdv';
      path: '/pdv';
      fullPath: '/a/pdv';
      preLoaderRoute: typeof APdvRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/produto': {
      id: '/a/produto';
      path: '/produto';
      fullPath: '/a/produto';
      preLoaderRoute: typeof AProdutoRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/regra-fiscal': {
      id: '/a/regra-fiscal';
      path: '/regra-fiscal';
      fullPath: '/a/regra-fiscal';
      preLoaderRoute: typeof ARegraFiscalRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/romaneio': {
      id: '/a/romaneio';
      path: '/romaneio';
      fullPath: '/a/romaneio';
      preLoaderRoute: typeof ARomaneioRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/secundario': {
      id: '/a/secundario';
      path: '/secundario';
      fullPath: '/a/secundario';
      preLoaderRoute: typeof ASecundarioRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/servico': {
      id: '/a/servico';
      path: '/servico';
      fullPath: '/a/servico';
      preLoaderRoute: typeof AServicoRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/sped-fiscal': {
      id: '/a/sped-fiscal';
      path: '/sped-fiscal';
      fullPath: '/a/sped-fiscal';
      preLoaderRoute: typeof ASpedFiscalRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/transportador': {
      id: '/a/transportador';
      path: '/transportador';
      fullPath: '/a/transportador';
      preLoaderRoute: typeof ATransportadorRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/venda': {
      id: '/a/venda';
      path: '/venda';
      fullPath: '/a/venda';
      preLoaderRoute: typeof AVendaRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/venda-externa': {
      id: '/a/venda-externa';
      path: '/venda-externa';
      fullPath: '/a/venda-externa';
      preLoaderRoute: typeof AVendaExternaRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/admin/_a': {
      id: '/admin/_a';
      path: '';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminARouteRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    '/admin/auth': {
      id: '/admin/auth';
      path: '/auth';
      fullPath: '/admin/auth';
      preLoaderRoute: typeof AdminAuthRouteImport;
      parentRoute: typeof AdminRouteRoute;
    };
    '/auth/acesso-negado': {
      id: '/auth/acesso-negado';
      path: '/acesso-negado';
      fullPath: '/auth/acesso-negado';
      preLoaderRoute: typeof AuthAcessoNegadoRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    '/auth/cadastro': {
      id: '/auth/cadastro';
      path: '/cadastro';
      fullPath: '/auth/cadastro';
      preLoaderRoute: typeof AuthCadastroRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    '/auth/cadastro-fim': {
      id: '/auth/cadastro-fim';
      path: '/cadastro-fim';
      fullPath: '/auth/cadastro-fim';
      preLoaderRoute: typeof AuthCadastroFimRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    '/auth/conta-bloqueada': {
      id: '/auth/conta-bloqueada';
      path: '/conta-bloqueada';
      fullPath: '/auth/conta-bloqueada';
      preLoaderRoute: typeof AuthContaBloqueadaRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    '/auth/login': {
      id: '/auth/login';
      path: '/login';
      fullPath: '/auth/login';
      preLoaderRoute: typeof AuthLoginRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    '/auth/login-adm': {
      id: '/auth/login-adm';
      path: '/login-adm';
      fullPath: '/auth/login-adm';
      preLoaderRoute: typeof AuthLoginAdmRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    '/auth/login-automatico': {
      id: '/auth/login-automatico';
      path: '/login-automatico';
      fullPath: '/auth/login-automatico';
      preLoaderRoute: typeof AuthLoginAutomaticoRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    '/auth/recuperar-senha': {
      id: '/auth/recuperar-senha';
      path: '/recuperar-senha';
      fullPath: '/auth/recuperar-senha';
      preLoaderRoute: typeof AuthRecuperarSenhaRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    '/auth/redefinir-senha': {
      id: '/auth/redefinir-senha';
      path: '/redefinir-senha';
      fullPath: '/auth/redefinir-senha';
      preLoaderRoute: typeof AuthRedefinirSenhaRouteImport;
      parentRoute: typeof AuthRouteRoute;
    };
    '/p/erro': {
      id: '/p/erro';
      path: '/p/erro';
      fullPath: '/p/erro';
      preLoaderRoute: typeof PErroRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/a/cliente/': {
      id: '/a/cliente/';
      path: '/';
      fullPath: '/a/cliente/';
      preLoaderRoute: typeof AClienteIndexRouteImport;
      parentRoute: typeof AClienteRouteRoute;
    };
    '/a/cobranca-boleto/': {
      id: '/a/cobranca-boleto/';
      path: '/';
      fullPath: '/a/cobranca-boleto/';
      preLoaderRoute: typeof ACobrancaBoletoIndexRouteImport;
      parentRoute: typeof ACobrancaBoletoRouteRoute;
    };
    '/a/cobranca-boleto/rotinas-bancarias': {
      id: '/a/cobranca-boleto/rotinas-bancarias';
      path: '/rotinas-bancarias';
      fullPath: '/a/cobranca-boleto/rotinas-bancarias';
      preLoaderRoute: typeof ACobrancaBoletoRotinasBancariasRouteImport;
      parentRoute: typeof ACobrancaBoletoRouteRoute;
    };
    '/a/cobranca-cartao/': {
      id: '/a/cobranca-cartao/';
      path: '/';
      fullPath: '/a/cobranca-cartao/';
      preLoaderRoute: typeof ACobrancaCartaoIndexRouteImport;
      parentRoute: typeof ACobrancaCartaoRouteRoute;
    };
    '/a/cobranca-cartao/cadastrar': {
      id: '/a/cobranca-cartao/cadastrar';
      path: '/cadastrar';
      fullPath: '/a/cobranca-cartao/cadastrar';
      preLoaderRoute: typeof ACobrancaCartaoCadastrarRouteImport;
      parentRoute: typeof ACobrancaCartaoRouteRoute;
    };
    '/a/cobranca-pix/': {
      id: '/a/cobranca-pix/';
      path: '/';
      fullPath: '/a/cobranca-pix/';
      preLoaderRoute: typeof ACobrancaPixIndexRouteImport;
      parentRoute: typeof ACobrancaPixRouteRoute;
    };
    '/a/comissao/': {
      id: '/a/comissao/';
      path: '/';
      fullPath: '/a/comissao/';
      preLoaderRoute: typeof AComissaoIndexRouteImport;
      parentRoute: typeof AComissaoRouteRoute;
    };
    '/a/compra/compra': {
      id: '/a/compra/compra';
      path: '/compra';
      fullPath: '/a/compra/compra';
      preLoaderRoute: typeof ACompraCompraRouteImport;
      parentRoute: typeof ACompraRouteRoute;
    };
    '/a/compra/importacao-nfe': {
      id: '/a/compra/importacao-nfe';
      path: '/importacao-nfe';
      fullPath: '/a/compra/importacao-nfe';
      preLoaderRoute: typeof ACompraImportacaoNfeRouteImport;
      parentRoute: typeof ACompraRouteRoute;
    };
    '/a/compra/manifestador': {
      id: '/a/compra/manifestador';
      path: '/manifestador';
      fullPath: '/a/compra/manifestador';
      preLoaderRoute: typeof ACompraManifestadorRouteImport;
      parentRoute: typeof ACompraRouteRoute;
    };
    '/a/configuracao/empresa': {
      id: '/a/configuracao/empresa';
      path: '/configuracao/empresa';
      fullPath: '/a/configuracao/empresa';
      preLoaderRoute: typeof AConfiguracaoEmpresaRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/configuracao/usuario': {
      id: '/a/configuracao/usuario';
      path: '/configuracao/usuario';
      fullPath: '/a/configuracao/usuario';
      preLoaderRoute: typeof AConfiguracaoUsuarioRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/contas-pagar/': {
      id: '/a/contas-pagar/';
      path: '/';
      fullPath: '/a/contas-pagar/';
      preLoaderRoute: typeof AContasPagarIndexRouteImport;
      parentRoute: typeof AContasPagarRouteRoute;
    };
    '/a/contas-receber/': {
      id: '/a/contas-receber/';
      path: '/';
      fullPath: '/a/contas-receber/';
      preLoaderRoute: typeof AContasReceberIndexRouteImport;
      parentRoute: typeof AContasReceberRouteRoute;
    };
    '/a/contrato/': {
      id: '/a/contrato/';
      path: '/contrato';
      fullPath: '/a/contrato/';
      preLoaderRoute: typeof AContratoIndexRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/cupom-fiscal/': {
      id: '/a/cupom-fiscal/';
      path: '/';
      fullPath: '/a/cupom-fiscal/';
      preLoaderRoute: typeof ACupomFiscalIndexRouteImport;
      parentRoute: typeof ACupomFiscalRouteRoute;
    };
    '/a/debug/': {
      id: '/a/debug/';
      path: '/';
      fullPath: '/a/debug/';
      preLoaderRoute: typeof ADebugIndexRouteImport;
      parentRoute: typeof ADebugRouteRoute;
    };
    '/a/devolucao/': {
      id: '/a/devolucao/';
      path: '/';
      fullPath: '/a/devolucao/';
      preLoaderRoute: typeof ADevolucaoIndexRouteImport;
      parentRoute: typeof ADevolucaoRouteRoute;
    };
    '/a/estoque/conferencia': {
      id: '/a/estoque/conferencia';
      path: '/conferencia';
      fullPath: '/a/estoque/conferencia';
      preLoaderRoute: typeof AEstoqueConferenciaRouteImport;
      parentRoute: typeof AEstoqueRouteRoute;
    };
    '/a/estoque/movimentacao': {
      id: '/a/estoque/movimentacao';
      path: '/movimentacao';
      fullPath: '/a/estoque/movimentacao';
      preLoaderRoute: typeof AEstoqueMovimentacaoRouteImport;
      parentRoute: typeof AEstoqueRouteRoute;
    };
    '/a/extrato-boleto/': {
      id: '/a/extrato-boleto/';
      path: '/';
      fullPath: '/a/extrato-boleto/';
      preLoaderRoute: typeof AExtratoBoletoIndexRouteImport;
      parentRoute: typeof AExtratoBoletoRouteRoute;
    };
    '/a/extrato-pix/': {
      id: '/a/extrato-pix/';
      path: '/';
      fullPath: '/a/extrato-pix/';
      preLoaderRoute: typeof AExtratoPixIndexRouteImport;
      parentRoute: typeof AExtratoPixRouteRoute;
    };
    '/a/fornecedor/': {
      id: '/a/fornecedor/';
      path: '/';
      fullPath: '/a/fornecedor/';
      preLoaderRoute: typeof AFornecedorIndexRouteImport;
      parentRoute: typeof AFornecedorRouteRoute;
    };
    '/a/impressao/$filetype': {
      id: '/a/impressao/$filetype';
      path: '/impressao/$filetype';
      fullPath: '/a/impressao/$filetype';
      preLoaderRoute: typeof AImpressaoFiletypeRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/inventario/': {
      id: '/a/inventario/';
      path: '/inventario';
      fullPath: '/a/inventario/';
      preLoaderRoute: typeof AInventarioIndexRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/manifesto-carga/': {
      id: '/a/manifesto-carga/';
      path: '/';
      fullPath: '/a/manifesto-carga/';
      preLoaderRoute: typeof AManifestoCargaIndexRouteImport;
      parentRoute: typeof AManifestoCargaRouteRoute;
    };
    '/a/movimentacoes/': {
      id: '/a/movimentacoes/';
      path: '/';
      fullPath: '/a/movimentacoes/';
      preLoaderRoute: typeof AMovimentacoesIndexRouteImport;
      parentRoute: typeof AMovimentacoesRouteRoute;
    };
    '/a/nfse/': {
      id: '/a/nfse/';
      path: '/';
      fullPath: '/a/nfse/';
      preLoaderRoute: typeof ANfseIndexRouteImport;
      parentRoute: typeof ANfseRouteRoute;
    };
    '/a/nota-fiscal/': {
      id: '/a/nota-fiscal/';
      path: '/';
      fullPath: '/a/nota-fiscal/';
      preLoaderRoute: typeof ANotaFiscalIndexRouteImport;
      parentRoute: typeof ANotaFiscalRouteRoute;
    };
    '/a/nota-fiscal/cadastrar': {
      id: '/a/nota-fiscal/cadastrar';
      path: '/cadastrar';
      fullPath: '/a/nota-fiscal/cadastrar';
      preLoaderRoute: typeof ANotaFiscalCadastrarRouteImport;
      parentRoute: typeof ANotaFiscalRouteRoute;
    };
    '/a/notificacao/listagem': {
      id: '/a/notificacao/listagem';
      path: '/listagem';
      fullPath: '/a/notificacao/listagem';
      preLoaderRoute: typeof ANotificacaoListagemRouteImport;
      parentRoute: typeof ANotificacaoRouteRoute;
    };
    '/a/pagfor/importar': {
      id: '/a/pagfor/importar';
      path: '/importar';
      fullPath: '/a/pagfor/importar';
      preLoaderRoute: typeof APagforImportarRouteImport;
      parentRoute: typeof APagforRouteRoute;
    };
    '/a/pagfor/listagem': {
      id: '/a/pagfor/listagem';
      path: '/listagem';
      fullPath: '/a/pagfor/listagem';
      preLoaderRoute: typeof APagforListagemRouteImport;
      parentRoute: typeof APagforRouteRoute;
    };
    '/a/painel-gerencial/': {
      id: '/a/painel-gerencial/';
      path: '/painel-gerencial';
      fullPath: '/a/painel-gerencial/';
      preLoaderRoute: typeof APainelGerencialIndexRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/personalizacoes/comandos': {
      id: '/a/personalizacoes/comandos';
      path: '/personalizacoes/comandos';
      fullPath: '/a/personalizacoes/comandos';
      preLoaderRoute: typeof APersonalizacoesComandosRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/personalizacoes/consultas': {
      id: '/a/personalizacoes/consultas';
      path: '/personalizacoes/consultas';
      fullPath: '/a/personalizacoes/consultas';
      preLoaderRoute: typeof APersonalizacoesConsultasRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/produto/': {
      id: '/a/produto/';
      path: '/';
      fullPath: '/a/produto/';
      preLoaderRoute: typeof AProdutoIndexRouteImport;
      parentRoute: typeof AProdutoRouteRoute;
    };
    '/a/regra-fiscal/': {
      id: '/a/regra-fiscal/';
      path: '/';
      fullPath: '/a/regra-fiscal/';
      preLoaderRoute: typeof ARegraFiscalIndexRouteImport;
      parentRoute: typeof ARegraFiscalRouteRoute;
    };
    '/a/relatorio/cadastro': {
      id: '/a/relatorio/cadastro';
      path: '/relatorio/cadastro';
      fullPath: '/a/relatorio/cadastro';
      preLoaderRoute: typeof ARelatorioCadastroRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/relatorio/compra': {
      id: '/a/relatorio/compra';
      path: '/relatorio/compra';
      fullPath: '/a/relatorio/compra';
      preLoaderRoute: typeof ARelatorioCompraRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/relatorio/estoque': {
      id: '/a/relatorio/estoque';
      path: '/relatorio/estoque';
      fullPath: '/a/relatorio/estoque';
      preLoaderRoute: typeof ARelatorioEstoqueRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/relatorio/financeiro': {
      id: '/a/relatorio/financeiro';
      path: '/relatorio/financeiro';
      fullPath: '/a/relatorio/financeiro';
      preLoaderRoute: typeof ARelatorioFinanceiroRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/relatorio/fiscal': {
      id: '/a/relatorio/fiscal';
      path: '/relatorio/fiscal';
      fullPath: '/a/relatorio/fiscal';
      preLoaderRoute: typeof ARelatorioFiscalRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/relatorio/venda': {
      id: '/a/relatorio/venda';
      path: '/relatorio/venda';
      fullPath: '/a/relatorio/venda';
      preLoaderRoute: typeof ARelatorioVendaRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/renegociacao/contas-pagar': {
      id: '/a/renegociacao/contas-pagar';
      path: '/renegociacao/contas-pagar';
      fullPath: '/a/renegociacao/contas-pagar';
      preLoaderRoute: typeof ARenegociacaoContasPagarRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/renegociacao/contas-receber': {
      id: '/a/renegociacao/contas-receber';
      path: '/renegociacao/contas-receber';
      fullPath: '/a/renegociacao/contas-receber';
      preLoaderRoute: typeof ARenegociacaoContasReceberRouteRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/romaneio/': {
      id: '/a/romaneio/';
      path: '/';
      fullPath: '/a/romaneio/';
      preLoaderRoute: typeof ARomaneioIndexRouteImport;
      parentRoute: typeof ARomaneioRouteRoute;
    };
    '/a/secundario/': {
      id: '/a/secundario/';
      path: '/';
      fullPath: '/a/secundario/';
      preLoaderRoute: typeof ASecundarioIndexRouteImport;
      parentRoute: typeof ASecundarioRouteRoute;
    };
    '/a/separacao/': {
      id: '/a/separacao/';
      path: '/separacao';
      fullPath: '/a/separacao/';
      preLoaderRoute: typeof ASeparacaoIndexRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/separacao/monitor': {
      id: '/a/separacao/monitor';
      path: '/separacao/monitor';
      fullPath: '/a/separacao/monitor';
      preLoaderRoute: typeof ASeparacaoMonitorRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/servico/': {
      id: '/a/servico/';
      path: '/';
      fullPath: '/a/servico/';
      preLoaderRoute: typeof AServicoIndexRouteImport;
      parentRoute: typeof AServicoRouteRoute;
    };
    '/a/sped-fiscal/': {
      id: '/a/sped-fiscal/';
      path: '/';
      fullPath: '/a/sped-fiscal/';
      preLoaderRoute: typeof ASpedFiscalIndexRouteImport;
      parentRoute: typeof ASpedFiscalRouteRoute;
    };
    '/a/suporte/': {
      id: '/a/suporte/';
      path: '/suporte';
      fullPath: '/a/suporte/';
      preLoaderRoute: typeof ASuporteIndexRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/suporte/instrucoes-de-uso': {
      id: '/a/suporte/instrucoes-de-uso';
      path: '/suporte/instrucoes-de-uso';
      fullPath: '/a/suporte/instrucoes-de-uso';
      preLoaderRoute: typeof ASuporteInstrucoesDeUsoRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/transportador/': {
      id: '/a/transportador/';
      path: '/';
      fullPath: '/a/transportador/';
      preLoaderRoute: typeof ATransportadorIndexRouteImport;
      parentRoute: typeof ATransportadorRouteRoute;
    };
    '/a/venda-externa/': {
      id: '/a/venda-externa/';
      path: '/';
      fullPath: '/a/venda-externa/';
      preLoaderRoute: typeof AVendaExternaIndexRouteImport;
      parentRoute: typeof AVendaExternaRouteRoute;
    };
    '/admin/_a/empresa': {
      id: '/admin/_a/empresa';
      path: '/empresa';
      fullPath: '/admin/empresa';
      preLoaderRoute: typeof AdminAEmpresaRouteImport;
      parentRoute: typeof AdminARouteRoute;
    };
    '/admin/_a/erro': {
      id: '/admin/_a/erro';
      path: '/erro';
      fullPath: '/admin/erro';
      preLoaderRoute: typeof AdminAErroRouteImport;
      parentRoute: typeof AdminARouteRoute;
    };
    '/admin/_a/representante': {
      id: '/admin/_a/representante';
      path: '/representante';
      fullPath: '/admin/representante';
      preLoaderRoute: typeof AdminARepresentanteRouteImport;
      parentRoute: typeof AdminARouteRoute;
    };
    '/admin/_a/sql': {
      id: '/admin/_a/sql';
      path: '/sql';
      fullPath: '/admin/sql';
      preLoaderRoute: typeof AdminASqlRouteImport;
      parentRoute: typeof AdminARouteRoute;
    };
    '/admin/_a/sql-editor': {
      id: '/admin/_a/sql-editor';
      path: '/sql-editor';
      fullPath: '/admin/sql-editor';
      preLoaderRoute: typeof AdminASqlEditorRouteImport;
      parentRoute: typeof AdminARouteRoute;
    };
    '/admin/auth/login': {
      id: '/admin/auth/login';
      path: '/login';
      fullPath: '/admin/auth/login';
      preLoaderRoute: typeof AdminAuthLoginRouteImport;
      parentRoute: typeof AdminAuthRoute;
    };
    '/p/catalogo/$slug': {
      id: '/p/catalogo/$slug';
      path: '/p/catalogo/$slug';
      fullPath: '/p/catalogo/$slug';
      preLoaderRoute: typeof PCatalogoSlugRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/p/cliente/$slug': {
      id: '/p/cliente/$slug';
      path: '/p/cliente/$slug';
      fullPath: '/p/cliente/$slug';
      preLoaderRoute: typeof PClienteSlugRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/p/compartilhamento/$id': {
      id: '/p/compartilhamento/$id';
      path: '/p/compartilhamento/$id';
      fullPath: '/p/compartilhamento/$id';
      preLoaderRoute: typeof PCompartilhamentoIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/p/contrato/$id': {
      id: '/p/contrato/$id';
      path: '/p/contrato/$id';
      fullPath: '/p/contrato/$id';
      preLoaderRoute: typeof PContratoIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/p/impressao/$filetype': {
      id: '/p/impressao/$filetype';
      path: '/p/impressao/$filetype';
      fullPath: '/p/impressao/$filetype';
      preLoaderRoute: typeof PImpressaoFiletypeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/a/cliente/$action/{-$idpk}': {
      id: '/a/cliente/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/cliente/$action/{-$idpk}';
      preLoaderRoute: typeof AClienteActionChar123IdpkChar125RouteImport;
      parentRoute: typeof AClienteRouteRoute;
    };
    '/a/cobranca-boleto/$action/{-$idpk}': {
      id: '/a/cobranca-boleto/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/cobranca-boleto/$action/{-$idpk}';
      preLoaderRoute: typeof ACobrancaBoletoActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ACobrancaBoletoRouteRoute;
    };
    '/a/compra/$action/{-$idpk}': {
      id: '/a/compra/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/compra/$action/{-$idpk}';
      preLoaderRoute: typeof ACompraActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ACompraRouteRoute;
    };
    '/a/compra/clonar/$idpk': {
      id: '/a/compra/clonar/$idpk';
      path: '/clonar/$idpk';
      fullPath: '/a/compra/clonar/$idpk';
      preLoaderRoute: typeof ACompraClonarIdpkRouteImport;
      parentRoute: typeof ACompraRouteRoute;
    };
    '/a/configuracao/empresa/': {
      id: '/a/configuracao/empresa/';
      path: '/';
      fullPath: '/a/configuracao/empresa/';
      preLoaderRoute: typeof AConfiguracaoEmpresaIndexRouteImport;
      parentRoute: typeof AConfiguracaoEmpresaRouteRoute;
    };
    '/a/contas-pagar/$action/{-$idpk}': {
      id: '/a/contas-pagar/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/contas-pagar/$action/{-$idpk}';
      preLoaderRoute: typeof AContasPagarActionChar123IdpkChar125RouteImport;
      parentRoute: typeof AContasPagarRouteRoute;
    };
    '/a/contas-receber/$action/{-$idpk}': {
      id: '/a/contas-receber/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/contas-receber/$action/{-$idpk}';
      preLoaderRoute: typeof AContasReceberActionChar123IdpkChar125RouteImport;
      parentRoute: typeof AContasReceberRouteRoute;
    };
    '/a/contrato/$action/{-$idpk}': {
      id: '/a/contrato/$action/{-$idpk}';
      path: '/contrato/$action/{-$idpk}';
      fullPath: '/a/contrato/$action/{-$idpk}';
      preLoaderRoute: typeof AContratoActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/devolucao/$action/{-$idpk}': {
      id: '/a/devolucao/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/devolucao/$action/{-$idpk}';
      preLoaderRoute: typeof ADevolucaoActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ADevolucaoRouteRoute;
    };
    '/a/importacao/$tipo/{-$idpk}': {
      id: '/a/importacao/$tipo/{-$idpk}';
      path: '/importacao/$tipo/{-$idpk}';
      fullPath: '/a/importacao/$tipo/{-$idpk}';
      preLoaderRoute: typeof AImportacaoTipoChar123IdpkChar125RouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/importacao/xml/$tipo': {
      id: '/a/importacao/xml/$tipo';
      path: '/importacao/xml/$tipo';
      fullPath: '/a/importacao/xml/$tipo';
      preLoaderRoute: typeof AImportacaoXmlTipoRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/inventario/$action/{-$idpk}': {
      id: '/a/inventario/$action/{-$idpk}';
      path: '/inventario/$action/{-$idpk}';
      fullPath: '/a/inventario/$action/{-$idpk}';
      preLoaderRoute: typeof AInventarioActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/manifesto-carga/$action/{-$idpk}': {
      id: '/a/manifesto-carga/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/manifesto-carga/$action/{-$idpk}';
      preLoaderRoute: typeof AManifestoCargaActionChar123IdpkChar125RouteImport;
      parentRoute: typeof AManifestoCargaRouteRoute;
    };
    '/a/movimentacoes/$action/{-$idpk}': {
      id: '/a/movimentacoes/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/movimentacoes/$action/{-$idpk}';
      preLoaderRoute: typeof AMovimentacoesActionChar123IdpkChar125RouteImport;
      parentRoute: typeof AMovimentacoesRouteRoute;
    };
    '/a/movimentacoes/extrato/$idpk': {
      id: '/a/movimentacoes/extrato/$idpk';
      path: '/extrato/$idpk';
      fullPath: '/a/movimentacoes/extrato/$idpk';
      preLoaderRoute: typeof AMovimentacoesExtratoIdpkRouteImport;
      parentRoute: typeof AMovimentacoesRouteRoute;
    };
    '/a/nfse/$action/{-$idpk}': {
      id: '/a/nfse/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/nfse/$action/{-$idpk}';
      preLoaderRoute: typeof ANfseActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ANfseRouteRoute;
    };
    '/a/nota-fiscal/$action/{-$idpk}': {
      id: '/a/nota-fiscal/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/nota-fiscal/$action/{-$idpk}';
      preLoaderRoute: typeof ANotaFiscalActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ANotaFiscalRouteRoute;
    };
    '/a/pagfor/$action/{-$idpk}': {
      id: '/a/pagfor/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/pagfor/$action/{-$idpk}';
      preLoaderRoute: typeof APagforActionChar123IdpkChar125RouteImport;
      parentRoute: typeof APagforRouteRoute;
    };
    '/a/produto/$action/{-$idpk}': {
      id: '/a/produto/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/produto/$action/{-$idpk}';
      preLoaderRoute: typeof AProdutoActionChar123IdpkChar125RouteImport;
      parentRoute: typeof AProdutoRouteRoute;
    };
    '/a/regra-fiscal/$action/{-$idpk}': {
      id: '/a/regra-fiscal/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/regra-fiscal/$action/{-$idpk}';
      preLoaderRoute: typeof ARegraFiscalActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ARegraFiscalRouteRoute;
    };
    '/a/relatorio/cadastro/': {
      id: '/a/relatorio/cadastro/';
      path: '/';
      fullPath: '/a/relatorio/cadastro/';
      preLoaderRoute: typeof ARelatorioCadastroIndexRouteImport;
      parentRoute: typeof ARelatorioCadastroRouteRoute;
    };
    '/a/relatorio/cadastro/catalogo-produtos': {
      id: '/a/relatorio/cadastro/catalogo-produtos';
      path: '/catalogo-produtos';
      fullPath: '/a/relatorio/cadastro/catalogo-produtos';
      preLoaderRoute: typeof ARelatorioCadastroCatalogoProdutosRouteImport;
      parentRoute: typeof ARelatorioCadastroRouteRoute;
    };
    '/a/relatorio/cadastro/controle-lotes': {
      id: '/a/relatorio/cadastro/controle-lotes';
      path: '/controle-lotes';
      fullPath: '/a/relatorio/cadastro/controle-lotes';
      preLoaderRoute: typeof ARelatorioCadastroControleLotesRouteImport;
      parentRoute: typeof ARelatorioCadastroRouteRoute;
    };
    '/a/relatorio/cadastro/historico-alteracoes-preco': {
      id: '/a/relatorio/cadastro/historico-alteracoes-preco';
      path: '/historico-alteracoes-preco';
      fullPath: '/a/relatorio/cadastro/historico-alteracoes-preco';
      preLoaderRoute: typeof ARelatorioCadastroHistoricoAlteracoesPrecoRouteImport;
      parentRoute: typeof ARelatorioCadastroRouteRoute;
    };
    '/a/relatorio/cadastro/relacao-clientes': {
      id: '/a/relatorio/cadastro/relacao-clientes';
      path: '/relacao-clientes';
      fullPath: '/a/relatorio/cadastro/relacao-clientes';
      preLoaderRoute: typeof ARelatorioCadastroRelacaoClientesRouteImport;
      parentRoute: typeof ARelatorioCadastroRouteRoute;
    };
    '/a/relatorio/cadastro/relacao-clientes-aniversariantes': {
      id: '/a/relatorio/cadastro/relacao-clientes-aniversariantes';
      path: '/relacao-clientes-aniversariantes';
      fullPath: '/a/relatorio/cadastro/relacao-clientes-aniversariantes';
      preLoaderRoute: typeof ARelatorioCadastroRelacaoClientesAniversariantesRouteImport;
      parentRoute: typeof ARelatorioCadastroRouteRoute;
    };
    '/a/relatorio/cadastro/relacao-fornecedores': {
      id: '/a/relatorio/cadastro/relacao-fornecedores';
      path: '/relacao-fornecedores';
      fullPath: '/a/relatorio/cadastro/relacao-fornecedores';
      preLoaderRoute: typeof ARelatorioCadastroRelacaoFornecedoresRouteImport;
      parentRoute: typeof ARelatorioCadastroRouteRoute;
    };
    '/a/relatorio/cadastro/relacao-produtos': {
      id: '/a/relatorio/cadastro/relacao-produtos';
      path: '/relacao-produtos';
      fullPath: '/a/relatorio/cadastro/relacao-produtos';
      preLoaderRoute: typeof ARelatorioCadastroRelacaoProdutosRouteImport;
      parentRoute: typeof ARelatorioCadastroRouteRoute;
    };
    '/a/relatorio/cadastro/relacao-transportadores': {
      id: '/a/relatorio/cadastro/relacao-transportadores';
      path: '/relacao-transportadores';
      fullPath: '/a/relatorio/cadastro/relacao-transportadores';
      preLoaderRoute: typeof ARelatorioCadastroRelacaoTransportadoresRouteImport;
      parentRoute: typeof ARelatorioCadastroRouteRoute;
    };
    '/a/relatorio/compra/': {
      id: '/a/relatorio/compra/';
      path: '/';
      fullPath: '/a/relatorio/compra/';
      preLoaderRoute: typeof ARelatorioCompraIndexRouteImport;
      parentRoute: typeof ARelatorioCompraRouteRoute;
    };
    '/a/relatorio/compra/compras-por-fornecedor': {
      id: '/a/relatorio/compra/compras-por-fornecedor';
      path: '/compras-por-fornecedor';
      fullPath: '/a/relatorio/compra/compras-por-fornecedor';
      preLoaderRoute: typeof ARelatorioCompraComprasPorFornecedorRouteImport;
      parentRoute: typeof ARelatorioCompraRouteRoute;
    };
    '/a/relatorio/estoque/': {
      id: '/a/relatorio/estoque/';
      path: '/';
      fullPath: '/a/relatorio/estoque/';
      preLoaderRoute: typeof ARelatorioEstoqueIndexRouteImport;
      parentRoute: typeof ARelatorioEstoqueRouteRoute;
    };
    '/a/relatorio/estoque/estoque-minimo': {
      id: '/a/relatorio/estoque/estoque-minimo';
      path: '/estoque-minimo';
      fullPath: '/a/relatorio/estoque/estoque-minimo';
      preLoaderRoute: typeof ARelatorioEstoqueEstoqueMinimoRouteImport;
      parentRoute: typeof ARelatorioEstoqueRouteRoute;
    };
    '/a/relatorio/estoque/saldos-em-estoque': {
      id: '/a/relatorio/estoque/saldos-em-estoque';
      path: '/saldos-em-estoque';
      fullPath: '/a/relatorio/estoque/saldos-em-estoque';
      preLoaderRoute: typeof ARelatorioEstoqueSaldosEmEstoqueRouteImport;
      parentRoute: typeof ARelatorioEstoqueRouteRoute;
    };
    '/a/relatorio/financeiro/': {
      id: '/a/relatorio/financeiro/';
      path: '/';
      fullPath: '/a/relatorio/financeiro/';
      preLoaderRoute: typeof ARelatorioFinanceiroIndexRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/balancete': {
      id: '/a/relatorio/financeiro/balancete';
      path: '/balancete';
      fullPath: '/a/relatorio/financeiro/balancete';
      preLoaderRoute: typeof ARelatorioFinanceiroBalanceteRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/boletos-recebidos': {
      id: '/a/relatorio/financeiro/boletos-recebidos';
      path: '/boletos-recebidos';
      fullPath: '/a/relatorio/financeiro/boletos-recebidos';
      preLoaderRoute: typeof ARelatorioFinanceiroBoletosRecebidosRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/contas-pagar': {
      id: '/a/relatorio/financeiro/contas-pagar';
      path: '/contas-pagar';
      fullPath: '/a/relatorio/financeiro/contas-pagar';
      preLoaderRoute: typeof ARelatorioFinanceiroContasPagarRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/contas-receber': {
      id: '/a/relatorio/financeiro/contas-receber';
      path: '/contas-receber';
      fullPath: '/a/relatorio/financeiro/contas-receber';
      preLoaderRoute: typeof ARelatorioFinanceiroContasReceberRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/contas-recebidas': {
      id: '/a/relatorio/financeiro/contas-recebidas';
      path: '/contas-recebidas';
      fullPath: '/a/relatorio/financeiro/contas-recebidas';
      preLoaderRoute: typeof ARelatorioFinanceiroContasRecebidasRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/dre': {
      id: '/a/relatorio/financeiro/dre';
      path: '/dre';
      fullPath: '/a/relatorio/financeiro/dre';
      preLoaderRoute: typeof ARelatorioFinanceiroDreRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/entradas-saidas': {
      id: '/a/relatorio/financeiro/entradas-saidas';
      path: '/entradas-saidas';
      fullPath: '/a/relatorio/financeiro/entradas-saidas';
      preLoaderRoute: typeof ARelatorioFinanceiroEntradasSaidasRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/fluxo-caixa': {
      id: '/a/relatorio/financeiro/fluxo-caixa';
      path: '/fluxo-caixa';
      fullPath: '/a/relatorio/financeiro/fluxo-caixa';
      preLoaderRoute: typeof ARelatorioFinanceiroFluxoCaixaRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/lancamentos-contas-receber': {
      id: '/a/relatorio/financeiro/lancamentos-contas-receber';
      path: '/lancamentos-contas-receber';
      fullPath: '/a/relatorio/financeiro/lancamentos-contas-receber';
      preLoaderRoute: typeof ARelatorioFinanceiroLancamentosContasReceberRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/pagamentos': {
      id: '/a/relatorio/financeiro/pagamentos';
      path: '/pagamentos';
      fullPath: '/a/relatorio/financeiro/pagamentos';
      preLoaderRoute: typeof ARelatorioFinanceiroPagamentosRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/relacao-boletos': {
      id: '/a/relatorio/financeiro/relacao-boletos';
      path: '/relacao-boletos';
      fullPath: '/a/relatorio/financeiro/relacao-boletos';
      preLoaderRoute: typeof ARelatorioFinanceiroRelacaoBoletosRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/financeiro/totais-por-categoria': {
      id: '/a/relatorio/financeiro/totais-por-categoria';
      path: '/totais-por-categoria';
      fullPath: '/a/relatorio/financeiro/totais-por-categoria';
      preLoaderRoute: typeof ARelatorioFinanceiroTotaisPorCategoriaRouteImport;
      parentRoute: typeof ARelatorioFinanceiroRouteRoute;
    };
    '/a/relatorio/fiscal/': {
      id: '/a/relatorio/fiscal/';
      path: '/';
      fullPath: '/a/relatorio/fiscal/';
      preLoaderRoute: typeof ARelatorioFiscalIndexRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/fiscal/itens-notas-fiscais': {
      id: '/a/relatorio/fiscal/itens-notas-fiscais';
      path: '/itens-notas-fiscais';
      fullPath: '/a/relatorio/fiscal/itens-notas-fiscais';
      preLoaderRoute: typeof ARelatorioFiscalItensNotasFiscaisRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/fiscal/notas-fiscais-cliente': {
      id: '/a/relatorio/fiscal/notas-fiscais-cliente';
      path: '/notas-fiscais-cliente';
      fullPath: '/a/relatorio/fiscal/notas-fiscais-cliente';
      preLoaderRoute: typeof ARelatorioFiscalNotasFiscaisClienteRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/fiscal/notas-fiscais-produto': {
      id: '/a/relatorio/fiscal/notas-fiscais-produto';
      path: '/notas-fiscais-produto';
      fullPath: '/a/relatorio/fiscal/notas-fiscais-produto';
      preLoaderRoute: typeof ARelatorioFiscalNotasFiscaisProdutoRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/fiscal/notas-fiscais-tipo': {
      id: '/a/relatorio/fiscal/notas-fiscais-tipo';
      path: '/notas-fiscais-tipo';
      fullPath: '/a/relatorio/fiscal/notas-fiscais-tipo';
      preLoaderRoute: typeof ARelatorioFiscalNotasFiscaisTipoRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/fiscal/relacao-documentos': {
      id: '/a/relatorio/fiscal/relacao-documentos';
      path: '/relacao-documentos';
      fullPath: '/a/relatorio/fiscal/relacao-documentos';
      preLoaderRoute: typeof ARelatorioFiscalRelacaoDocumentosRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/fiscal/relacao-sequencias-inutilizadas': {
      id: '/a/relatorio/fiscal/relacao-sequencias-inutilizadas';
      path: '/relacao-sequencias-inutilizadas';
      fullPath: '/a/relatorio/fiscal/relacao-sequencias-inutilizadas';
      preLoaderRoute: typeof ARelatorioFiscalRelacaoSequenciasInutilizadasRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/fiscal/total-agrupado-cfop': {
      id: '/a/relatorio/fiscal/total-agrupado-cfop';
      path: '/total-agrupado-cfop';
      fullPath: '/a/relatorio/fiscal/total-agrupado-cfop';
      preLoaderRoute: typeof ARelatorioFiscalTotalAgrupadoCfopRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/fiscal/total-agrupado-forma-pagamento': {
      id: '/a/relatorio/fiscal/total-agrupado-forma-pagamento';
      path: '/total-agrupado-forma-pagamento';
      fullPath: '/a/relatorio/fiscal/total-agrupado-forma-pagamento';
      preLoaderRoute: typeof ARelatorioFiscalTotalAgrupadoFormaPagamentoRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/fiscal/total-agrupado-ncm': {
      id: '/a/relatorio/fiscal/total-agrupado-ncm';
      path: '/total-agrupado-ncm';
      fullPath: '/a/relatorio/fiscal/total-agrupado-ncm';
      preLoaderRoute: typeof ARelatorioFiscalTotalAgrupadoNcmRouteImport;
      parentRoute: typeof ARelatorioFiscalRouteRoute;
    };
    '/a/relatorio/venda/': {
      id: '/a/relatorio/venda/';
      path: '/';
      fullPath: '/a/relatorio/venda/';
      preLoaderRoute: typeof ARelatorioVendaIndexRouteImport;
      parentRoute: typeof ARelatorioVendaRouteRoute;
    };
    '/a/relatorio/venda/comissoes': {
      id: '/a/relatorio/venda/comissoes';
      path: '/comissoes';
      fullPath: '/a/relatorio/venda/comissoes';
      preLoaderRoute: typeof ARelatorioVendaComissoesRouteImport;
      parentRoute: typeof ARelatorioVendaRouteRoute;
    };
    '/a/relatorio/venda/produtos-mais-vendidos': {
      id: '/a/relatorio/venda/produtos-mais-vendidos';
      path: '/produtos-mais-vendidos';
      fullPath: '/a/relatorio/venda/produtos-mais-vendidos';
      preLoaderRoute: typeof ARelatorioVendaProdutosMaisVendidosRouteImport;
      parentRoute: typeof ARelatorioVendaRouteRoute;
    };
    '/a/relatorio/venda/relacao-vendas': {
      id: '/a/relatorio/venda/relacao-vendas';
      path: '/relacao-vendas';
      fullPath: '/a/relatorio/venda/relacao-vendas';
      preLoaderRoute: typeof ARelatorioVendaRelacaoVendasRouteImport;
      parentRoute: typeof ARelatorioVendaRouteRoute;
    };
    '/a/relatorio/venda/relacao-vendas-produto': {
      id: '/a/relatorio/venda/relacao-vendas-produto';
      path: '/relacao-vendas-produto';
      fullPath: '/a/relatorio/venda/relacao-vendas-produto';
      preLoaderRoute: typeof ARelatorioVendaRelacaoVendasProdutoRouteImport;
      parentRoute: typeof ARelatorioVendaRouteRoute;
    };
    '/a/relatorio/venda/relacao-vendas-resumido': {
      id: '/a/relatorio/venda/relacao-vendas-resumido';
      path: '/relacao-vendas-resumido';
      fullPath: '/a/relatorio/venda/relacao-vendas-resumido';
      preLoaderRoute: typeof ARelatorioVendaRelacaoVendasResumidoRouteImport;
      parentRoute: typeof ARelatorioVendaRouteRoute;
    };
    '/a/relatorio/venda/total-forma-pagamento': {
      id: '/a/relatorio/venda/total-forma-pagamento';
      path: '/total-forma-pagamento';
      fullPath: '/a/relatorio/venda/total-forma-pagamento';
      preLoaderRoute: typeof ARelatorioVendaTotalFormaPagamentoRouteImport;
      parentRoute: typeof ARelatorioVendaRouteRoute;
    };
    '/a/relatorio/venda/vendas-cliente': {
      id: '/a/relatorio/venda/vendas-cliente';
      path: '/vendas-cliente';
      fullPath: '/a/relatorio/venda/vendas-cliente';
      preLoaderRoute: typeof ARelatorioVendaVendasClienteRouteImport;
      parentRoute: typeof ARelatorioVendaRouteRoute;
    };
    '/a/relatorio/venda/vendas-vendedor': {
      id: '/a/relatorio/venda/vendas-vendedor';
      path: '/vendas-vendedor';
      fullPath: '/a/relatorio/venda/vendas-vendedor';
      preLoaderRoute: typeof ARelatorioVendaVendasVendedorRouteImport;
      parentRoute: typeof ARelatorioVendaRouteRoute;
    };
    '/a/renegociacao/contas-pagar/': {
      id: '/a/renegociacao/contas-pagar/';
      path: '/';
      fullPath: '/a/renegociacao/contas-pagar/';
      preLoaderRoute: typeof ARenegociacaoContasPagarIndexRouteImport;
      parentRoute: typeof ARenegociacaoContasPagarRouteRoute;
    };
    '/a/renegociacao/contas-pagar/cadastrar': {
      id: '/a/renegociacao/contas-pagar/cadastrar';
      path: '/cadastrar';
      fullPath: '/a/renegociacao/contas-pagar/cadastrar';
      preLoaderRoute: typeof ARenegociacaoContasPagarCadastrarRouteImport;
      parentRoute: typeof ARenegociacaoContasPagarRouteRoute;
    };
    '/a/renegociacao/contas-receber/': {
      id: '/a/renegociacao/contas-receber/';
      path: '/';
      fullPath: '/a/renegociacao/contas-receber/';
      preLoaderRoute: typeof ARenegociacaoContasReceberIndexRouteImport;
      parentRoute: typeof ARenegociacaoContasReceberRouteRoute;
    };
    '/a/renegociacao/contas-receber/cadastrar': {
      id: '/a/renegociacao/contas-receber/cadastrar';
      path: '/cadastrar';
      fullPath: '/a/renegociacao/contas-receber/cadastrar';
      preLoaderRoute: typeof ARenegociacaoContasReceberCadastrarRouteImport;
      parentRoute: typeof ARenegociacaoContasReceberRouteRoute;
    };
    '/a/romaneio/$action/{-$idpk}': {
      id: '/a/romaneio/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/romaneio/$action/{-$idpk}';
      preLoaderRoute: typeof ARomaneioActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ARomaneioRouteRoute;
    };
    '/a/separacao/$type/$idpk': {
      id: '/a/separacao/$type/$idpk';
      path: '/separacao/$type/$idpk';
      fullPath: '/a/separacao/$type/$idpk';
      preLoaderRoute: typeof ASeparacaoTypeIdpkRouteImport;
      parentRoute: typeof ARouteRoute;
    };
    '/a/servico/$action/{-$idpk}': {
      id: '/a/servico/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/servico/$action/{-$idpk}';
      preLoaderRoute: typeof AServicoActionChar123IdpkChar125RouteImport;
      parentRoute: typeof AServicoRouteRoute;
    };
    '/a/sped-fiscal/$action/{-$idpk}': {
      id: '/a/sped-fiscal/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/sped-fiscal/$action/{-$idpk}';
      preLoaderRoute: typeof ASpedFiscalActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ASpedFiscalRouteRoute;
    };
    '/a/transportador/$action/{-$idpk}': {
      id: '/a/transportador/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/transportador/$action/{-$idpk}';
      preLoaderRoute: typeof ATransportadorActionChar123IdpkChar125RouteImport;
      parentRoute: typeof ATransportadorRouteRoute;
    };
    '/a/venda-externa/$action/{-$idpk}': {
      id: '/a/venda-externa/$action/{-$idpk}';
      path: '/$action/{-$idpk}';
      fullPath: '/a/venda-externa/$action/{-$idpk}';
      preLoaderRoute: typeof AVendaExternaActionChar123IdpkChar125RouteImport;
      parentRoute: typeof AVendaExternaRouteRoute;
    };
    '/a/venda/$action/$idpk': {
      id: '/a/venda/$action/$idpk';
      path: '/$action/$idpk';
      fullPath: '/a/venda/$action/$idpk';
      preLoaderRoute: typeof AVendaActionIdpkRouteImport;
      parentRoute: typeof AVendaRouteRoute;
    };
    '/a/venda/$tipo/': {
      id: '/a/venda/$tipo/';
      path: '/$tipo';
      fullPath: '/a/venda/$tipo/';
      preLoaderRoute: typeof AVendaTipoIndexRouteImport;
      parentRoute: typeof AVendaRouteRoute;
    };
    '/a/venda/cadastrar/$tipo': {
      id: '/a/venda/cadastrar/$tipo';
      path: '/cadastrar/$tipo';
      fullPath: '/a/venda/cadastrar/$tipo';
      preLoaderRoute: typeof AVendaCadastrarTipoRouteImport;
      parentRoute: typeof AVendaRouteRoute;
    };
    '/admin/_a/configuracao/representante': {
      id: '/admin/_a/configuracao/representante';
      path: '/configuracao/representante';
      fullPath: '/admin/configuracao/representante';
      preLoaderRoute: typeof AdminAConfiguracaoRepresentanteRouteImport;
      parentRoute: typeof AdminARouteRoute;
    };
    '/p/catalogo/$slug/': {
      id: '/p/catalogo/$slug/';
      path: '/';
      fullPath: '/p/catalogo/$slug/';
      preLoaderRoute: typeof PCatalogoSlugIndexRouteImport;
      parentRoute: typeof PCatalogoSlugRouteRoute;
    };
    '/p/catalogo/$slug/_default': {
      id: '/p/catalogo/$slug/_default';
      path: '';
      fullPath: '/p/catalogo/$slug';
      preLoaderRoute: typeof PCatalogoSlugDefaultRouteRouteImport;
      parentRoute: typeof PCatalogoSlugRouteRoute;
    };
    '/p/catalogo/$slug/auth': {
      id: '/p/catalogo/$slug/auth';
      path: '/auth';
      fullPath: '/p/catalogo/$slug/auth';
      preLoaderRoute: typeof PCatalogoSlugAuthRouteRouteImport;
      parentRoute: typeof PCatalogoSlugRouteRoute;
    };
    '/p/conta-digital/termos-de-uso/$base64': {
      id: '/p/conta-digital/termos-de-uso/$base64';
      path: '/p/conta-digital/termos-de-uso/$base64';
      fullPath: '/p/conta-digital/termos-de-uso/$base64';
      preLoaderRoute: typeof PContaDigitalTermosDeUsoBase64RouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/p/pagamento/$id/': {
      id: '/p/pagamento/$id/';
      path: '/p/pagamento/$id';
      fullPath: '/p/pagamento/$id/';
      preLoaderRoute: typeof PPagamentoIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/a/romaneio/impressao/carga/$idpk': {
      id: '/a/romaneio/impressao/carga/$idpk';
      path: '/impressao/carga/$idpk';
      fullPath: '/a/romaneio/impressao/carga/$idpk';
      preLoaderRoute: typeof ARomaneioImpressaoCargaIdpkRouteImport;
      parentRoute: typeof ARomaneioRouteRoute;
    };
    '/a/romaneio/impressao/entrega/$idpk': {
      id: '/a/romaneio/impressao/entrega/$idpk';
      path: '/impressao/entrega/$idpk';
      fullPath: '/a/romaneio/impressao/entrega/$idpk';
      preLoaderRoute: typeof ARomaneioImpressaoEntregaIdpkRouteImport;
      parentRoute: typeof ARomaneioRouteRoute;
    };
    '/a/romaneio/impressao/padrao/$idpk': {
      id: '/a/romaneio/impressao/padrao/$idpk';
      path: '/impressao/padrao/$idpk';
      fullPath: '/a/romaneio/impressao/padrao/$idpk';
      preLoaderRoute: typeof ARomaneioImpressaoPadraoIdpkRouteImport;
      parentRoute: typeof ARomaneioRouteRoute;
    };
    '/a/venda/clonar/$tipo/$idpk': {
      id: '/a/venda/clonar/$tipo/$idpk';
      path: '/clonar/$tipo/$idpk';
      fullPath: '/a/venda/clonar/$tipo/$idpk';
      preLoaderRoute: typeof AVendaClonarTipoIdpkRouteImport;
      parentRoute: typeof AVendaRouteRoute;
    };
    '/admin/_a/empresa_/$action/{-$idpk}': {
      id: '/admin/_a/empresa_/$action/{-$idpk}';
      path: '/empresa/$action/{-$idpk}';
      fullPath: '/admin/empresa/$action/{-$idpk}';
      preLoaderRoute: typeof AdminAEmpresaActionChar123IdpkChar125RouteImport;
      parentRoute: typeof AdminARouteRoute;
    };
    '/p/catalogo/$slug/_default/finalizar': {
      id: '/p/catalogo/$slug/_default/finalizar';
      path: '/finalizar';
      fullPath: '/p/catalogo/$slug/finalizar';
      preLoaderRoute: typeof PCatalogoSlugDefaultFinalizarRouteImport;
      parentRoute: typeof PCatalogoSlugDefaultRouteRoute;
    };
    '/p/catalogo/$slug/_default/produtos': {
      id: '/p/catalogo/$slug/_default/produtos';
      path: '/produtos';
      fullPath: '/p/catalogo/$slug/produtos';
      preLoaderRoute: typeof PCatalogoSlugDefaultProdutosRouteImport;
      parentRoute: typeof PCatalogoSlugDefaultRouteRoute;
    };
    '/p/catalogo/$slug/_default/usuario': {
      id: '/p/catalogo/$slug/_default/usuario';
      path: '/usuario';
      fullPath: '/p/catalogo/$slug/usuario';
      preLoaderRoute: typeof PCatalogoSlugDefaultUsuarioRouteRouteImport;
      parentRoute: typeof PCatalogoSlugDefaultRouteRoute;
    };
    '/p/catalogo/$slug/auth/cadastrar': {
      id: '/p/catalogo/$slug/auth/cadastrar';
      path: '/cadastrar';
      fullPath: '/p/catalogo/$slug/auth/cadastrar';
      preLoaderRoute: typeof PCatalogoSlugAuthCadastrarRouteImport;
      parentRoute: typeof PCatalogoSlugAuthRouteRoute;
    };
    '/p/catalogo/$slug/auth/entrar': {
      id: '/p/catalogo/$slug/auth/entrar';
      path: '/entrar';
      fullPath: '/p/catalogo/$slug/auth/entrar';
      preLoaderRoute: typeof PCatalogoSlugAuthEntrarRouteImport;
      parentRoute: typeof PCatalogoSlugAuthRouteRoute;
    };
    '/p/catalogo/$slug/auth/recuperar-senha': {
      id: '/p/catalogo/$slug/auth/recuperar-senha';
      path: '/recuperar-senha';
      fullPath: '/p/catalogo/$slug/auth/recuperar-senha';
      preLoaderRoute: typeof PCatalogoSlugAuthRecuperarSenhaRouteImport;
      parentRoute: typeof PCatalogoSlugAuthRouteRoute;
    };
    '/p/catalogo/$slug/auth/validar-codigo': {
      id: '/p/catalogo/$slug/auth/validar-codigo';
      path: '/validar-codigo';
      fullPath: '/p/catalogo/$slug/auth/validar-codigo';
      preLoaderRoute: typeof PCatalogoSlugAuthValidarCodigoRouteImport;
      parentRoute: typeof PCatalogoSlugAuthRouteRoute;
    };
    '/p/catalogo/$slug/_default/usuario/perfil': {
      id: '/p/catalogo/$slug/_default/usuario/perfil';
      path: '/perfil';
      fullPath: '/p/catalogo/$slug/usuario/perfil';
      preLoaderRoute: typeof PCatalogoSlugDefaultUsuarioPerfilRouteImport;
      parentRoute: typeof PCatalogoSlugDefaultUsuarioRouteRoute;
    };
  }
}

interface AClienteRouteRouteChildren {
  AClienteIndexRoute: typeof AClienteIndexRoute;
  AClienteActionChar123IdpkChar125Route: typeof AClienteActionChar123IdpkChar125Route;
}

const AClienteRouteRouteChildren: AClienteRouteRouteChildren = {
  AClienteIndexRoute: AClienteIndexRoute,
  AClienteActionChar123IdpkChar125Route: AClienteActionChar123IdpkChar125Route,
};

const AClienteRouteRouteWithChildren = AClienteRouteRoute._addFileChildren(
  AClienteRouteRouteChildren,
);

interface ACobrancaBoletoRouteRouteChildren {
  ACobrancaBoletoRotinasBancariasRoute: typeof ACobrancaBoletoRotinasBancariasRoute;
  ACobrancaBoletoIndexRoute: typeof ACobrancaBoletoIndexRoute;
  ACobrancaBoletoActionChar123IdpkChar125Route: typeof ACobrancaBoletoActionChar123IdpkChar125Route;
}

const ACobrancaBoletoRouteRouteChildren: ACobrancaBoletoRouteRouteChildren = {
  ACobrancaBoletoRotinasBancariasRoute: ACobrancaBoletoRotinasBancariasRoute,
  ACobrancaBoletoIndexRoute: ACobrancaBoletoIndexRoute,
  ACobrancaBoletoActionChar123IdpkChar125Route:
    ACobrancaBoletoActionChar123IdpkChar125Route,
};

const ACobrancaBoletoRouteRouteWithChildren =
  ACobrancaBoletoRouteRoute._addFileChildren(ACobrancaBoletoRouteRouteChildren);

interface ACobrancaCartaoRouteRouteChildren {
  ACobrancaCartaoCadastrarRoute: typeof ACobrancaCartaoCadastrarRoute;
  ACobrancaCartaoIndexRoute: typeof ACobrancaCartaoIndexRoute;
}

const ACobrancaCartaoRouteRouteChildren: ACobrancaCartaoRouteRouteChildren = {
  ACobrancaCartaoCadastrarRoute: ACobrancaCartaoCadastrarRoute,
  ACobrancaCartaoIndexRoute: ACobrancaCartaoIndexRoute,
};

const ACobrancaCartaoRouteRouteWithChildren =
  ACobrancaCartaoRouteRoute._addFileChildren(ACobrancaCartaoRouteRouteChildren);

interface ACobrancaPixRouteRouteChildren {
  ACobrancaPixIndexRoute: typeof ACobrancaPixIndexRoute;
}

const ACobrancaPixRouteRouteChildren: ACobrancaPixRouteRouteChildren = {
  ACobrancaPixIndexRoute: ACobrancaPixIndexRoute,
};

const ACobrancaPixRouteRouteWithChildren =
  ACobrancaPixRouteRoute._addFileChildren(ACobrancaPixRouteRouteChildren);

interface AComissaoRouteRouteChildren {
  AComissaoIndexRoute: typeof AComissaoIndexRoute;
}

const AComissaoRouteRouteChildren: AComissaoRouteRouteChildren = {
  AComissaoIndexRoute: AComissaoIndexRoute,
};

const AComissaoRouteRouteWithChildren = AComissaoRouteRoute._addFileChildren(
  AComissaoRouteRouteChildren,
);

interface ACompraRouteRouteChildren {
  ACompraCompraRoute: typeof ACompraCompraRoute;
  ACompraImportacaoNfeRoute: typeof ACompraImportacaoNfeRoute;
  ACompraManifestadorRoute: typeof ACompraManifestadorRoute;
  ACompraActionChar123IdpkChar125Route: typeof ACompraActionChar123IdpkChar125Route;
  ACompraClonarIdpkRoute: typeof ACompraClonarIdpkRoute;
}

const ACompraRouteRouteChildren: ACompraRouteRouteChildren = {
  ACompraCompraRoute: ACompraCompraRoute,
  ACompraImportacaoNfeRoute: ACompraImportacaoNfeRoute,
  ACompraManifestadorRoute: ACompraManifestadorRoute,
  ACompraActionChar123IdpkChar125Route: ACompraActionChar123IdpkChar125Route,
  ACompraClonarIdpkRoute: ACompraClonarIdpkRoute,
};

const ACompraRouteRouteWithChildren = ACompraRouteRoute._addFileChildren(
  ACompraRouteRouteChildren,
);

interface AContasPagarRouteRouteChildren {
  AContasPagarIndexRoute: typeof AContasPagarIndexRoute;
  AContasPagarActionChar123IdpkChar125Route: typeof AContasPagarActionChar123IdpkChar125Route;
}

const AContasPagarRouteRouteChildren: AContasPagarRouteRouteChildren = {
  AContasPagarIndexRoute: AContasPagarIndexRoute,
  AContasPagarActionChar123IdpkChar125Route:
    AContasPagarActionChar123IdpkChar125Route,
};

const AContasPagarRouteRouteWithChildren =
  AContasPagarRouteRoute._addFileChildren(AContasPagarRouteRouteChildren);

interface AContasReceberRouteRouteChildren {
  AContasReceberIndexRoute: typeof AContasReceberIndexRoute;
  AContasReceberActionChar123IdpkChar125Route: typeof AContasReceberActionChar123IdpkChar125Route;
}

const AContasReceberRouteRouteChildren: AContasReceberRouteRouteChildren = {
  AContasReceberIndexRoute: AContasReceberIndexRoute,
  AContasReceberActionChar123IdpkChar125Route:
    AContasReceberActionChar123IdpkChar125Route,
};

const AContasReceberRouteRouteWithChildren =
  AContasReceberRouteRoute._addFileChildren(AContasReceberRouteRouteChildren);

interface ACupomFiscalRouteRouteChildren {
  ACupomFiscalIndexRoute: typeof ACupomFiscalIndexRoute;
}

const ACupomFiscalRouteRouteChildren: ACupomFiscalRouteRouteChildren = {
  ACupomFiscalIndexRoute: ACupomFiscalIndexRoute,
};

const ACupomFiscalRouteRouteWithChildren =
  ACupomFiscalRouteRoute._addFileChildren(ACupomFiscalRouteRouteChildren);

interface ADebugRouteRouteChildren {
  ADebugIndexRoute: typeof ADebugIndexRoute;
}

const ADebugRouteRouteChildren: ADebugRouteRouteChildren = {
  ADebugIndexRoute: ADebugIndexRoute,
};

const ADebugRouteRouteWithChildren = ADebugRouteRoute._addFileChildren(
  ADebugRouteRouteChildren,
);

interface ADevolucaoRouteRouteChildren {
  ADevolucaoIndexRoute: typeof ADevolucaoIndexRoute;
  ADevolucaoActionChar123IdpkChar125Route: typeof ADevolucaoActionChar123IdpkChar125Route;
}

const ADevolucaoRouteRouteChildren: ADevolucaoRouteRouteChildren = {
  ADevolucaoIndexRoute: ADevolucaoIndexRoute,
  ADevolucaoActionChar123IdpkChar125Route:
    ADevolucaoActionChar123IdpkChar125Route,
};

const ADevolucaoRouteRouteWithChildren = ADevolucaoRouteRoute._addFileChildren(
  ADevolucaoRouteRouteChildren,
);

interface AEstoqueRouteRouteChildren {
  AEstoqueConferenciaRoute: typeof AEstoqueConferenciaRoute;
  AEstoqueMovimentacaoRoute: typeof AEstoqueMovimentacaoRoute;
}

const AEstoqueRouteRouteChildren: AEstoqueRouteRouteChildren = {
  AEstoqueConferenciaRoute: AEstoqueConferenciaRoute,
  AEstoqueMovimentacaoRoute: AEstoqueMovimentacaoRoute,
};

const AEstoqueRouteRouteWithChildren = AEstoqueRouteRoute._addFileChildren(
  AEstoqueRouteRouteChildren,
);

interface AExtratoBoletoRouteRouteChildren {
  AExtratoBoletoIndexRoute: typeof AExtratoBoletoIndexRoute;
}

const AExtratoBoletoRouteRouteChildren: AExtratoBoletoRouteRouteChildren = {
  AExtratoBoletoIndexRoute: AExtratoBoletoIndexRoute,
};

const AExtratoBoletoRouteRouteWithChildren =
  AExtratoBoletoRouteRoute._addFileChildren(AExtratoBoletoRouteRouteChildren);

interface AExtratoPixRouteRouteChildren {
  AExtratoPixIndexRoute: typeof AExtratoPixIndexRoute;
}

const AExtratoPixRouteRouteChildren: AExtratoPixRouteRouteChildren = {
  AExtratoPixIndexRoute: AExtratoPixIndexRoute,
};

const AExtratoPixRouteRouteWithChildren =
  AExtratoPixRouteRoute._addFileChildren(AExtratoPixRouteRouteChildren);

interface AFornecedorRouteRouteChildren {
  AFornecedorIndexRoute: typeof AFornecedorIndexRoute;
}

const AFornecedorRouteRouteChildren: AFornecedorRouteRouteChildren = {
  AFornecedorIndexRoute: AFornecedorIndexRoute,
};

const AFornecedorRouteRouteWithChildren =
  AFornecedorRouteRoute._addFileChildren(AFornecedorRouteRouteChildren);

interface AManifestoCargaRouteRouteChildren {
  AManifestoCargaIndexRoute: typeof AManifestoCargaIndexRoute;
  AManifestoCargaActionChar123IdpkChar125Route: typeof AManifestoCargaActionChar123IdpkChar125Route;
}

const AManifestoCargaRouteRouteChildren: AManifestoCargaRouteRouteChildren = {
  AManifestoCargaIndexRoute: AManifestoCargaIndexRoute,
  AManifestoCargaActionChar123IdpkChar125Route:
    AManifestoCargaActionChar123IdpkChar125Route,
};

const AManifestoCargaRouteRouteWithChildren =
  AManifestoCargaRouteRoute._addFileChildren(AManifestoCargaRouteRouteChildren);

interface AMovimentacoesRouteRouteChildren {
  AMovimentacoesIndexRoute: typeof AMovimentacoesIndexRoute;
  AMovimentacoesActionChar123IdpkChar125Route: typeof AMovimentacoesActionChar123IdpkChar125Route;
  AMovimentacoesExtratoIdpkRoute: typeof AMovimentacoesExtratoIdpkRoute;
}

const AMovimentacoesRouteRouteChildren: AMovimentacoesRouteRouteChildren = {
  AMovimentacoesIndexRoute: AMovimentacoesIndexRoute,
  AMovimentacoesActionChar123IdpkChar125Route:
    AMovimentacoesActionChar123IdpkChar125Route,
  AMovimentacoesExtratoIdpkRoute: AMovimentacoesExtratoIdpkRoute,
};

const AMovimentacoesRouteRouteWithChildren =
  AMovimentacoesRouteRoute._addFileChildren(AMovimentacoesRouteRouteChildren);

interface ANfseRouteRouteChildren {
  ANfseIndexRoute: typeof ANfseIndexRoute;
  ANfseActionChar123IdpkChar125Route: typeof ANfseActionChar123IdpkChar125Route;
}

const ANfseRouteRouteChildren: ANfseRouteRouteChildren = {
  ANfseIndexRoute: ANfseIndexRoute,
  ANfseActionChar123IdpkChar125Route: ANfseActionChar123IdpkChar125Route,
};

const ANfseRouteRouteWithChildren = ANfseRouteRoute._addFileChildren(
  ANfseRouteRouteChildren,
);

interface ANotaFiscalRouteRouteChildren {
  ANotaFiscalCadastrarRoute: typeof ANotaFiscalCadastrarRoute;
  ANotaFiscalIndexRoute: typeof ANotaFiscalIndexRoute;
  ANotaFiscalActionChar123IdpkChar125Route: typeof ANotaFiscalActionChar123IdpkChar125Route;
}

const ANotaFiscalRouteRouteChildren: ANotaFiscalRouteRouteChildren = {
  ANotaFiscalCadastrarRoute: ANotaFiscalCadastrarRoute,
  ANotaFiscalIndexRoute: ANotaFiscalIndexRoute,
  ANotaFiscalActionChar123IdpkChar125Route:
    ANotaFiscalActionChar123IdpkChar125Route,
};

const ANotaFiscalRouteRouteWithChildren =
  ANotaFiscalRouteRoute._addFileChildren(ANotaFiscalRouteRouteChildren);

interface ANotificacaoRouteRouteChildren {
  ANotificacaoListagemRoute: typeof ANotificacaoListagemRoute;
}

const ANotificacaoRouteRouteChildren: ANotificacaoRouteRouteChildren = {
  ANotificacaoListagemRoute: ANotificacaoListagemRoute,
};

const ANotificacaoRouteRouteWithChildren =
  ANotificacaoRouteRoute._addFileChildren(ANotificacaoRouteRouteChildren);

interface APagforRouteRouteChildren {
  APagforImportarRoute: typeof APagforImportarRoute;
  APagforListagemRoute: typeof APagforListagemRoute;
  APagforActionChar123IdpkChar125Route: typeof APagforActionChar123IdpkChar125Route;
}

const APagforRouteRouteChildren: APagforRouteRouteChildren = {
  APagforImportarRoute: APagforImportarRoute,
  APagforListagemRoute: APagforListagemRoute,
  APagforActionChar123IdpkChar125Route: APagforActionChar123IdpkChar125Route,
};

const APagforRouteRouteWithChildren = APagforRouteRoute._addFileChildren(
  APagforRouteRouteChildren,
);

interface AProdutoRouteRouteChildren {
  AProdutoIndexRoute: typeof AProdutoIndexRoute;
  AProdutoActionChar123IdpkChar125Route: typeof AProdutoActionChar123IdpkChar125Route;
}

const AProdutoRouteRouteChildren: AProdutoRouteRouteChildren = {
  AProdutoIndexRoute: AProdutoIndexRoute,
  AProdutoActionChar123IdpkChar125Route: AProdutoActionChar123IdpkChar125Route,
};

const AProdutoRouteRouteWithChildren = AProdutoRouteRoute._addFileChildren(
  AProdutoRouteRouteChildren,
);

interface ARegraFiscalRouteRouteChildren {
  ARegraFiscalIndexRoute: typeof ARegraFiscalIndexRoute;
  ARegraFiscalActionChar123IdpkChar125Route: typeof ARegraFiscalActionChar123IdpkChar125Route;
}

const ARegraFiscalRouteRouteChildren: ARegraFiscalRouteRouteChildren = {
  ARegraFiscalIndexRoute: ARegraFiscalIndexRoute,
  ARegraFiscalActionChar123IdpkChar125Route:
    ARegraFiscalActionChar123IdpkChar125Route,
};

const ARegraFiscalRouteRouteWithChildren =
  ARegraFiscalRouteRoute._addFileChildren(ARegraFiscalRouteRouteChildren);

interface ARomaneioRouteRouteChildren {
  ARomaneioIndexRoute: typeof ARomaneioIndexRoute;
  ARomaneioActionChar123IdpkChar125Route: typeof ARomaneioActionChar123IdpkChar125Route;
  ARomaneioImpressaoCargaIdpkRoute: typeof ARomaneioImpressaoCargaIdpkRoute;
  ARomaneioImpressaoEntregaIdpkRoute: typeof ARomaneioImpressaoEntregaIdpkRoute;
  ARomaneioImpressaoPadraoIdpkRoute: typeof ARomaneioImpressaoPadraoIdpkRoute;
}

const ARomaneioRouteRouteChildren: ARomaneioRouteRouteChildren = {
  ARomaneioIndexRoute: ARomaneioIndexRoute,
  ARomaneioActionChar123IdpkChar125Route:
    ARomaneioActionChar123IdpkChar125Route,
  ARomaneioImpressaoCargaIdpkRoute: ARomaneioImpressaoCargaIdpkRoute,
  ARomaneioImpressaoEntregaIdpkRoute: ARomaneioImpressaoEntregaIdpkRoute,
  ARomaneioImpressaoPadraoIdpkRoute: ARomaneioImpressaoPadraoIdpkRoute,
};

const ARomaneioRouteRouteWithChildren = ARomaneioRouteRoute._addFileChildren(
  ARomaneioRouteRouteChildren,
);

interface ASecundarioRouteRouteChildren {
  ASecundarioIndexRoute: typeof ASecundarioIndexRoute;
}

const ASecundarioRouteRouteChildren: ASecundarioRouteRouteChildren = {
  ASecundarioIndexRoute: ASecundarioIndexRoute,
};

const ASecundarioRouteRouteWithChildren =
  ASecundarioRouteRoute._addFileChildren(ASecundarioRouteRouteChildren);

interface AServicoRouteRouteChildren {
  AServicoIndexRoute: typeof AServicoIndexRoute;
  AServicoActionChar123IdpkChar125Route: typeof AServicoActionChar123IdpkChar125Route;
}

const AServicoRouteRouteChildren: AServicoRouteRouteChildren = {
  AServicoIndexRoute: AServicoIndexRoute,
  AServicoActionChar123IdpkChar125Route: AServicoActionChar123IdpkChar125Route,
};

const AServicoRouteRouteWithChildren = AServicoRouteRoute._addFileChildren(
  AServicoRouteRouteChildren,
);

interface ASpedFiscalRouteRouteChildren {
  ASpedFiscalIndexRoute: typeof ASpedFiscalIndexRoute;
  ASpedFiscalActionChar123IdpkChar125Route: typeof ASpedFiscalActionChar123IdpkChar125Route;
}

const ASpedFiscalRouteRouteChildren: ASpedFiscalRouteRouteChildren = {
  ASpedFiscalIndexRoute: ASpedFiscalIndexRoute,
  ASpedFiscalActionChar123IdpkChar125Route:
    ASpedFiscalActionChar123IdpkChar125Route,
};

const ASpedFiscalRouteRouteWithChildren =
  ASpedFiscalRouteRoute._addFileChildren(ASpedFiscalRouteRouteChildren);

interface ATransportadorRouteRouteChildren {
  ATransportadorIndexRoute: typeof ATransportadorIndexRoute;
  ATransportadorActionChar123IdpkChar125Route: typeof ATransportadorActionChar123IdpkChar125Route;
}

const ATransportadorRouteRouteChildren: ATransportadorRouteRouteChildren = {
  ATransportadorIndexRoute: ATransportadorIndexRoute,
  ATransportadorActionChar123IdpkChar125Route:
    ATransportadorActionChar123IdpkChar125Route,
};

const ATransportadorRouteRouteWithChildren =
  ATransportadorRouteRoute._addFileChildren(ATransportadorRouteRouteChildren);

interface AVendaRouteRouteChildren {
  AVendaActionIdpkRoute: typeof AVendaActionIdpkRoute;
  AVendaCadastrarTipoRoute: typeof AVendaCadastrarTipoRoute;
  AVendaTipoIndexRoute: typeof AVendaTipoIndexRoute;
  AVendaClonarTipoIdpkRoute: typeof AVendaClonarTipoIdpkRoute;
}

const AVendaRouteRouteChildren: AVendaRouteRouteChildren = {
  AVendaActionIdpkRoute: AVendaActionIdpkRoute,
  AVendaCadastrarTipoRoute: AVendaCadastrarTipoRoute,
  AVendaTipoIndexRoute: AVendaTipoIndexRoute,
  AVendaClonarTipoIdpkRoute: AVendaClonarTipoIdpkRoute,
};

const AVendaRouteRouteWithChildren = AVendaRouteRoute._addFileChildren(
  AVendaRouteRouteChildren,
);

interface AVendaExternaRouteRouteChildren {
  AVendaExternaIndexRoute: typeof AVendaExternaIndexRoute;
  AVendaExternaActionChar123IdpkChar125Route: typeof AVendaExternaActionChar123IdpkChar125Route;
}

const AVendaExternaRouteRouteChildren: AVendaExternaRouteRouteChildren = {
  AVendaExternaIndexRoute: AVendaExternaIndexRoute,
  AVendaExternaActionChar123IdpkChar125Route:
    AVendaExternaActionChar123IdpkChar125Route,
};

const AVendaExternaRouteRouteWithChildren =
  AVendaExternaRouteRoute._addFileChildren(AVendaExternaRouteRouteChildren);

interface AConfiguracaoEmpresaRouteRouteChildren {
  AConfiguracaoEmpresaIndexRoute: typeof AConfiguracaoEmpresaIndexRoute;
}

const AConfiguracaoEmpresaRouteRouteChildren: AConfiguracaoEmpresaRouteRouteChildren =
  {
    AConfiguracaoEmpresaIndexRoute: AConfiguracaoEmpresaIndexRoute,
  };

const AConfiguracaoEmpresaRouteRouteWithChildren =
  AConfiguracaoEmpresaRouteRoute._addFileChildren(
    AConfiguracaoEmpresaRouteRouteChildren,
  );

interface ARelatorioCadastroRouteRouteChildren {
  ARelatorioCadastroCatalogoProdutosRoute: typeof ARelatorioCadastroCatalogoProdutosRoute;
  ARelatorioCadastroControleLotesRoute: typeof ARelatorioCadastroControleLotesRoute;
  ARelatorioCadastroHistoricoAlteracoesPrecoRoute: typeof ARelatorioCadastroHistoricoAlteracoesPrecoRoute;
  ARelatorioCadastroRelacaoClientesRoute: typeof ARelatorioCadastroRelacaoClientesRoute;
  ARelatorioCadastroRelacaoClientesAniversariantesRoute: typeof ARelatorioCadastroRelacaoClientesAniversariantesRoute;
  ARelatorioCadastroRelacaoFornecedoresRoute: typeof ARelatorioCadastroRelacaoFornecedoresRoute;
  ARelatorioCadastroRelacaoProdutosRoute: typeof ARelatorioCadastroRelacaoProdutosRoute;
  ARelatorioCadastroRelacaoTransportadoresRoute: typeof ARelatorioCadastroRelacaoTransportadoresRoute;
  ARelatorioCadastroIndexRoute: typeof ARelatorioCadastroIndexRoute;
}

const ARelatorioCadastroRouteRouteChildren: ARelatorioCadastroRouteRouteChildren =
  {
    ARelatorioCadastroCatalogoProdutosRoute:
      ARelatorioCadastroCatalogoProdutosRoute,
    ARelatorioCadastroControleLotesRoute: ARelatorioCadastroControleLotesRoute,
    ARelatorioCadastroHistoricoAlteracoesPrecoRoute:
      ARelatorioCadastroHistoricoAlteracoesPrecoRoute,
    ARelatorioCadastroRelacaoClientesRoute:
      ARelatorioCadastroRelacaoClientesRoute,
    ARelatorioCadastroRelacaoClientesAniversariantesRoute:
      ARelatorioCadastroRelacaoClientesAniversariantesRoute,
    ARelatorioCadastroRelacaoFornecedoresRoute:
      ARelatorioCadastroRelacaoFornecedoresRoute,
    ARelatorioCadastroRelacaoProdutosRoute:
      ARelatorioCadastroRelacaoProdutosRoute,
    ARelatorioCadastroRelacaoTransportadoresRoute:
      ARelatorioCadastroRelacaoTransportadoresRoute,
    ARelatorioCadastroIndexRoute: ARelatorioCadastroIndexRoute,
  };

const ARelatorioCadastroRouteRouteWithChildren =
  ARelatorioCadastroRouteRoute._addFileChildren(
    ARelatorioCadastroRouteRouteChildren,
  );

interface ARelatorioCompraRouteRouteChildren {
  ARelatorioCompraComprasPorFornecedorRoute: typeof ARelatorioCompraComprasPorFornecedorRoute;
  ARelatorioCompraIndexRoute: typeof ARelatorioCompraIndexRoute;
}

const ARelatorioCompraRouteRouteChildren: ARelatorioCompraRouteRouteChildren = {
  ARelatorioCompraComprasPorFornecedorRoute:
    ARelatorioCompraComprasPorFornecedorRoute,
  ARelatorioCompraIndexRoute: ARelatorioCompraIndexRoute,
};

const ARelatorioCompraRouteRouteWithChildren =
  ARelatorioCompraRouteRoute._addFileChildren(
    ARelatorioCompraRouteRouteChildren,
  );

interface ARelatorioEstoqueRouteRouteChildren {
  ARelatorioEstoqueEstoqueMinimoRoute: typeof ARelatorioEstoqueEstoqueMinimoRoute;
  ARelatorioEstoqueSaldosEmEstoqueRoute: typeof ARelatorioEstoqueSaldosEmEstoqueRoute;
  ARelatorioEstoqueIndexRoute: typeof ARelatorioEstoqueIndexRoute;
}

const ARelatorioEstoqueRouteRouteChildren: ARelatorioEstoqueRouteRouteChildren =
  {
    ARelatorioEstoqueEstoqueMinimoRoute: ARelatorioEstoqueEstoqueMinimoRoute,
    ARelatorioEstoqueSaldosEmEstoqueRoute:
      ARelatorioEstoqueSaldosEmEstoqueRoute,
    ARelatorioEstoqueIndexRoute: ARelatorioEstoqueIndexRoute,
  };

const ARelatorioEstoqueRouteRouteWithChildren =
  ARelatorioEstoqueRouteRoute._addFileChildren(
    ARelatorioEstoqueRouteRouteChildren,
  );

interface ARelatorioFinanceiroRouteRouteChildren {
  ARelatorioFinanceiroBalanceteRoute: typeof ARelatorioFinanceiroBalanceteRoute;
  ARelatorioFinanceiroBoletosRecebidosRoute: typeof ARelatorioFinanceiroBoletosRecebidosRoute;
  ARelatorioFinanceiroContasPagarRoute: typeof ARelatorioFinanceiroContasPagarRoute;
  ARelatorioFinanceiroContasReceberRoute: typeof ARelatorioFinanceiroContasReceberRoute;
  ARelatorioFinanceiroContasRecebidasRoute: typeof ARelatorioFinanceiroContasRecebidasRoute;
  ARelatorioFinanceiroDreRoute: typeof ARelatorioFinanceiroDreRoute;
  ARelatorioFinanceiroEntradasSaidasRoute: typeof ARelatorioFinanceiroEntradasSaidasRoute;
  ARelatorioFinanceiroFluxoCaixaRoute: typeof ARelatorioFinanceiroFluxoCaixaRoute;
  ARelatorioFinanceiroLancamentosContasReceberRoute: typeof ARelatorioFinanceiroLancamentosContasReceberRoute;
  ARelatorioFinanceiroPagamentosRoute: typeof ARelatorioFinanceiroPagamentosRoute;
  ARelatorioFinanceiroRelacaoBoletosRoute: typeof ARelatorioFinanceiroRelacaoBoletosRoute;
  ARelatorioFinanceiroTotaisPorCategoriaRoute: typeof ARelatorioFinanceiroTotaisPorCategoriaRoute;
  ARelatorioFinanceiroIndexRoute: typeof ARelatorioFinanceiroIndexRoute;
}

const ARelatorioFinanceiroRouteRouteChildren: ARelatorioFinanceiroRouteRouteChildren =
  {
    ARelatorioFinanceiroBalanceteRoute: ARelatorioFinanceiroBalanceteRoute,
    ARelatorioFinanceiroBoletosRecebidosRoute:
      ARelatorioFinanceiroBoletosRecebidosRoute,
    ARelatorioFinanceiroContasPagarRoute: ARelatorioFinanceiroContasPagarRoute,
    ARelatorioFinanceiroContasReceberRoute:
      ARelatorioFinanceiroContasReceberRoute,
    ARelatorioFinanceiroContasRecebidasRoute:
      ARelatorioFinanceiroContasRecebidasRoute,
    ARelatorioFinanceiroDreRoute: ARelatorioFinanceiroDreRoute,
    ARelatorioFinanceiroEntradasSaidasRoute:
      ARelatorioFinanceiroEntradasSaidasRoute,
    ARelatorioFinanceiroFluxoCaixaRoute: ARelatorioFinanceiroFluxoCaixaRoute,
    ARelatorioFinanceiroLancamentosContasReceberRoute:
      ARelatorioFinanceiroLancamentosContasReceberRoute,
    ARelatorioFinanceiroPagamentosRoute: ARelatorioFinanceiroPagamentosRoute,
    ARelatorioFinanceiroRelacaoBoletosRoute:
      ARelatorioFinanceiroRelacaoBoletosRoute,
    ARelatorioFinanceiroTotaisPorCategoriaRoute:
      ARelatorioFinanceiroTotaisPorCategoriaRoute,
    ARelatorioFinanceiroIndexRoute: ARelatorioFinanceiroIndexRoute,
  };

const ARelatorioFinanceiroRouteRouteWithChildren =
  ARelatorioFinanceiroRouteRoute._addFileChildren(
    ARelatorioFinanceiroRouteRouteChildren,
  );

interface ARelatorioFiscalRouteRouteChildren {
  ARelatorioFiscalItensNotasFiscaisRoute: typeof ARelatorioFiscalItensNotasFiscaisRoute;
  ARelatorioFiscalNotasFiscaisClienteRoute: typeof ARelatorioFiscalNotasFiscaisClienteRoute;
  ARelatorioFiscalNotasFiscaisProdutoRoute: typeof ARelatorioFiscalNotasFiscaisProdutoRoute;
  ARelatorioFiscalNotasFiscaisTipoRoute: typeof ARelatorioFiscalNotasFiscaisTipoRoute;
  ARelatorioFiscalRelacaoDocumentosRoute: typeof ARelatorioFiscalRelacaoDocumentosRoute;
  ARelatorioFiscalRelacaoSequenciasInutilizadasRoute: typeof ARelatorioFiscalRelacaoSequenciasInutilizadasRoute;
  ARelatorioFiscalTotalAgrupadoCfopRoute: typeof ARelatorioFiscalTotalAgrupadoCfopRoute;
  ARelatorioFiscalTotalAgrupadoFormaPagamentoRoute: typeof ARelatorioFiscalTotalAgrupadoFormaPagamentoRoute;
  ARelatorioFiscalTotalAgrupadoNcmRoute: typeof ARelatorioFiscalTotalAgrupadoNcmRoute;
  ARelatorioFiscalIndexRoute: typeof ARelatorioFiscalIndexRoute;
}

const ARelatorioFiscalRouteRouteChildren: ARelatorioFiscalRouteRouteChildren = {
  ARelatorioFiscalItensNotasFiscaisRoute:
    ARelatorioFiscalItensNotasFiscaisRoute,
  ARelatorioFiscalNotasFiscaisClienteRoute:
    ARelatorioFiscalNotasFiscaisClienteRoute,
  ARelatorioFiscalNotasFiscaisProdutoRoute:
    ARelatorioFiscalNotasFiscaisProdutoRoute,
  ARelatorioFiscalNotasFiscaisTipoRoute: ARelatorioFiscalNotasFiscaisTipoRoute,
  ARelatorioFiscalRelacaoDocumentosRoute:
    ARelatorioFiscalRelacaoDocumentosRoute,
  ARelatorioFiscalRelacaoSequenciasInutilizadasRoute:
    ARelatorioFiscalRelacaoSequenciasInutilizadasRoute,
  ARelatorioFiscalTotalAgrupadoCfopRoute:
    ARelatorioFiscalTotalAgrupadoCfopRoute,
  ARelatorioFiscalTotalAgrupadoFormaPagamentoRoute:
    ARelatorioFiscalTotalAgrupadoFormaPagamentoRoute,
  ARelatorioFiscalTotalAgrupadoNcmRoute: ARelatorioFiscalTotalAgrupadoNcmRoute,
  ARelatorioFiscalIndexRoute: ARelatorioFiscalIndexRoute,
};

const ARelatorioFiscalRouteRouteWithChildren =
  ARelatorioFiscalRouteRoute._addFileChildren(
    ARelatorioFiscalRouteRouteChildren,
  );

interface ARelatorioVendaRouteRouteChildren {
  ARelatorioVendaComissoesRoute: typeof ARelatorioVendaComissoesRoute;
  ARelatorioVendaProdutosMaisVendidosRoute: typeof ARelatorioVendaProdutosMaisVendidosRoute;
  ARelatorioVendaRelacaoVendasRoute: typeof ARelatorioVendaRelacaoVendasRoute;
  ARelatorioVendaRelacaoVendasProdutoRoute: typeof ARelatorioVendaRelacaoVendasProdutoRoute;
  ARelatorioVendaRelacaoVendasResumidoRoute: typeof ARelatorioVendaRelacaoVendasResumidoRoute;
  ARelatorioVendaTotalFormaPagamentoRoute: typeof ARelatorioVendaTotalFormaPagamentoRoute;
  ARelatorioVendaVendasClienteRoute: typeof ARelatorioVendaVendasClienteRoute;
  ARelatorioVendaVendasVendedorRoute: typeof ARelatorioVendaVendasVendedorRoute;
  ARelatorioVendaIndexRoute: typeof ARelatorioVendaIndexRoute;
}

const ARelatorioVendaRouteRouteChildren: ARelatorioVendaRouteRouteChildren = {
  ARelatorioVendaComissoesRoute: ARelatorioVendaComissoesRoute,
  ARelatorioVendaProdutosMaisVendidosRoute:
    ARelatorioVendaProdutosMaisVendidosRoute,
  ARelatorioVendaRelacaoVendasRoute: ARelatorioVendaRelacaoVendasRoute,
  ARelatorioVendaRelacaoVendasProdutoRoute:
    ARelatorioVendaRelacaoVendasProdutoRoute,
  ARelatorioVendaRelacaoVendasResumidoRoute:
    ARelatorioVendaRelacaoVendasResumidoRoute,
  ARelatorioVendaTotalFormaPagamentoRoute:
    ARelatorioVendaTotalFormaPagamentoRoute,
  ARelatorioVendaVendasClienteRoute: ARelatorioVendaVendasClienteRoute,
  ARelatorioVendaVendasVendedorRoute: ARelatorioVendaVendasVendedorRoute,
  ARelatorioVendaIndexRoute: ARelatorioVendaIndexRoute,
};

const ARelatorioVendaRouteRouteWithChildren =
  ARelatorioVendaRouteRoute._addFileChildren(ARelatorioVendaRouteRouteChildren);

interface ARenegociacaoContasPagarRouteRouteChildren {
  ARenegociacaoContasPagarCadastrarRoute: typeof ARenegociacaoContasPagarCadastrarRoute;
  ARenegociacaoContasPagarIndexRoute: typeof ARenegociacaoContasPagarIndexRoute;
}

const ARenegociacaoContasPagarRouteRouteChildren: ARenegociacaoContasPagarRouteRouteChildren =
  {
    ARenegociacaoContasPagarCadastrarRoute:
      ARenegociacaoContasPagarCadastrarRoute,
    ARenegociacaoContasPagarIndexRoute: ARenegociacaoContasPagarIndexRoute,
  };

const ARenegociacaoContasPagarRouteRouteWithChildren =
  ARenegociacaoContasPagarRouteRoute._addFileChildren(
    ARenegociacaoContasPagarRouteRouteChildren,
  );

interface ARenegociacaoContasReceberRouteRouteChildren {
  ARenegociacaoContasReceberCadastrarRoute: typeof ARenegociacaoContasReceberCadastrarRoute;
  ARenegociacaoContasReceberIndexRoute: typeof ARenegociacaoContasReceberIndexRoute;
}

const ARenegociacaoContasReceberRouteRouteChildren: ARenegociacaoContasReceberRouteRouteChildren =
  {
    ARenegociacaoContasReceberCadastrarRoute:
      ARenegociacaoContasReceberCadastrarRoute,
    ARenegociacaoContasReceberIndexRoute: ARenegociacaoContasReceberIndexRoute,
  };

const ARenegociacaoContasReceberRouteRouteWithChildren =
  ARenegociacaoContasReceberRouteRoute._addFileChildren(
    ARenegociacaoContasReceberRouteRouteChildren,
  );

interface ARouteRouteChildren {
  AClienteRouteRoute: typeof AClienteRouteRouteWithChildren;
  ACobrancaBoletoRouteRoute: typeof ACobrancaBoletoRouteRouteWithChildren;
  ACobrancaCartaoRouteRoute: typeof ACobrancaCartaoRouteRouteWithChildren;
  ACobrancaPixRouteRoute: typeof ACobrancaPixRouteRouteWithChildren;
  AComissaoRouteRoute: typeof AComissaoRouteRouteWithChildren;
  ACompraRouteRoute: typeof ACompraRouteRouteWithChildren;
  AContasPagarRouteRoute: typeof AContasPagarRouteRouteWithChildren;
  AContasReceberRouteRoute: typeof AContasReceberRouteRouteWithChildren;
  ACupomFiscalRouteRoute: typeof ACupomFiscalRouteRouteWithChildren;
  ADebugRouteRoute: typeof ADebugRouteRouteWithChildren;
  ADevolucaoRouteRoute: typeof ADevolucaoRouteRouteWithChildren;
  AEstoqueRouteRoute: typeof AEstoqueRouteRouteWithChildren;
  AExtratoBoletoRouteRoute: typeof AExtratoBoletoRouteRouteWithChildren;
  AExtratoPixRouteRoute: typeof AExtratoPixRouteRouteWithChildren;
  AFornecedorRouteRoute: typeof AFornecedorRouteRouteWithChildren;
  AManifestoCargaRouteRoute: typeof AManifestoCargaRouteRouteWithChildren;
  AMovimentacoesRouteRoute: typeof AMovimentacoesRouteRouteWithChildren;
  ANfseRouteRoute: typeof ANfseRouteRouteWithChildren;
  ANotaFiscalRouteRoute: typeof ANotaFiscalRouteRouteWithChildren;
  ANotificacaoRouteRoute: typeof ANotificacaoRouteRouteWithChildren;
  APagforRouteRoute: typeof APagforRouteRouteWithChildren;
  AProdutoRouteRoute: typeof AProdutoRouteRouteWithChildren;
  ARegraFiscalRouteRoute: typeof ARegraFiscalRouteRouteWithChildren;
  ARomaneioRouteRoute: typeof ARomaneioRouteRouteWithChildren;
  ASecundarioRouteRoute: typeof ASecundarioRouteRouteWithChildren;
  AServicoRouteRoute: typeof AServicoRouteRouteWithChildren;
  ASpedFiscalRouteRoute: typeof ASpedFiscalRouteRouteWithChildren;
  ATransportadorRouteRoute: typeof ATransportadorRouteRouteWithChildren;
  AVendaRouteRoute: typeof AVendaRouteRouteWithChildren;
  AVendaExternaRouteRoute: typeof AVendaExternaRouteRouteWithChildren;
  APdvRoute: typeof APdvRoute;
  AConfiguracaoEmpresaRouteRoute: typeof AConfiguracaoEmpresaRouteRouteWithChildren;
  ARelatorioCadastroRouteRoute: typeof ARelatorioCadastroRouteRouteWithChildren;
  ARelatorioCompraRouteRoute: typeof ARelatorioCompraRouteRouteWithChildren;
  ARelatorioEstoqueRouteRoute: typeof ARelatorioEstoqueRouteRouteWithChildren;
  ARelatorioFinanceiroRouteRoute: typeof ARelatorioFinanceiroRouteRouteWithChildren;
  ARelatorioFiscalRouteRoute: typeof ARelatorioFiscalRouteRouteWithChildren;
  ARelatorioVendaRouteRoute: typeof ARelatorioVendaRouteRouteWithChildren;
  ARenegociacaoContasPagarRouteRoute: typeof ARenegociacaoContasPagarRouteRouteWithChildren;
  ARenegociacaoContasReceberRouteRoute: typeof ARenegociacaoContasReceberRouteRouteWithChildren;
  AConfiguracaoUsuarioRoute: typeof AConfiguracaoUsuarioRoute;
  AImpressaoFiletypeRoute: typeof AImpressaoFiletypeRoute;
  APersonalizacoesComandosRoute: typeof APersonalizacoesComandosRoute;
  APersonalizacoesConsultasRoute: typeof APersonalizacoesConsultasRoute;
  ASeparacaoMonitorRoute: typeof ASeparacaoMonitorRoute;
  ASuporteInstrucoesDeUsoRoute: typeof ASuporteInstrucoesDeUsoRoute;
  AContratoIndexRoute: typeof AContratoIndexRoute;
  AInventarioIndexRoute: typeof AInventarioIndexRoute;
  APainelGerencialIndexRoute: typeof APainelGerencialIndexRoute;
  ASeparacaoIndexRoute: typeof ASeparacaoIndexRoute;
  ASuporteIndexRoute: typeof ASuporteIndexRoute;
  AContratoActionChar123IdpkChar125Route: typeof AContratoActionChar123IdpkChar125Route;
  AImportacaoTipoChar123IdpkChar125Route: typeof AImportacaoTipoChar123IdpkChar125Route;
  AImportacaoXmlTipoRoute: typeof AImportacaoXmlTipoRoute;
  AInventarioActionChar123IdpkChar125Route: typeof AInventarioActionChar123IdpkChar125Route;
  ASeparacaoTypeIdpkRoute: typeof ASeparacaoTypeIdpkRoute;
}

const ARouteRouteChildren: ARouteRouteChildren = {
  AClienteRouteRoute: AClienteRouteRouteWithChildren,
  ACobrancaBoletoRouteRoute: ACobrancaBoletoRouteRouteWithChildren,
  ACobrancaCartaoRouteRoute: ACobrancaCartaoRouteRouteWithChildren,
  ACobrancaPixRouteRoute: ACobrancaPixRouteRouteWithChildren,
  AComissaoRouteRoute: AComissaoRouteRouteWithChildren,
  ACompraRouteRoute: ACompraRouteRouteWithChildren,
  AContasPagarRouteRoute: AContasPagarRouteRouteWithChildren,
  AContasReceberRouteRoute: AContasReceberRouteRouteWithChildren,
  ACupomFiscalRouteRoute: ACupomFiscalRouteRouteWithChildren,
  ADebugRouteRoute: ADebugRouteRouteWithChildren,
  ADevolucaoRouteRoute: ADevolucaoRouteRouteWithChildren,
  AEstoqueRouteRoute: AEstoqueRouteRouteWithChildren,
  AExtratoBoletoRouteRoute: AExtratoBoletoRouteRouteWithChildren,
  AExtratoPixRouteRoute: AExtratoPixRouteRouteWithChildren,
  AFornecedorRouteRoute: AFornecedorRouteRouteWithChildren,
  AManifestoCargaRouteRoute: AManifestoCargaRouteRouteWithChildren,
  AMovimentacoesRouteRoute: AMovimentacoesRouteRouteWithChildren,
  ANfseRouteRoute: ANfseRouteRouteWithChildren,
  ANotaFiscalRouteRoute: ANotaFiscalRouteRouteWithChildren,
  ANotificacaoRouteRoute: ANotificacaoRouteRouteWithChildren,
  APagforRouteRoute: APagforRouteRouteWithChildren,
  AProdutoRouteRoute: AProdutoRouteRouteWithChildren,
  ARegraFiscalRouteRoute: ARegraFiscalRouteRouteWithChildren,
  ARomaneioRouteRoute: ARomaneioRouteRouteWithChildren,
  ASecundarioRouteRoute: ASecundarioRouteRouteWithChildren,
  AServicoRouteRoute: AServicoRouteRouteWithChildren,
  ASpedFiscalRouteRoute: ASpedFiscalRouteRouteWithChildren,
  ATransportadorRouteRoute: ATransportadorRouteRouteWithChildren,
  AVendaRouteRoute: AVendaRouteRouteWithChildren,
  AVendaExternaRouteRoute: AVendaExternaRouteRouteWithChildren,
  APdvRoute: APdvRoute,
  AConfiguracaoEmpresaRouteRoute: AConfiguracaoEmpresaRouteRouteWithChildren,
  ARelatorioCadastroRouteRoute: ARelatorioCadastroRouteRouteWithChildren,
  ARelatorioCompraRouteRoute: ARelatorioCompraRouteRouteWithChildren,
  ARelatorioEstoqueRouteRoute: ARelatorioEstoqueRouteRouteWithChildren,
  ARelatorioFinanceiroRouteRoute: ARelatorioFinanceiroRouteRouteWithChildren,
  ARelatorioFiscalRouteRoute: ARelatorioFiscalRouteRouteWithChildren,
  ARelatorioVendaRouteRoute: ARelatorioVendaRouteRouteWithChildren,
  ARenegociacaoContasPagarRouteRoute:
    ARenegociacaoContasPagarRouteRouteWithChildren,
  ARenegociacaoContasReceberRouteRoute:
    ARenegociacaoContasReceberRouteRouteWithChildren,
  AConfiguracaoUsuarioRoute: AConfiguracaoUsuarioRoute,
  AImpressaoFiletypeRoute: AImpressaoFiletypeRoute,
  APersonalizacoesComandosRoute: APersonalizacoesComandosRoute,
  APersonalizacoesConsultasRoute: APersonalizacoesConsultasRoute,
  ASeparacaoMonitorRoute: ASeparacaoMonitorRoute,
  ASuporteInstrucoesDeUsoRoute: ASuporteInstrucoesDeUsoRoute,
  AContratoIndexRoute: AContratoIndexRoute,
  AInventarioIndexRoute: AInventarioIndexRoute,
  APainelGerencialIndexRoute: APainelGerencialIndexRoute,
  ASeparacaoIndexRoute: ASeparacaoIndexRoute,
  ASuporteIndexRoute: ASuporteIndexRoute,
  AContratoActionChar123IdpkChar125Route:
    AContratoActionChar123IdpkChar125Route,
  AImportacaoTipoChar123IdpkChar125Route:
    AImportacaoTipoChar123IdpkChar125Route,
  AImportacaoXmlTipoRoute: AImportacaoXmlTipoRoute,
  AInventarioActionChar123IdpkChar125Route:
    AInventarioActionChar123IdpkChar125Route,
  ASeparacaoTypeIdpkRoute: ASeparacaoTypeIdpkRoute,
};

const ARouteRouteWithChildren =
  ARouteRoute._addFileChildren(ARouteRouteChildren);

interface AdminARouteRouteChildren {
  AdminAEmpresaRoute: typeof AdminAEmpresaRoute;
  AdminAErroRoute: typeof AdminAErroRoute;
  AdminARepresentanteRoute: typeof AdminARepresentanteRoute;
  AdminASqlRoute: typeof AdminASqlRoute;
  AdminASqlEditorRoute: typeof AdminASqlEditorRoute;
  AdminAConfiguracaoRepresentanteRoute: typeof AdminAConfiguracaoRepresentanteRoute;
  AdminAEmpresaActionChar123IdpkChar125Route: typeof AdminAEmpresaActionChar123IdpkChar125Route;
}

const AdminARouteRouteChildren: AdminARouteRouteChildren = {
  AdminAEmpresaRoute: AdminAEmpresaRoute,
  AdminAErroRoute: AdminAErroRoute,
  AdminARepresentanteRoute: AdminARepresentanteRoute,
  AdminASqlRoute: AdminASqlRoute,
  AdminASqlEditorRoute: AdminASqlEditorRoute,
  AdminAConfiguracaoRepresentanteRoute: AdminAConfiguracaoRepresentanteRoute,
  AdminAEmpresaActionChar123IdpkChar125Route:
    AdminAEmpresaActionChar123IdpkChar125Route,
};

const AdminARouteRouteWithChildren = AdminARouteRoute._addFileChildren(
  AdminARouteRouteChildren,
);

interface AdminAuthRouteChildren {
  AdminAuthLoginRoute: typeof AdminAuthLoginRoute;
}

const AdminAuthRouteChildren: AdminAuthRouteChildren = {
  AdminAuthLoginRoute: AdminAuthLoginRoute,
};

const AdminAuthRouteWithChildren = AdminAuthRoute._addFileChildren(
  AdminAuthRouteChildren,
);

interface AdminRouteRouteChildren {
  AdminARouteRoute: typeof AdminARouteRouteWithChildren;
  AdminAuthRoute: typeof AdminAuthRouteWithChildren;
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminARouteRoute: AdminARouteRouteWithChildren,
  AdminAuthRoute: AdminAuthRouteWithChildren,
};

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
);

interface AuthRouteRouteChildren {
  AuthAcessoNegadoRoute: typeof AuthAcessoNegadoRoute;
  AuthCadastroRoute: typeof AuthCadastroRoute;
  AuthCadastroFimRoute: typeof AuthCadastroFimRoute;
  AuthContaBloqueadaRoute: typeof AuthContaBloqueadaRoute;
  AuthLoginRoute: typeof AuthLoginRoute;
  AuthLoginAdmRoute: typeof AuthLoginAdmRoute;
  AuthLoginAutomaticoRoute: typeof AuthLoginAutomaticoRoute;
  AuthRecuperarSenhaRoute: typeof AuthRecuperarSenhaRoute;
  AuthRedefinirSenhaRoute: typeof AuthRedefinirSenhaRoute;
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAcessoNegadoRoute: AuthAcessoNegadoRoute,
  AuthCadastroRoute: AuthCadastroRoute,
  AuthCadastroFimRoute: AuthCadastroFimRoute,
  AuthContaBloqueadaRoute: AuthContaBloqueadaRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLoginAdmRoute: AuthLoginAdmRoute,
  AuthLoginAutomaticoRoute: AuthLoginAutomaticoRoute,
  AuthRecuperarSenhaRoute: AuthRecuperarSenhaRoute,
  AuthRedefinirSenhaRoute: AuthRedefinirSenhaRoute,
};

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
);

interface PCatalogoSlugDefaultUsuarioRouteRouteChildren {
  PCatalogoSlugDefaultUsuarioPerfilRoute: typeof PCatalogoSlugDefaultUsuarioPerfilRoute;
}

const PCatalogoSlugDefaultUsuarioRouteRouteChildren: PCatalogoSlugDefaultUsuarioRouteRouteChildren =
  {
    PCatalogoSlugDefaultUsuarioPerfilRoute:
      PCatalogoSlugDefaultUsuarioPerfilRoute,
  };

const PCatalogoSlugDefaultUsuarioRouteRouteWithChildren =
  PCatalogoSlugDefaultUsuarioRouteRoute._addFileChildren(
    PCatalogoSlugDefaultUsuarioRouteRouteChildren,
  );

interface PCatalogoSlugDefaultRouteRouteChildren {
  PCatalogoSlugDefaultUsuarioRouteRoute: typeof PCatalogoSlugDefaultUsuarioRouteRouteWithChildren;
  PCatalogoSlugDefaultFinalizarRoute: typeof PCatalogoSlugDefaultFinalizarRoute;
  PCatalogoSlugDefaultProdutosRoute: typeof PCatalogoSlugDefaultProdutosRoute;
}

const PCatalogoSlugDefaultRouteRouteChildren: PCatalogoSlugDefaultRouteRouteChildren =
  {
    PCatalogoSlugDefaultUsuarioRouteRoute:
      PCatalogoSlugDefaultUsuarioRouteRouteWithChildren,
    PCatalogoSlugDefaultFinalizarRoute: PCatalogoSlugDefaultFinalizarRoute,
    PCatalogoSlugDefaultProdutosRoute: PCatalogoSlugDefaultProdutosRoute,
  };

const PCatalogoSlugDefaultRouteRouteWithChildren =
  PCatalogoSlugDefaultRouteRoute._addFileChildren(
    PCatalogoSlugDefaultRouteRouteChildren,
  );

interface PCatalogoSlugAuthRouteRouteChildren {
  PCatalogoSlugAuthCadastrarRoute: typeof PCatalogoSlugAuthCadastrarRoute;
  PCatalogoSlugAuthEntrarRoute: typeof PCatalogoSlugAuthEntrarRoute;
  PCatalogoSlugAuthRecuperarSenhaRoute: typeof PCatalogoSlugAuthRecuperarSenhaRoute;
  PCatalogoSlugAuthValidarCodigoRoute: typeof PCatalogoSlugAuthValidarCodigoRoute;
}

const PCatalogoSlugAuthRouteRouteChildren: PCatalogoSlugAuthRouteRouteChildren =
  {
    PCatalogoSlugAuthCadastrarRoute: PCatalogoSlugAuthCadastrarRoute,
    PCatalogoSlugAuthEntrarRoute: PCatalogoSlugAuthEntrarRoute,
    PCatalogoSlugAuthRecuperarSenhaRoute: PCatalogoSlugAuthRecuperarSenhaRoute,
    PCatalogoSlugAuthValidarCodigoRoute: PCatalogoSlugAuthValidarCodigoRoute,
  };

const PCatalogoSlugAuthRouteRouteWithChildren =
  PCatalogoSlugAuthRouteRoute._addFileChildren(
    PCatalogoSlugAuthRouteRouteChildren,
  );

interface PCatalogoSlugRouteRouteChildren {
  PCatalogoSlugDefaultRouteRoute: typeof PCatalogoSlugDefaultRouteRouteWithChildren;
  PCatalogoSlugAuthRouteRoute: typeof PCatalogoSlugAuthRouteRouteWithChildren;
  PCatalogoSlugIndexRoute: typeof PCatalogoSlugIndexRoute;
}

const PCatalogoSlugRouteRouteChildren: PCatalogoSlugRouteRouteChildren = {
  PCatalogoSlugDefaultRouteRoute: PCatalogoSlugDefaultRouteRouteWithChildren,
  PCatalogoSlugAuthRouteRoute: PCatalogoSlugAuthRouteRouteWithChildren,
  PCatalogoSlugIndexRoute: PCatalogoSlugIndexRoute,
};

const PCatalogoSlugRouteRouteWithChildren =
  PCatalogoSlugRouteRoute._addFileChildren(PCatalogoSlugRouteRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ARouteRoute: ARouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PErroRoute: PErroRoute,
  PCatalogoSlugRouteRoute: PCatalogoSlugRouteRouteWithChildren,
  PClienteSlugRoute: PClienteSlugRoute,
  PCompartilhamentoIdRoute: PCompartilhamentoIdRoute,
  PContratoIdRoute: PContratoIdRoute,
  PImpressaoFiletypeRoute: PImpressaoFiletypeRoute,
  PContaDigitalTermosDeUsoBase64Route: PContaDigitalTermosDeUsoBase64Route,
  PPagamentoIdIndexRoute: PPagamentoIdIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
